import React, { useEffect, useState } from 'react';
import { startLoader, stopLoader, useAsyncState } from '../../../lib/utils';
import { assignDaysPlanner, assignNutritionPlanner, assignPlanner, getAllNutritionPlanner, getAllWorkoutPlanners, getNutritionPlannerCount, getWorkoutPlannerCount } from '../helper/api';
import { isAuthenticated } from '../../../auth/index';
import { getMemberCount, getAllMembers } from '../../member/helper/api';
import FlatPicker from 'flatpickr';
import { formatDateTime } from '../../../lib/utils'
import _, { isEmpty } from 'lodash';
import { getAllParameters } from '../../parameters/helper/api';
// import config from '../../../config';
import client from '../../../clients';
import { getAllGym, getGymCount } from '../../company/helper/api';
import { getAllBranches, getBranchCount } from '../../gyms/helper/api';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getContentsCount, getAllContents } from '../../content/helper/api';
import Toast from '../../../lib/toast';

let flatpickr;

const ExecutePlanner = (props) => {
  const location = useLocation();
  const [PlannerType, setPlannerType] = useState("Workout")
  const path = location.pathname;
  const [isMemberViewOpen, setMemberViewOpen] = useState(false);
  const [Gyms, setGyms] = useState([]);
  const [Branches, setBranches] = useAsyncState([])
  const [isGymSpinnerLoader, setGymSpinnerLoader] = useState(false);
  const [isBrachSpinnerLoader, setBranchSpinnerLoader] = useState(false);
  const [isMultipleMember, setMultipleMember] = useState(false);
  const [isFilterPlannerOpen, setFilterPlannerOpen] = useState(false);
  const [isDataChangedTriggered, setDataChangedTriggered] = useState(false);
  const [isFilterMemberOpen, setFilterMemberOpen] = useState(false);
  const [isCurrentMemberFilterOption, setCurrentMemberFilterOption] = useState('home');
  const [Planners, setPlanners] = useState([]);
  const [sortByLevelID, setSortByLevelID] = useState('');
  var [pageNo, setPageNo] = useState({
    branch: 1,
    gym: 1,
    planner: 1,
    member: 1,
    content:1
  });
  var [pageCount, setPageCount] = useState({
    branch: 1,
    gym: 1,
    planner: 1,
    member: 1,
    content:1
  })
  const [Total, setTotal] = useState({
    branch: 1,
    gym: 1,
    planner: 1,
    member: 1,
    content:1
  })
  const pageSize={
    branch: 20,
    gym: 20,
    planner: 20,
    member: 20,
    content:20
  };
  const [searchPlannerKey, setSearchPlannerKey] = useState("");
  const { user, token } = isAuthenticated()
  const [selectedGym, setSelectedGym] = useState('');
  const [selectedBranchIds, setSelectedBranchIds] = useState([]);
  const [memberSearchKey, setMemberSearchKey] = useState('')
  const [Members, setMembers] = useAsyncState([]);
  const [plannerTimeStampSelection, setPlannerTimeStampSelection] = useState(false);
  const [workoutPlannerExeccuteData, setWorkoutPlannerExecuteData] = useState({
    workoutPlanner: {},
    startDate: "",
    duration: "",
    members: []
  });
  const [tempIDs, setTempIDs] = useState([])
  const [currentElementId, setCurrentElementId] = useState("");
  const [plannerLoaderView, setPlannerLoaderView] = useState(false);
  const [memberLoaderView, setMemberLoaderView] = useState(false);
  const [Parameters, setParameters] = useState({
    exerciseLevel: [],
    targetMuscle: [],
    exerciseType: []
  });
  const [isReload,setReload] = useState(false);
  const [sortByPlannerRole, setSortByPlannerRole] = useState("");
  const [sortByPlannerFrequency, setSortPlannerByFrequency] = useState(3);
  const [gymSearchKey, setGymSearchKey] = useState('');
  const [branchSearchKey, setBranchSearchKey] = useState('');
  var [prevCurrentMemberFilter, setPrevCurrentMemberFilter] = useState("planner");
  const [isPlannerSelectWindow, setPlannerSelectWindow] = useState(-1);
  const [tempObjects, setTempObjects] = useState([]);
  const [isButtonLock, setButtonLock] = useState(true);
  const [isCurrentWeekFrequency, setCurrentWeekFrequency] = useState(6);
  const [isDayFormat, setDayFormat] = useState("M W F");
  const [isSelectedPlannerIndex, setSelectedPlannerIndex] =  useState(-1);
  const [sortByAccessRight,setSortByAccessRight]=useState('all');
  const [weekdayExerciseTypeOpenDropdown, setWeekdayExerciseTypeOpenDropdown] = useState(false);
  const [exerciseWeightUnitTypeDropdownOpen, setExerciseWeightUnitTypeDropdownOpen] = useState(false);
  const [exerciseDistanceUnitTypeDropdownOpen, setExerciseDistanceUnitTypeDropdownOpen] = useState(false);
  const [isExerciseDetailsViewOpen, setExerciseDetailsViewOpen] = useState(false);
  const [isVideoPlayerOpen, setVideoPlayerOpen] = useState(false);
  const [isContentFilter, setContentFilter] = useState('');
  const [sortExerciseTypeIDs, setSortExerciseTypeIDs] = useState([]);
  const [sortExerciseLevelIDs, setSortExerciseLevelIDs] = useState([]);
  const [sortTargetMuscleIDs, setTargetMuscleIDs] = useState([])
  var [prevContentFilterOpen, setPrevContentFilterOpen] = useState('');
  const [displayContent, setDisplayContent] = useState('');
  const [workoutPlanner, setWorkoutPlanner] = useState({
    isNutritionPlanner:false,
    isOneDayPlanner:false,
    isDayPlanner:false,
    workoutPlannerId: "",
    accessRight:'private',
    exerciseLevelIDs: [],
    name: "",
    warmup: [{
      content: {
        name: "",
        contentId: "",
        isSelected: false
      },
      optionalExercises: []
    }],
    cooldown: [{
      content: {
        name: "",
        contentId: "",
        isSelected: false
      },
      optionalExercises: []
    }],
    days: [{
      name: "",
      isSelected: false,
      displayName:"",
      exercises: []
    }],
    weekdays: [{
      name: "",
      isSelected: false,
      displayName:"",
      exercises: []
    }]
  })
  const [isAccessRightDropdown,setAccessRightDropdown]=useState(false);
  const exerciseTemplate = {
    content: {},
    optionalExercises: [],
    parameter: {
      id: "",
      set: [{
        reps: "15",
        weight:{
          value:"",
          unit:"Kg"
        }
      }],
      distance: {
        value: "",
        unit: ""
      },
      count: "",
      duration: {
        hour: "",
        min: ""
      }
    }
  }
  const [exerciseNames, setExerciseNames] = useState([]);
  const [exerciseTypes, setExerciseTypes] = useState([])
  const [targetMuscles, setTargetMuscles] = useState([])
  const [exerciseLevels, setExerciseLevels] = useState([])
  const accessRights=['private','public'];
  const [Contents, setContents] = useAsyncState([]);
  const [selectedSet, setSelectedSet] = useState(0);
  const [exerciseDetails, setExerciseDetails] = useState({
    id: "",
    set: [
      {
        reps: "15",
        weight:{
          value:"",
          unit:"Kg"
        }
      }
    ],
    distance: {
      value: "",
      unit: ""
    },
    count: "",
    duration: {
      hour: "",
      min: ""
    }
  })
  const [contentSearchKey, setContentSearchKey] = useState('');
  var [sortByContentType, setSortByContentType] = useState("");
  const [contentApiAction, setContentApiAction] = useState(false);
  const [isContentLoader, setContentLoader] = useState(false);
  const [selectedWeekDay, setSelectedWeekDay] = useState(1);
  const [selectedExerciseIndex, setSelectedExerciseIndex] = useState(-1);
  const [selectedOptionalExerciseIndex, setSelectedOptionalExerciseIndex] = useState(-1);
  const [selectedContent, setSelectedContent] = useState("");
  const [ContentRole, setContentRole] = useState('All');
  var [isSearchBranch, setSearchBranch] = useState(false);
  const [branchIDs, setBranchIDs] = useState([]);
  const [weekDayFrequency, setWeekdayFrequency] = useState(3);
  const [isEditActive,setEditActive] = useState(false);
  const [copyFrom, setCopyFrom] = useState("");
  const [copyTo, setCopyTo] = useState([{
    day: "Monday",
    isSelected: false
  },{
    day: "Tuesday",
    isSelected: false
  },{
    day: "Wednesday",
    isSelected: false
  },{
    day: "Thursday",
    isSelected: false
  },{
    day: "Friday",
    isSelected: false
  },{
    day: "Saturday",
    isSelected: false
  }]);
  const [dayWorkoutStorage, setDayWorkoutStorage] = useState({
    workoutDays: [
      {
        name: "Mon",
        isSelected: false, 
      },
      {
        name: "Tue",
        isSelected: false
      },
      {
        name: "Wed",
        isSelected: false
      },
      {
        name: "Thu",
        isSelected: false
      },
      {
        name: "Fri",
        isSelected: false
      },
      {
        name: "Sat",
        isSelected: false
      }
    ],
    name: "",
    displayName:"",
    exercises: []
  })
  const [isSetIndexDeleteEnabled, setIndexDeleteEnabled] = useState("-1");


  const clearExerciseLevels = () => {
    setSortExerciseLevelIDs([]);
  }


  const handleContentSearchKey = async event => {
    await setContents([]);
    setContentSearchKey(event.target.value);
  }

  const handleSelectAccessRight=data=>{
    setWorkoutPlanner({
      ...workoutPlanner,
      accessRight:data
    });
  }


  const getContentParams = () => {

		let params = {
			pageNo: pageNo.content,
			pageSize: pageSize.content,
		};



    return params;


    // let params = {
    //   pageNo: pageNo.content,
    //   pageSize: pageSize.content
    // };
    // params.activationStatus = "activate";
    // if (contentSearchKey) params.q = contentSearchKey;
    // if (sortExerciseLevelIDs.length) params.exerciseLevelIDs = sortExerciseLevelIDs;
    // if (sortExerciseTypeIDs.length) params.exerciseTypeIDs = sortExerciseTypeIDs;
    // if (sortTargetMuscleIDs.length) params.targetMuscleIDs = sortTargetMuscleIDs;
    // if (ContentRole != "All") params.contentRole = ContentRole;
    // params.contentType = sortByContentType;
    // params.accessRight=sortByAccessRight;
    // return params;
  }

  const GetContentCount = async () => {
    try {
      let params = getContentParams();
      delete params.pageNo;
      delete params.pageSize;
      let response = await getContentsCount(user._id, token, params);
      if (response.error) {
        // do something
      } else {
        pageNo.content = 1;
        pageCount.content =  Math.ceil(response.COUNT / pageSize.content);
        setPageNo({
          ...pageNo
        })
        setPageCount({
          ...pageCount
        })
        setTotal({
          ...Total,
          content: response.COUNT
        })
      }
    } catch (error) {
      // do something
    }
  }

  const GetAllContents = async (isReload) => {
    try {
      let params = getContentParams();
      let response = await getAllContents(user._id, token, params);
      console.log(response);
      if (response.error) {
        // do something
      } else {
        if(isReload) await setContents(response); 
        else await setContents([...Contents, ...response]);
      }
    } catch (error) {
      // do something
    }
  }


  useEffect(async () => {
    try {
      if (isCurrentMemberFilterOption == "add-exercise") {
        setContentLoader(true);
        await GetContentCount();
        await GetAllContents(true);
        setContentLoader(false);
      }
    } catch (error) {
      // do something
      setContentLoader(false);
    }
  }, [contentApiAction, sortByAccessRight, contentSearchKey, sortExerciseTypeIDs, sortExerciseLevelIDs, sortTargetMuscleIDs, ContentRole, selectedGym, branchIDs])

  const handleSelectedExerciseLevelIDs = id => event => {
    let list = [...workoutPlanner.exerciseLevelIDs];
    let index = list.indexOf(id)
    if (index == -1) {
      list.push(id);
    } else {
      list.splice(index, 1)
    }
    setWorkoutPlanner({
      ...workoutPlanner,
      exerciseLevelIDs: list
    })
  }


  const handleAddOptionalExerise = (currentIndex, event) => {
    setWorkoutPlanner(oldstate => {
      if (isCurrentMemberFilterOption == "cool-down") {
        oldstate.cooldown[selectedExerciseIndex].optionalExercises.push({})
      } else if (isCurrentMemberFilterOption == "warm-up") {
        oldstate.warmup[selectedExerciseIndex].optionalExercises.push({})
      } else if (isCurrentMemberFilterOption == "weekdays-exercise") {
        oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises.push({
          content: {},
          parameter: {}
        })
      }
      return ({
        ...oldstate
      })
    })

    setTimeout(() => {
      handleExerciseContentWindow(currentIndex, {})
    }, 10);

  }

  const handleAddExercise = (index = -1) => {
    switch (isCurrentMemberFilterOption) {
      case "weekdays-exercise":
        setWorkoutPlanner(oldstate => {
          let exerciseTemplateCopy = {
            ...exerciseTemplate
          }
          exerciseTemplateCopy.content = {}
          oldstate.weekdays[selectedWeekDay].exercises.push(exerciseTemplateCopy);
          return { ...oldstate }
        })
        break;
      case "cool-down":
        setWorkoutPlanner(oldstate => {
          let exerciseTemplateCopy = {
            ...exerciseTemplate
          }
          delete exerciseTemplateCopy.parameter;
          exerciseTemplateCopy.content = {}

          oldstate.cooldown.push(exerciseTemplateCopy);
          return ({
            ...oldstate
          })
        })
        break;
      case "warm-up":
        setWorkoutPlanner(oldstate => {
          let exerciseTemplateCopy = {
            ...exerciseTemplate
          }
          delete exerciseTemplateCopy.parameter;
          exerciseTemplateCopy.content = {}
          oldstate.warmup.push(exerciseTemplateCopy);
          return(
            {...oldstate}
          )
        })
        break;
      default:
      // do something 
    }

  }

  const confirmTempSelectionIDs = event => {
    switch (isContentFilter) {
      case "exercise-type":
        setSortExerciseTypeIDs(tempIDs)
        break;
      case "exercise-level":
        setSortExerciseLevelIDs(tempIDs)
        break;
      case "muscle-type":
        setTargetMuscleIDs(tempIDs);
        break;
      case "branch":
        setBranchIDs(tempIDs);
        break;
      default:
      // do somethig 

    }

    toggleContentFilter(isContentFilter)
  }


  const handleSetAction = (type, index) => {
    if(type == "delete"){
      if(exerciseDetails.set.length>1){
        let newSelectedSet=selectedSet-1;
        setSelectedSet(newSelectedSet);
      } 
      setExerciseDetails(oldData => {
        oldData.set.splice(index, 1)
        return{
          ...oldData
        }
      })
    }else{
      setExerciseDetails(oldData => {
        oldData.set.push({
          reps:"15",
          weight:{
            value:"",
            unit:""
          }
        })
        return{
          ...oldData
        }
      })
    }
  }

  const handleSetReps = event => {
    setExerciseDetails(oldState => {
      oldState.set[selectedSet].reps = event.target.value
      return{
        ...oldState
      }
    })
  }

  const handleChangeExerciseDetails = name => event => {
    setExerciseDetails(oldstate => {
      let listNames = `${name}`.split('.');
      if (listNames.length > 1) {
        if(listNames[0] == 'weight') oldstate.set[selectedSet][listNames[0]][listNames[1]]= event.target.value;
        else oldstate[listNames[0]][listNames[1]]= event.target.value;
      } else {
        oldstate[name] = event.target.value;
      }
      return {
        ...oldstate
      }
    })
  }



  const getSelectedWeightUnit = (selectedUnit) => {
    setExerciseWeightUnitTypeDropdownOpen(false)
    setExerciseDetails(prev=>{
      prev.set[selectedSet]['weight']['unit']=selectedUnit;
      return {
        ...prev
      };
    });
  }

  const addDayExerciseContent = event => {
    event.preventDefault();
    setDayWorkoutStorage(oldstate => {
      if (selectedOptionalExerciseIndex > -1) {
        oldstate.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content = {
          ...selectedContent
        };
      } else {
        oldstate.exercises[selectedExerciseIndex].content = {
          ...selectedContent
        }
      }

      let exerciseDetailValues = {};

      if (selectedContent.exerciseUnit == "weight") {
        if (exerciseDetails.set.length > 0) {
          exerciseDetailValues = {
            set: exerciseDetails.set,
            isParameterAdded: true
          }
        }
      } else if (selectedContent.exerciseUnit == "time") {
        if (exerciseDetails.duration.hour > 0 || exerciseDetails.duration.min > 0) {
          exerciseDetailValues = {
            duration: { ...exerciseDetails.duration },
            isParameterAdded: true
          }
        }
      } else if (selectedContent.exerciseUnit == "distance") {
        if (exerciseDetails.distance.value > 0 && exerciseDetails.distance.unit) {
          exerciseDetailValues = {
            distance: { ...exerciseDetails.distance },
            isParameterAdded: true
          }
        }
      } else if (selectedContent.exerciseUnit == "number") {
        if (exerciseDetails.count > 0) {
          exerciseDetailValues = {
            count: exerciseDetails.count,
            isParameterAdded: true
          }
        }
      }

      if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex == -1) {
        oldstate.exercises[selectedExerciseIndex].parameter = {
          ...exerciseDetailValues,
          unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
        }
      }
      if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex > -1) {
        oldstate.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter = {
          ...exerciseDetailValues,
          unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
        }
      }

      return ({
        ...oldstate
      })
    })
    setSelectedContent("");
    toggleBackToPrevWindow();
    event.stopPropagation()
  }


  const addExerciseContent = event => {
    event.preventDefault()
    setWorkoutPlanner(oldstate => {
      if (sortByContentType == "cooldown") {
        console.log(selectedOptionalExerciseIndex);
        if (selectedOptionalExerciseIndex > -1) {
          oldstate.cooldown[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex] = {
            ...selectedContent
          }
        } else {
          oldstate.cooldown[selectedExerciseIndex].content = {
            ...selectedContent
          }
        }
      } else if (sortByContentType == "warmup") {
        if (selectedOptionalExerciseIndex > -1) {
          oldstate.warmup[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex] = {
            ...selectedContent
          }
        } else {
          oldstate.warmup[selectedExerciseIndex].content = {
            ...selectedContent
          }
        }
      } else if (sortByContentType == "mainexercise") {
        if (selectedOptionalExerciseIndex > -1) {
          oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content = {
            ...selectedContent
          };
        } else {
          oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].content = {
            ...selectedContent
          }
        }

        let exerciseDetailValues = {};

        if (selectedContent.exerciseUnit == "weight") {
          if (exerciseDetails.weight.value > 0 && exerciseDetails.set.length > 0 && exerciseDetails.weight.unit) {
            exerciseDetailValues = {
              weight: { ...exerciseDetails.weight },
              set: { ...exerciseDetails.set },
              isParameterAdded: true
            }
          }
        } else if (selectedContent.exerciseUnit == "time") {
          if (exerciseDetails.duration.hour > 0 || exerciseDetails.duration.min > 0) {
            exerciseDetailValues = {
              duration: { ...exerciseDetails.duration },
              isParameterAdded: true
            }
          }
        } else if (selectedContent.exerciseUnit == "distance") {
          if (exerciseDetails.distance.value > 0 && exerciseDetails.distance.unit) {
            exerciseDetailValues = {
              distance: { ...exerciseDetails.distance },
              isParameterAdded: true
            }
          }
        } else if (selectedContent.exerciseUnit == "number") {
          if (exerciseDetails.count > 0) {
            exerciseDetailValues = {
              count: exerciseDetails.count,
              isParameterAdded: true
            }
          }
        }

        if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex == -1) {
          oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].parameter = {
            ...exerciseDetailValues,
            unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
          }
        }
        if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex > -1) {
          oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter = {
            ...exerciseDetailValues,
            unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
          }
        }
        
      }
      return ({
        ...oldstate
      })
    });
    setSelectedContent("");
    toggleBackToPrevWindow();
    event.stopPropagation()
  }

  const handleSelectContent = content => event => {
    setSelectedContent(content);
  }

  const handleScroll = async event => {
    const contentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollPosition = window.scrollY;


    if (contentHeight - windowHeight - scrollPosition < 100 && pageNo.content < pageCount.content) {
        pageNo.content = pageNo.content + 1;
        setPageNo(pageNo)
        setContentLoader(true)
        await GetAllContents();
        setContentLoader(false)
    }
}

  const clearTargetMuscles = () => {
    setTargetMuscleIDs([]);
  }

  const handleAccessRight = accessRight =>{
    setSortByAccessRight(accessRight);
  }

  const handlePlannerType = plannerType => {
    setPlannerType(plannerType)
  }

  const clearExerciseTypes = () => {
    setSortExerciseTypeIDs([])
  }


  const handleContentRole = (contentRole) => {
    if (contentRole == "branch" && ContentRole == "gym" && selectedGym) {
      isSearchBranch = true;
      setSearchBranch(isSearchBranch);
      setBranches([])
    }
    setContentRole(contentRole);
  }

  const getSelectedDistanceUnit = (selectedUnit) => {
    setExerciseDistanceUnitTypeDropdownOpen(false);
    setExerciseDetails({
      ...exerciseDetails,
      distance: {
        ...exerciseDetails.distance,
        unit: selectedUnit
      }
    })
  }

  const toggleContentFilter = (filterType) => {
    if (isContentFilter == filterType) {
      if (prevContentFilterOpen) {
        setContentFilter(prevContentFilterOpen);
        prevContentFilterOpen = "";
        setPrevContentFilterOpen(prevContentFilterOpen);
      } else {
        setContentFilter('')
        setTempIDs([])
      }
    } else {
      prevContentFilterOpen = isContentFilter;
      setContentFilter(filterType)
      setPrevContentFilterOpen(prevContentFilterOpen)
      if (filterType == "exercise-type") {
        setTempIDs(sortExerciseTypeIDs);
      } else if (filterType == "exercise-level") {
        setTempIDs(sortExerciseLevelIDs);
      } else if (filterType == "muscle-type") {
        setTempIDs(sortTargetMuscleIDs);
      } else if (filterType == "branch") {
        setTempIDs(branchIDs);
      }
    }
  }

  const handleRemoveOptionalExercise = index => event => {
    setWorkoutPlanner(oldstate => {
      if (isCurrentMemberFilterOption == "cool-down") {
        oldstate.cooldown[selectedExerciseIndex].optionalExercises.splice(index, 1);
      } else if (isCurrentMemberFilterOption == "warm-up") {
        oldstate.warmup[selectedExerciseIndex].optionalExercises.splice(index, 1);
      } else if (isCurrentMemberFilterOption == "weekdays-exercise") {
        oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises.splice(index, 1);
      }
      return ({
        ...oldstate
      })
    })
    event.stopPropagation()
  }


  const removeExercise = (index) => event => {
    setWorkoutPlanner(oldstate => {

      if (isCurrentMemberFilterOption == "cool-down") {
        if(index == 0 && oldstate.warmup.length == 1){
          oldstate.cooldown[index].content = "";  
        }else{
          oldstate.cooldown.splice(index, 1);
        }
      } else if (isCurrentMemberFilterOption == "warm-up") {
        if(index == 0 && oldstate.warmup.length == 1){
          oldstate.warmup[index].content = "";  
        }else{
          oldstate.warmup.splice(index, 1);
        }
      } 
      else if (isCurrentMemberFilterOption == "weekdays-exercise") {
        oldstate.weekdays[selectedWeekDay].exercises.splice(index, 1);
      }
      return ({
        ...oldstate
      })
    })
    event.stopPropagation()
  }


  useEffect(()=>{
    if(selectedWeekDay>-1 && selectedExerciseIndex>-1 && selectedContent && selectedContent.contentType=="mainexercise" && isCurrentMemberFilterOption == "add-exercise"){
      if (selectedOptionalExerciseIndex > -1) {
        if (selectedContent && dayWorkoutStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content._id &&  dayWorkoutStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content._id == selectedContent._id && dayWorkoutStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter && dayWorkoutStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter.isParameterAdded) {
          setExerciseDetails({
            ...exerciseDetails,
            ...dayWorkoutStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter
          });
        } else {
          setExerciseDetails({
            ...exerciseDetails,
            set: [
              {
                reps: "15",
                weight:{
                  value:"",
                  unit:"Kg"
                }
              }
            ],
            weight: {
              value: 0,
              unit: "Kg"
            },
            count: 0,
            distance: {
              value: 0,
              unit: "Km"
            },
            duration: {
              hour: 0,
              min: 0
            }
          })
        }
      } else {
        if (selectedContent && dayWorkoutStorage.exercises[selectedExerciseIndex].content._id && dayWorkoutStorage.exercises[selectedExerciseIndex].content._id == selectedContent._id && dayWorkoutStorage.exercises[selectedExerciseIndex].parameter && dayWorkoutStorage.exercises[selectedExerciseIndex].parameter.isParameterAdded) {
          setExerciseDetails({
            ...exerciseDetails,
            ...dayWorkoutStorage.exercises[selectedExerciseIndex].parameter
          })
        } else {
          setExerciseDetails({
            ...exerciseDetails,
            set: [{
              reps: "15",
              weight:{
                value:"",
                unit:"Kg"
              }
            }],
            weight: {
              value: 0,
              unit: "Kg"
            },
            count: 0,
            distance: {
              value: 0,
              unit: "Km"
            },
            duration: {
              hour: 0,
              min: 0
            }
          })
        }
      }
    }else{
      setExerciseDetails({
        ...exerciseDetails,
        set: [
          {
            reps: "15",
            weight:{
              value:"",
              unit:"Kg"
            }
          }
        ],
        weight: {
          value: 0,
          unit: "Kg"
        },
        count: 0,
        distance: {
          value: 0,
          unit: "Km"
        },
        duration: {
          hour: 0,
          min: 0
        }
      })
    }
  },[selectedWeekDay,selectedExerciseIndex,selectedOptionalExerciseIndex,selectedContent])

  useEffect(() =>{
    handleAddDayExercises();
  },[])

  useEffect(() => {
    if (isCurrentMemberFilterOption == "add-exercise") setContentApiAction(!contentApiAction)
  }, [isCurrentMemberFilterOption])

  const handleSelectWorkoutDay = (name,isUpdate) => {
    const index=dayWorkoutStorage.workoutDays.findIndex(d=>d.name == name);
    if(index>-1){
      const weekDayIndex=workoutPlanner.weekdays.findIndex(d=>d.dayName==name);
      if(isUpdate && weekDayIndex>-1){
        setEditActive(true);
        var workoutDays=[...dayWorkoutStorage.workoutDays];
        workoutDays[index].isSelected=!dayWorkoutStorage.workoutDays[index].isSelected;
        setDayWorkoutStorage({
          ...dayWorkoutStorage,
          workoutDays,
          displayName:workoutPlanner.weekdays[weekDayIndex].displayName,
          name:workoutPlanner.weekdays[weekDayIndex].name,
          exercises:workoutPlanner.weekdays[weekDayIndex].exercises
        })
      }else{
        var workoutDays=[...dayWorkoutStorage.workoutDays];
        workoutDays[index].isSelected=!dayWorkoutStorage.workoutDays[index].isSelected;
        setDayWorkoutStorage({
          ...dayWorkoutStorage,
          workoutDays
        });
      }
      
    }
  
}



const handleAddWorkouts = async event => {

  event.preventDefault();


  const exerciseTemplateCopy = {
    ...exerciseTemplate
  }

  await Promise.all(dayWorkoutStorage.workoutDays.map(data => {
    if(data.isSelected == true){
      setWorkoutPlanner(oldWeekDays => {
        const weekIndex=oldWeekDays.weekdays.findIndex(d=>d.dayName == data.name);
        if(isEditActive && weekIndex>-1){
          oldWeekDays.weekdays[weekIndex].name=dayWorkoutStorage.name;
          oldWeekDays.weekdays[weekIndex].displayName=dayWorkoutStorage.displayName;
          oldWeekDays.weekdays[weekIndex].exercises=dayWorkoutStorage.exercises;
        }else if(weekIndex == -1){
          oldWeekDays.weekdays.push({
            dayIndex:client.config.weekDays.indexOf(data.name),
            dayName : data.name,
            displayName : dayWorkoutStorage.displayName,
            exercises : dayWorkoutStorage.exercises,
            isSelected : false,
            name: dayWorkoutStorage.displayName
          });
        }

        const sortWeekDays=oldWeekDays.weekdays.sort((a,b)=>a.dayIndex-b.dayIndex);
        oldWeekDays.weekdays=[...sortWeekDays];

        return{
          ...oldWeekDays
        }
      })     
    }      
  }))

  setDayWorkoutStorage(oldState => {

    oldState.exercises = [];
    oldState.displayName = "";
    exerciseTemplateCopy.content = {};
    oldState.exercises.push(exerciseTemplateCopy);

    oldState.workoutDays.map(data => {
      if(data.isSelected == true){
        data.isSelected = false
      }
    })

    return {
      ...oldState
    }
  })

  setEditActive(false);
}

const handleDayWorkoutCopyTo = (dayName) => {
  let formattedDayName = dayName == "Mon" ? "Monday" : dayName == "Tue" ? "Tuesday" : dayName == "Wed" ? "Wednesday" : dayName == "Thu" ? "Thursday" : dayName == "Fri" ? "Friday" : dayName == "Sat" ? "Saturday" : ""  
  if(dayName){
    setCopyFrom(formattedDayName)
  }else{
    setCopyFrom("")
  }
}

const handleCopyTo = (index) => {
  setCopyTo(oldState => {  
    
    oldState[index].isSelected = !oldState[index].isSelected;

    return[
      ...oldState
    ]
  })
}

const handlePasteTo = () => {
  let copiedFrom = copyFrom == "Monday" ? "Mon" : copyFrom == "Tuesday" ? "Tue" : copyFrom == "Wednesday" ? "Wed" : copyFrom == "Thursday" ? "Thu" : copyFrom == "Friday" ? "Fri" : "";
  const copiedExerciseList = workoutPlanner.weekdays[workoutPlanner.weekdays.findIndex(data => data.dayName == copiedFrom)]
  
  copyTo.map(data => {
    if(data.isSelected == true){
      setWorkoutPlanner(oldDayWorkout => {
        let foundedIndex = oldDayWorkout.weekdays.findIndex(weekData => weekData.dayName == ((data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "")))
        if(foundedIndex !== -1){
          oldDayWorkout.weekdays[foundedIndex] = {
            dayName: data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "",
            displayName: copiedExerciseList.displayName,
            exercises: copiedExerciseList.exercises,
            isSelected: false,
            name: ""
          }
          oldDayWorkout.weekdays[foundedIndex].dayIndex=client.config.weekDays.indexOf(oldDayWorkout.weekdays[foundedIndex].dayName)
        }else{
          oldDayWorkout.weekdays.push({
            dayIndex:client.config.weekDays.indexOf("Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : ""),
            dayName: data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "",
            displayName: copiedExerciseList.displayName,
            exercises: copiedExerciseList.exercises,
            isSelected: false,
            name: ""
          }) 
        }

        return{
          ...oldDayWorkout
        }
      })
    }
  })

  // TODO
  handleDayWorkoutCopyTo("")
  
}

  const handleSelectedSet = (index) => {
    setSelectedSet(index)
  }

  const handleDeleteSet = (index) => {
    setIndexDeleteEnabled(index)
  }

  const checkDataField = () => {


    if ((isCurrentMemberFilterOption == 'create-planner' ? (
      workoutPlanner.cooldown.length > 0 && 
      workoutPlanner.accessRight && 
      workoutPlanner.cooldown.every(d => d.content && d.content._id) && 
      workoutPlanner.warmup.length > 0 && 
      workoutPlanner.warmup.every(d => d.content && d.content._id) && 
      workoutPlanner.name && 
      PlannerType == "day-workout" ? (
        workoutPlanner.days.length > 0 && 
        workoutPlanner.days.every(d =>  d.exercises.length > 0 && d.exercises.every(d2 => d2.content && d2.content._id))
      ) : (
        workoutPlanner.weekdays.length > 0 && 
        workoutPlanner.weekdays.every(d => d.displayName && d.exercises.length > 0 && d.exercises.every(d2 => d2.content && d2.content._id))
      )
    ) :
        workoutPlanner.isNutritionPlanner?(workoutPlanner.workoutPlannerId && workoutPlannerExeccuteData.members.length):
        workoutPlanner.isOneDayPlanner?(workoutPlanner.workoutPlannerId && workoutPlanner.name && workoutPlannerExeccuteData.members.length && workoutPlannerExeccuteData.startDate):
        (workoutPlannerExeccuteData.startDate && workoutPlannerExeccuteData.duration && 
        workoutPlannerExeccuteData.members.length > 0 && workoutPlanner.cooldown.length > 0 && workoutPlanner.accessRight && 
        workoutPlanner.cooldown.every(d => d.content && d.content._id) && workoutPlanner.warmup.length > 0 && 
        workoutPlanner.warmup.every(d => d.content && d.content._id) && 
        workoutPlanner.name && workoutPlanner.weekdays.length > 0 && 
        PlannerType == "day-workout" ? (
          workoutPlanner.days.length > 0 && 
          workoutPlanner.days.every(d => d.exercises.length > 0 && d.exercises.every(d2 => d2.content && d2.content._id))
        ) : (
          workoutPlanner.weekdays.length > 0 && 
          workoutPlanner.weekdays.every(d => d.displayName && d.exercises.length > 0 && d.exercises.every(d2 => d2.content && d2.content._id))
        )
        // workoutPlanner.weekdays.every(d => d.displayName && d.exercises.length > 0 && d.exercises.every(d2 => d2.content && d2.content._id))
      ))) {
      setButtonLock(false);
    } else {
      // alert("1");
      setButtonLock(true)
    }
  }


  const ExecuteNutritionPlanner = async event =>{
    try {
      // alert("2");
      setButtonLock(true)
      await startLoader()

      let payload = {
        memberIDs:[]
      };
      let memberIDs = workoutPlannerExeccuteData.members.map(d => d._id);
      if(memberIDs.length) payload.memberIDs=memberIDs;
      
      
      await assignNutritionPlanner(user._id,token,workoutPlanner.workoutPlannerId,payload)
      new Toast({
        message:"Planner executed successfully",
        duration:3000,
        type:'success'
      })
      props.toggleManageExecutePlanner();
      await stopLoader()
      setButtonLock(false)
    } catch (error) {
      new Toast({
        message:"Unable to assign planner, something went wrong",
        duration:3000,
        type:'error'
      })
      setButtonLock(false)
      await stopLoader()
    }
  }

  const AssignPlanner = async event => {
    try {
      setButtonLock(true)
      await startLoader()
      let newWorkoutPlanner = {
        workoutPlannerId: workoutPlannerExeccuteData.workoutPlanner._id,
        name: workoutPlannerExeccuteData.workoutPlanner.name,
        accessRight:workoutPlannerExeccuteData.workoutPlanner.accessRight,
        exerciseLevelIDs: workoutPlannerExeccuteData.workoutPlanner.exerciseLevelIDs,
        warmup: [],
        weekdays: [],
        days: [],
        cooldown: [],
      }

      console.log(workoutPlannerExeccuteData);


      if (workoutPlannerExeccuteData.workoutPlanner.warmup.length > 0) {
        await Promise.all(workoutPlannerExeccuteData.workoutPlanner.warmup.map(async exercise => {
          let exerciseObject = {
            optionalExercises: []
          }
          if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;

          await Promise.all(exercise.optionalExercises.map(opex => {
            if (opex._id) exerciseObject.optionalExercises.push({
              contentId: opex._id
            });
          }));

          newWorkoutPlanner.warmup.push(exerciseObject)
        }))
      }

     
      if(PlannerType == "day-workout") {
        if (workoutPlannerExeccuteData.workoutPlanner.days.length > 0) {

          // 🔹 sort by dayIndex first
          const sortedDays = [...workoutPlannerExeccuteData.workoutPlanner.days]
            .sort((a, b) => a.dayIndex - b.dayIndex);

            console.log("ljshdshdhds sorted",sortedDays)

          await Promise.all(
            sortedDays.map(async (day) => {

              let dayObject = {
                displayName: day.displayName,
                dayName: day.dayName,
                dayIndex: day.dayIndex,
                exercises: []
              };

              await Promise.all(
                (day.exercises || []).map(async (exercise) => {

                  let exerciseObject = {};

                  if (exercise.content?._id) {
                    exerciseObject.contentId = exercise.content._id;
                  }

                  if (exercise.optionalExercises?.length > 0) {
                    exerciseObject.optionalExercises = [];

                    await Promise.all(
                      exercise.optionalExercises.map(async (d) => {
                        let opExObject = {
                          parameter: d.parameter || {}
                        };

                        if (d.content?._id) {
                          opExObject.contentId = d.content._id;
                        }

                        exerciseObject.optionalExercises.push(opExObject);
                      })
                    );
                  }

                  if (exercise.parameter) {
                    exerciseObject.parameter = exercise.parameter;
                  }

                  dayObject.exercises.push(exerciseObject);
                })
              );

              newWorkoutPlanner.days.push(dayObject);
            })
          );
        }
      }else{
        if (workoutPlannerExeccuteData.workoutPlanner.weekdays.length > 0) {
          await Promise.all(workoutPlannerExeccuteData.workoutPlanner.weekdays.map(async (day, index) => {
            let dayObject = {
              displayName: day.displayName,
              dayName:day.dayName,
              dayIndex:day.dayIndex,
              exercises: []
            };
            await Promise.all(day.exercises.map(async (exercise, index) => {
              let exerciseObject = {}
              if (exercise.content && exercise.content._id) {
                exerciseObject.contentId = exercise.content._id;
              }
              if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                exerciseObject.optionalExercises = [];
                await Promise.all(exercise.optionalExercises.map(d => {
                  let opExObject = {
                    parameter: d.parameter ? d.parameter : {}
                  };
                  if (d.content && d.content._id) opExObject.contentId = d.content._id;
                  exerciseObject.optionalExercises.push(opExObject);
                }));
              }
              if (exercise.parameter) {
                exerciseObject.parameter = exercise.parameter;
              }

              dayObject.exercises.push(exerciseObject);
            }))
            newWorkoutPlanner.weekdays.push(dayObject)
          }))
        }
      }



      if (workoutPlannerExeccuteData.workoutPlanner.cooldown.length > 0) {
        await Promise.all(workoutPlannerExeccuteData.workoutPlanner.cooldown.map(async exercise => {
          let exerciseObject = {
            optionalExercises: []
          }

          if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;

          await Promise.all(exercise.optionalExercises.map(opex => {
            if (opex._id) exerciseObject.optionalExercises.push({ contentId: opex._id });
          }));

          newWorkoutPlanner.cooldown.push(exerciseObject)
        }))
      }

      let payload = {
        workoutPlanner: newWorkoutPlanner,
        startDate: workoutPlannerExeccuteData.startDate,
        duration: workoutPlannerExeccuteData.duration,
        plannerWeekDays: newWorkoutPlanner.weekdays.map(data => (
          data.dayName === "Mon" ? "Monday" :
          data.dayName === "Tue" ? "Tuesday" :
          data.dayName === "Wed" ? "Wednesday" :
          data.dayName === "Thu" ? "Thursday" :
          data.dayName === "Fri" ? "Friday" :
          data.dayName === "Sat" ? "Saturday" :
          data.dayName === "Sun" ? "Sunday" : ""
        ))
      };

      let payload2 = {
        workoutPlanner: newWorkoutPlanner,
        startDate: workoutPlannerExeccuteData.startDate,
        duration: workoutPlannerExeccuteData.duration
      };

      if(PlannerType == "day-workout") {
        

        if(isMultipleMember){
          payload2.isAllMember=true;
        }else{
          let memberIDs = workoutPlannerExeccuteData.members.map(d => d._id);
          if(memberIDs.length) payload2.memberIDs=memberIDs;
        }

        await assignDaysPlanner(user._id,token,payload2);
        
      }else{

        if(isMultipleMember){
          payload.isAllMember=true;
        }else{
          let memberIDs = workoutPlannerExeccuteData.members.map(d => d._id);
          if(memberIDs.length) payload.memberIDs=memberIDs;
        }
  
        await assignPlanner(user._id,token,payload);
      }
      
      new Toast({
        message:"Planner executed successfully",
        duration:3000,
        type:'success'
      })
      props.toggleManageExecutePlanner();
      await stopLoader()
      setButtonLock(false)
    } catch (error) {
      new Toast({
        message:"Unable to assign planner, something went wrong",
        duration:3000,
        type:'error'
      })
      console.log(error);
      setButtonLock(false)
      await stopLoader()
    }
  }



  const removeMemberFromList = (member) => async event => {
    if (isMultipleMember) {
      let members = await Members.filter(m => m._id != member._id);
      setWorkoutPlannerExecuteData({
        ...workoutPlannerExeccuteData,
        members
      });
      setMultipleMember(false)
    } else {
      let index = workoutPlannerExeccuteData.members.findIndex(d => d._id == member._id)
      if (index > -1) {
        let list = [...workoutPlannerExeccuteData.members]
        list.splice(index, 1);
        setWorkoutPlannerExecuteData({
          ...workoutPlannerExeccuteData,
          members: list
        })

      }
    }
  }

  const handleTempObject = data => event => {
    let list = [...tempObjects];
    let index = list.findIndex(d => d._id == data._id);
    if (index == -1) {
      list.push(data)
    } else {
      list.splice(index, 1)
    }
    setTempObjects(list);
  }


  const handleGymSearch = async event => {
    setGymSearchKey(event.target.value);
  }



  const handleBranchSearch = async event => {
    setBranchSearchKey(event.target.value);
  }


  const handleBranchScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && pageNo.branch < pageCount.branch && !isBrachSpinnerLoader) {
        setBranchSpinnerLoader(true)
        pageNo.branch = pageNo.branch + 1;
        setPageNo({
          ...pageNo
        });
        await GetAllBranches();
        setBranchSpinnerLoader(false)
      }
    } catch (error) {
      setBranchSpinnerLoader(false)
    }
  }

  const confirmBranchTempSelectionIDs = async event => {
    setSelectedBranchIds(tempIDs);
    setTempIDs([])
    setDataChangedTriggered(false)
    toggleMemberFilterOption('branch')
  }



  const GetBranchParams = () => {
    let params = {
      pageNo: pageNo.branch,
      pageSize: pageSize.branch
    };
    if (selectedGym) params.gymIds = [selectedGym._id];
    if (branchSearchKey) params.q = branchSearchKey;
    return params;
  }


  const GetAllBranches = async (isReload) => {
    try {
      let params = GetBranchParams();
      let responses = await getAllBranches(user._id, token, params);
      let list = [];
      if (!responses.error) {
        list = responses;
      }
      if(isReload) setBranches(list);
      else setBranches([...Branches, ...list]);
    } catch (error) {
      //do someting
    }
  }

  const GetBranchCount = async () => {
    let params = GetBranchParams()
    let response = await getBranchCount(user._id, token, params);
    if (response.error) {
      pageNo.branch = 1;
      setPageNo({
        ...pageNo
      })
      setPageCount({
        ...pageCount,
        branch: 1
      })
      setTotal({
        ...Total,
        branch: 0
      })
    } else {
      pageNo.branch = 1;
      pageCount.branch =  Math.ceil(response.COUNT / pageSize.branch);
      setPageNo({
        ...pageNo
      })
      setPageCount({
        ...pageCount
      })
      setTotal({
        ...Total,
        branch: response.COUNT
      })
    }
  }


  const GetGymParams = () => {
    let params = {
      pageNo: pageNo.gym,
      pageSize: pageSize.gym
    };

    if (gymSearchKey) params.q = gymSearchKey;


    return params;
  }

  const GetAllGyms = async (isReload) => {
    try {
      let params = GetGymParams()
      let responses = await getAllGym(user._id, token, params);
      let list = [];

      if (!responses.error) {
        list = responses;
      }
      if(isReload) setGyms(list);
      else setGyms([...Gyms, ...list])

    } catch (error) {
      // do something
    }
  }


  const GetGymCount = async () => {
    try {
      let params = GetGymParams();
      delete params.pageNo;
      delete params.pageSize;
      let response = await getGymCount(user._id, token, params);
      if (!response.error) {
        pageNo.gym = 1;
        setPageNo({
          ...pageNo
        })
        setPageCount({
          ...pageCount,
          gym: 1
        })
        setTotal({
          ...Total,
          gym: 0
        })
      } else {
        pageNo.gym = 1;
        pageCount.gym =  Math.ceil(response.COUNT / pageSize.gym);
        setPageNo({
          ...pageNo
        })
        setPageCount({
          ...pageCount,
        })
        setTotal({
          ...Total,
          gym: response.COUNT
        })
      }
    } catch (error) {
      // do someting
    }
  }

  const handleGymScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && pageNo.gym < pageCount.gym && !isGymSpinnerLoader) {
        setGymSpinnerLoader(true)
        pageNo.gym = pageNo.gym + 1;
        setPageNo({
          ...pageNo
        });
        await GetAllGyms();
        setGymSpinnerLoader(false)
      }
    } catch (error) {
      setGymSpinnerLoader(false)
    }
  }



  const handleClearGym = async () => {
    setSelectedGym("");
    setSelectedBranchIds([]);
  }

  const handleClearBranch = () => {
    setSelectedBranchIds([]);
  }

  const handleSortByLevelID = id => async event => {
    setSortByLevelID(id)
  }

  const GetParameters = async (type = "exerciseLevel") => {
    let params = {
      noLimit: 'noLimit',
      type
    }
    try {
      let response = await getAllParameters(user._id, token, params);
      if (response.error) {
        //do something......
      } else {
        setParameters({
          ...Parameters,
          [type]: response
        })
      }
    } catch (error) {
      // do something
      console.error(error)
    }




  }

  const handleSelectPlanner = (index) => {
    setSelectedPlannerIndex(index);
  }


  const addSelectedPlanner = () => {
    setWorkoutPlannerExecuteData({
      ...workoutPlannerExeccuteData,
      workoutPlanner: { ...Planners[isSelectedPlannerIndex] }
    });

    if(Planners[isSelectedPlannerIndex]){
      setWorkoutPlanner(PlannerType == 'Nutrition'?{
        ...workoutPlanner,
        name: Planners[isSelectedPlannerIndex].name,
        isNutritionPlanner:true,
        isOneDayPlanner:false,
        isDayPlanner:false,
        workoutPlannerId:Planners[isSelectedPlannerIndex]._id
      }: PlannerType == 'day-workout' ? {
        ...workoutPlanner,
        isOneDayPlanner:  Planners[isSelectedPlannerIndex].isOneDayPlanner?true:false,
        isDayPlanner: Planners[isSelectedPlannerIndex].isDayPlanner?true :false,
        exerciseLevelIDs: Planners[isSelectedPlannerIndex].exerciseLevelIDs ? Planners[isSelectedPlannerIndex].exerciseLevelIDs : [],
        workoutPlannerId: Planners[isSelectedPlannerIndex]._id,
        name: Planners[isSelectedPlannerIndex].name,
        cooldown: Planners[isSelectedPlannerIndex].cooldown,
        warmup: Planners[isSelectedPlannerIndex].warmup,
        accessRight:Planners[isSelectedPlannerIndex].accessRight,
        days: Planners[isSelectedPlannerIndex].days.sort((a,b)=>a.dayIndex-b.dayIndex),
        isNutritionPlanner:false
      }:{
        ...workoutPlanner,
        isOneDayPlanner:  Planners[isSelectedPlannerIndex].isOneDayPlanner?true:false,
        isDayPlanner: Planners[isSelectedPlannerIndex].isDayPlanner?true :false,
        exerciseLevelIDs: Planners[isSelectedPlannerIndex].exerciseLevelIDs ? Planners[isSelectedPlannerIndex].exerciseLevelIDs : [],
        workoutPlannerId: Planners[isSelectedPlannerIndex]._id,
        name: Planners[isSelectedPlannerIndex].name,
        cooldown: Planners[isSelectedPlannerIndex].cooldown,
        warmup: Planners[isSelectedPlannerIndex].warmup,
        accessRight:Planners[isSelectedPlannerIndex].accessRight,
        weekdays: Planners[isSelectedPlannerIndex].weekdays.sort((a,b)=>a.dayIndex-b.dayIndex),
        isNutritionPlanner:false
      });
    }
    setSelectedPlannerIndex(-1);
    toggleMemberFilterOption('home')
    togglePlannerTimeStampSelection(this)
  }





  const getExerciseCount = (planner) => {
    let count = 0;
    if( planner.cooldown &&  planner.warmup && planner.weekdays){
      count = count + planner.cooldown.length + planner.warmup.length;
      planner.weekdays.map(day => {
        count = count + day.exercises.length;
      })
    }
    return count;
  }

  const toggleInputFields = id => event => {
    setCurrentElementId(id)
    if (id == "start-date") {
      flatpickr = FlatPicker("#start-date-wrapper", {
        disableMobile: true,
        onChange: (e) => {
          setWorkoutPlannerExecuteData({
            ...workoutPlannerExeccuteData,
            startDate: e[0]
          })
        }
      })
      flatpickr.open();
    }
    if (id == 'weight-unit') setExerciseWeightUnitTypeDropdownOpen(!exerciseWeightUnitTypeDropdownOpen);
    if (id == 'exercise-name') setWeekdayExerciseTypeOpenDropdown(true);
    if(id == 'access-right') setAccessRightDropdown(!isAccessRightDropdown);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }
    event.stopPropagation()
  }



  const handleChange = (type="planner",name) => event => {
    if(type == "planner"){
      setWorkoutPlanner({
        ...workoutPlanner,
        [name]: event.target.value
      });
    }else{
      setWorkoutPlannerExecuteData({
        ...workoutPlannerExeccuteData,
        [name]: event.target.value
      });
    }
  }


  const handleTempIDs = id => event => {
    let ids = [...tempIDs]
    let index = ids.indexOf(id)
    if (index == -1) {
      ids.push(id)
    } else {
      ids.splice(id, 1)
    }
    setDataChangedTriggered(true)
    setTempIDs(ids)
  }

  const confirmMembers = event => {
    setWorkoutPlannerExecuteData({
      ...workoutPlannerExeccuteData,
      members: isMultipleMember ? [] : [...tempObjects]
    });
    toggleMemberFilterOption('home')
  }

  const handleMemberSearch = async event => {
    await setMembers([])
    setMemberSearchKey(event.target.value)
  }

  const handleSelectedBranchIds = (id) => {
    let ids = [...selectedBranchIds];
    let findindex = ids.indexOf(id);
    if (findindex == -1) ids.push(id);
    else ids.splice(findindex, 1)
    setSelectedBranchIds(ids)
  }

  const toggleExerciseContentManageWindow = (opindex = -1, content = {}, exIndex) => event => {
    event.preventDefault();
    setSelectedSet(0);
    if(exIndex != null){
      setSelectedExerciseIndex(exIndex);
      if (isCurrentMemberFilterOption == "weekdays-exercise"){
        toggleWeekDayDropdown(exIndex, -1);
      }
    }
    handleExerciseContentWindow(opindex, content);
    event.stopPropagation();
  }

  const toggleVideoPlayer = (content = "") => {
    if (isVideoPlayerOpen) {
      setVideoPlayerOpen(false)
    } else {
      if (content) {
        setDisplayContent({
          ...displayContent,
          ...content
        })
      }
      setVideoPlayerOpen(true)
    }
  }


  const handleSelectExercise = index => event => {
    setSelectedExerciseIndex(index);
    if (isCurrentMemberFilterOption == "weekdays-exercise"){
      toggleWeekDayDropdown(index, -1);
    }
    event.stopPropagation()
  }


  const handleSelectGym = gym => async event => {
    setSelectedGym(gym)
    toggleMemberFilterOption(prevCurrentMemberFilter)
    setPrevCurrentMemberFilter("")
  }




  const handleSearchPlannerKey = async event => {
    setSearchPlannerKey(event.target.value)
  }


  // api methods



  useEffect(async () => {
    try {
      if (isCurrentMemberFilterOption == "add-exercise") {
        setContentLoader(true);
        await GetContentCount();
        await GetAllContents(true);
        setContentLoader(false);
      }
    } catch (error) {
      // do something
      setContentLoader(false);
    }
  }, [contentApiAction,isCurrentMemberFilterOption,sortByAccessRight, contentSearchKey, sortExerciseTypeIDs, sortExerciseLevelIDs, sortTargetMuscleIDs, ContentRole, selectedGym, branchIDs])


  //workout planner
  const GetWorkoutPlannerParams = () => {
    let params = {
      pageNo: pageNo.planner,
      pageSize: pageSize.planner,
      isFilterByProfile:true,
      activationStatus: "activate"
    }

    if (searchPlannerKey) params.q = searchPlannerKey;

		if (sortByLevelID) params.exerciseLevelIDs = sortByLevelID;

		if (ContentRole) params.contentRole = ContentRole;

    if (ContentRole == "All" || ContentRole == "branch"){
     	params.branchIDs = localStorage.getItem("branchId");
    }

    if (ContentRole == "my"){
     	params.userID = user._id;
    }

    if (ContentRole == "instafit"){
     	params.isInstafitPlanner = true;
    }

    if(PlannerType){
      params.plannerType = PlannerType == "day-workout"?"day":'workout';
    }

		if (sortByAccessRight) params.accessRight= sortByAccessRight == "all" ? "" : sortByAccessRight;

    return params;
  }

  const GetWorkoutPlanners = async (isReload) => {
 
    try {
      let params = GetWorkoutPlannerParams();
 
      let responses = await getAllWorkoutPlanners(user._id, token, params);
 
      if (!responses.error) {
        await Promise.all(responses.map(async response => {
          if (response.warmup && response.warmup.length > 0) {
              await Promise.all(response.warmup.map(async exercise => {
                  let content = await response.warmupMainContent.find(d => d._id == exercise.contentId);
                  if (content) {
                      exercise.content = {
                          ...exercise,
                          ...content
                      }
                  } else {
                      exercise.content = {}
                  }
                  if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                      exercise.optionalExercises = await Promise.all(exercise.optionalExercises.map(async opEx => {
                          let optionalContent = await response.warmupOptionalContent.find(d => d._id == opEx.contentId);
                          if (optionalContent) {
                              opEx = {
                                  ...opEx,
                                  ...optionalContent
                              }
                          }
 
                          return opEx;
                      }))
                  }
              }))
          }
          if (response.cooldown && response.cooldown.length > 0) {
              await Promise.all(response.cooldown.map(async exercise => {
                  let content = await response.cooldownMainContent.find(d => d._id == exercise.contentId);
                  if (content) {
                      exercise.content = {
                          ...exercise,
                          ...content
                      }
                  } else {
                      exercise.content = {}
                  }
 
          
 
                  if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                      exercise.optionalExercises = await Promise.all(exercise.optionalExercises.map(async opEx => {
                          let optionalContent = await response.cooldownOptionalContent.find(d => d._id == opEx.contentId);
                          if (optionalContent) {
                              opEx = {
                                  ...opEx,
                                  ...optionalContent
                              }
                          }
                          return opEx;
                      }))
                  }
              }))
          }
          if (response.workout && response.workout.length > 0) {
              await Promise.all(response.workout.map(async exercise => {
                  let content = await response.workoutMainContent.find(d => d._id == exercise.contentId);
                  if (content) {
                      exercise.content = {
                          ...content
                      }
                  } else {
                      exercise.content = {}
                  }
                  if (!exercise.parameter) exercise.parameter = {};
                  if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                      await Promise.all(exercise.optionalExercises.map(async opEx => {
                          let opContent = await response.workoutOptionalContent.find(d => d._id == opEx.contentId);
                          if (opContent) {
                              opEx.content = {
                                  ...opContent
                              }
                          }
                          if (!opEx.parameter) opEx.parameter = {};
                      }))
                  }
              }))
          }
          if (response.days?.length > 0) {
            response.days = await Promise.all(
              response.days.map(async (day) => {
                if (!day.exercises?.length) {
                  return {
                  ...day,
                  exercises: day.exercises ?? []
                  };
                }
 
                const updatedExercises = await Promise.all(
                    day.exercises.map(async (exercise) => {
                    const content = response.dayListMainContent?.find(
                        d => d._id === exercise.contentId
                    );
 
                    const updatedExercise = {
                        ...exercise,
                        content: content ? { ...content } : {},
                        parameter: exercise.parameter ?? {}
                    };
 
                    if (exercise.optionalExercises?.length > 0) {
                        updatedExercise.optionalExercises = await Promise.all(
                        exercise.optionalExercises.map(async (opEx) => {
                            const opContent = response.dayListOptionalContent?.find(
                            d => d._id === opEx.contentId
                            );
 
                            return {
                            ...opEx,
                            content: opContent ? { ...opContent } : {},
                            parameter: opEx.parameter ?? {}
                            };
                        })
                        );
                    } else {
                        updatedExercise.optionalExercises = [];
                    }
 
                    return updatedExercise;
                    })
                );
 
                return {
                  ...day,
                  exercises: updatedExercises
                };
              })
            );
          }
          if (response.weekdays && response.weekdays.length > 0) {
            await Promise.all(response.weekdays.map(async weekday => {
              if (weekday.exercises && weekday.exercises.length > 0) {
                await Promise.all(weekday.exercises.map(async exercise => {
                  let content = await response.daysMainContent.find(d => d._id == exercise.contentId);
                  if (content) {
                    exercise.content = {
                      ...content
                    }
                  } else {
                    exercise.content = {}
                  }
                  if (!exercise.parameter) exercise.parameter = {};
                  if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                      await Promise.all(exercise.optionalExercises.map(async opEx => {
                          let opContent = await response.daysOptionalContent.find(d => d._id == opEx.contentId);
                          if (opContent) {
                              opEx.content = {
                                  ...opContent
                              }
                          }
                          if (!opEx.parameter) opEx.parameter = {};
                      }))
                  }
                }))
              }
            }))
          }
        }));
        setPlanners(!isReload?[...Planners,...responses]:responses)
      };
    } catch (error) {
      // do something
    }
  }


  const GetWorkoutPlannersCount = async () => {
    try {
      let params = GetWorkoutPlannerParams()
      let response = await getWorkoutPlannerCount(user._id, token, params);
      console.log(response);
      if (response.error) {
        pageCount.planner = 1;
        setPageCount({
          ...pageCount
        })
        pageNo.planner = 1;
        setPageNo({
          ...pageNo
        })
        setTotal({
          ...Total,
          planner: 0
        })
      } else {
        pageNo.planner = 1;
        // pageCount.planner =  Math.ceil(response.COUNT / pageSize.planner);
        pageCount.planner = response.COUNT
        setPageCount({
          ...pageCount
        })
        setPageNo({
          ...pageNo
        })
        setTotal({
          ...Total,
          planner: response.COUNT
        })
      }
    } catch (error) {
      // do something
    }
  }

  //nutrition planner
  // const GetNutritionPlannerParams = () => {
  //   let params = {
  //     pageNo: pageNo.planner,
  //     isInstafitPlanner: true,
  //     pageSize: pageSize.planner,
  //     activationStatus: "activate"
  //   };
  //   if (searchPlannerKey) params.q = searchPlannerKey;
  //   if (selectedGym) params.gymIDs = [selectedGym._id];
  //   if(sortByAccessRight) params.accessRight=sortByAccessRight;
  //   if (selectedBranchIds.length > 0) params.branchIDs = selectedBranchIds;
  //   if (ContentRole != "All") params.contentRole = ContentRole;
  //   return params;
  // }

  const GetNutritionPlannerParams = () => {
    let params = {
      pageNo: pageNo.planner,
      pageSize: pageSize.planner,
      isFilterByProfile: true,
      activationStatus: "activate"
    }

    if (searchPlannerKey) params.q = searchPlannerKey;

    if (ContentRole) params.contentRole = ContentRole;

    if (ContentRole == "All" || ContentRole == "branch"){
     	params.branchIDs = localStorage.getItem("branchId");
    }

    if (ContentRole == "my"){
     	params.userID = user._id;
    }

    if (ContentRole == "instafit"){
     	params.isInstafitPlanner = true;
    }

		if (sortByAccessRight) params.accessRight= sortByAccessRight == "all" ? "" : sortByAccessRight;










	
		// if (sortByExerciseLevelIds.length) params.exerciseLevelIDs = sortByExerciseLevelIds;
		// if (sortByPlannerFrequency > -1) params.plannerFrequency = sortByPlannerFrequency;
	

		if (ContentRole) params.contentRole = ContentRole;


	

    return params;
  }

  const GetNutritionPlanners = async (isReload) => {
    try {
      let params = GetNutritionPlannerParams();
      let responses = await getAllNutritionPlanner(user._id, token, params);
      if (responses.error) {
        // do something
      } else {
        await Promise.all(responses.map(async response => {
          if(response.nutritionSchedules && response.nutritionSchedules.length>0){
            await Promise.all(response.nutritionSchedules.map(async schedule=>{
                if(schedule.meals && schedule.meals.length){
                    await Promise.all(schedule.meals.map(async meal=>{
                        if(meal.items && meal.items.length){
                            await Promise.all(await meal.items.map(async item=>{
                                let content;
                                if(response.nutritionContents && response.nutritionContents.length){
                                    content = await response.nutritionContents.find(d=>d._id == item.contentId);
                                    if(content){
                                        item.content = content;
                                    }
                                }

                            }))
                        }
                    }))
                }
            }))
          }
        }));
        
        setPlanners(prev =>
          isReload ? responses : [...prev, ...responses]
        );
      }

    } catch (error) {
      // do something
      console.error(error)
    }
  }

  const GetNutritionPlannersCount = async () => {
    try {
      let params = GetNutritionPlannerParams()
      let response = await getNutritionPlannerCount(user._id, token, params)
      if (response.error) {
        setPageCount({
          ...pageCount,
          planner: 1
        })
        pageNo.planner = 1;
        setPageNo({
          ...pageNo
        })
        setTotal({
          ...Total,
          planner: 0
        })
      } else {
        setPageCount({
          ...pageCount,
          planner: Math.ceil(response.COUNT / pageSize.planner)
        })

        pageNo.planner = 1;
        setPageNo({
          ...pageNo
        })
        setTotal({
          ...Total,
          planner: response.COUNT
        })
      }
    } catch (error) {
      // do something
    }
  }
  

  //end of planner


  const GetMemberParams = () => {
    let params = {
      pageNo: pageNo.member,
      pageSize: pageSize.member,
      isTrainer:(user?.role == 2 || user?.role == 5)?true:false
    }

    params.activationStatus = "activate";
    if (memberSearchKey) params.q = memberSearchKey;
    params.branchIDs = localStorage?.getItem("branchId") || user.branchId;
    params.gymIDs = localStorage?.getItem("gymId") || user.gymId;
    
    // if (selectedGym) params.gymIDs = [selectedGym._id];
    //if (selectedBranchIds.length > 0) params.branchIDs = selectedBranchIds;

    return params;
  }

  const GetMembers = async (isReload) => {
    try {
      let params = GetMemberParams()
      let response = await getAllMembers(user._id, token, params)
      if (response.error) {
        // do something
      } else {
        setMembers(isReload?[...response]:[...Members, ...response]);
      }
    } catch (error) {
      // do something
    }
  }

  const GetMemberCount = async () => {
    try {
      let params = GetMemberParams();
      let response = await getMemberCount(user._id, token, params);
      if (response.error) {
        pageNo.member = 1;
        setPageNo({
          ...pageNo
        })
        setTotal({
          ...Total,
          member: 0
        })
        setPageCount({
          ...pageCount,
          member: 1
        })
      } else {
        pageNo.member = 1;
        pageCount.member =  Math.ceil(response.COUNT / pageSize.member);
        setPageNo({
          ...pageNo
        })
        setTotal({
          ...Total,
          member: response.COUNT
        })
        setPageCount({
          ...pageCount
        })
      }
    } catch (error) {
      // do something
      console.error(error)
    }
  }


  const handleDayRemove = name => event =>{
    event.preventDefault();
    setWorkoutPlanner(prev=>{
      let index=prev.weekdays.findIndex(data=>data.dayName == name);
      if(index>-1){
        prev.weekdays.splice(index,1);
      }
      return {
        ...prev
      };
    });
  }



  const toggleCurrentWindow = (newcurrentWindow) => {
    prevCurrentMemberFilter = isCurrentMemberFilterOption;
    setPrevCurrentMemberFilter(prevCurrentMemberFilter);
    setCurrentMemberFilterOption(newcurrentWindow);
  }


  const toggleBackToPrevWindow = async () => {
    setEditActive(false);
    if (prevCurrentMemberFilter != "add-exercise") {
      if(isCurrentMemberFilterOption == "weekdays-exercise"){    
        setWorkoutPlanner(prev=>{
          prev.weekdays.map((data, index) => {
            if(data.isSelected){
              data[index] = {
                ...data[index],
                ...prev.weekdays[0]
              };
            }
          });
          return {...prev}
        });
      }
      await setContents([])
      setSelectedContent("");
    }
    if (prevCurrentMemberFilter) {
      setCurrentMemberFilterOption(prevCurrentMemberFilter);
      prevCurrentMemberFilter = "";
      setPrevCurrentMemberFilter(prevCurrentMemberFilter)
    } else {
      setCurrentMemberFilterOption("create-planner")
    }
  }

  


  // close api methods

  const toggleSelectedMember = () => {
    if (isMemberViewOpen) {
      setMemberViewOpen(false)
    } else {
      setMemberViewOpen(true)
    }
  }



  const togglePlannerTimeStampSelection = () => {
    setPlannerTimeStampSelection(!plannerTimeStampSelection)
  }

  const toggleMultipleMember = () => {
    if (isMultipleMember) {
      setMultipleMember(false)
    } else {
      setMultipleMember(true)
    }
  }

  const toggleFilterPlanner = () => {
    if (isFilterPlannerOpen) {
      setFilterPlannerOpen(false)
    } else {
      setFilterPlannerOpen(true)
    }
  }

  const toggleFilterMember = () => {
    if (isFilterMemberOpen) {
      setFilterMemberOpen(false)
    } else {
      setFilterMemberOpen(true)
    }
  }

  const toggleMemberFilterOption = (memberFilterOption) => {
    setPrevCurrentMemberFilter(isCurrentMemberFilterOption);
    if (isCurrentMemberFilterOption == memberFilterOption) {
      setCurrentMemberFilterOption(prevCurrentMemberFilter)
      setFilterMemberOpen(false)
      setPrevCurrentMemberFilter("planer")
    } else {
      if (memberFilterOption == "planner") {
        setPlannerSelectWindow(1)
      }
      if (memberFilterOption == "member") {
        setPlannerSelectWindow(2)
        setTempObjects(workoutPlannerExeccuteData.members)
      }
      setCurrentMemberFilterOption(memberFilterOption)
      setFilterMemberOpen(false)
    }
  }


  //API method 
  const handlePlannerScroll = async event => {
    try {
      const offset = 100; // Adjust this value as needed
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop > 0 && Math.ceil(scrollTop + clientHeight) >= scrollHeight - offset && pageNo.planner < pageCount.planner && !plannerLoaderView){
        setPlannerLoaderView(true);
        pageNo.planner = pageNo.planner + 1;
        setPageNo({
          ...pageNo
        });
        if(PlannerType == "Nutrition"){
          await GetNutritionPlanners(false);
        }else{
          await GetWorkoutPlanners(false);          
        }
        setPlannerLoaderView(false);
      }
  } catch (error) {
      setPlannerLoaderView(false)
    }
  }
  
  const handleMemberScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && pageNo.member < pageCount.member && !memberLoaderView) {
        setMemberLoaderView(true)
        pageNo.member = pageNo.member + 1;
        setPageNo({
          ...pageNo
        });
        await GetMembers();
        setMemberLoaderView(false)
      }
    } catch (error) {
      setMemberLoaderView(false)
    }
  }

  const handleSortByFreequency = async value =>{
    setSortPlannerByFrequency(value);
  }

  const setWeekFrequency = (value) => {
    setCurrentWeekFrequency(value)
  }

  const handleDayFormat = (value) => {
    setDayFormat(value)
  }

  const removeDayExercise = (index) => {

    let exerciseTemplateCopy = {
      ...exerciseTemplate
    }

    setDayWorkoutStorage(oldstate => {
      if(index == 0 && oldstate.exercises.length == 1){
        oldstate.exercises = [];  
        oldstate.exercises.push(exerciseTemplateCopy)
      }else{
        oldstate.exercises.splice(index, 1);
      }
      return ({
        ...oldstate
      })
    })
  }

  const handleRemoveOptionalWeekDayExercise = index =>  event => {
    setDayWorkoutStorage(oldstate => {
      oldstate.exercises[selectedExerciseIndex].optionalExercises.splice(index, 1);
      return ({
        ...oldstate
      })
    })
    event.stopPropagation();
  }


  const toggleWeekDayDropdown = (mainExerciseIndex, optionalExerciseIndex = -1) => {
    if (mainExerciseIndex > -1) {
      setDayWorkoutStorage(oldstate => {
        if (optionalExerciseIndex > -1) {
          oldstate.exercises[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen = oldstate.exercises[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen ? false : true;
        } else {
          oldstate.exercises[mainExerciseIndex].isDropdownOpen = oldstate.exercises[mainExerciseIndex].isDropdownOpen ? false : true;
        }
        return {
          ...oldstate
        }
      })
    }
    // if (mainExerciseIndex > -1) {
    //   setWorkoutPlanner(oldstate => {
    //     if (optionalExerciseIndex > -1) {
    //       oldstate.weekdays[selectedWeekDay].exercises[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen = oldstate.weekdays[selectedWeekDay].exercises[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen ? false : true;
    //     } else {
    //       oldstate.weekdays[selectedWeekDay].exercises[mainExerciseIndex].isDropdownOpen = oldstate.weekdays[selectedWeekDay].exercises[mainExerciseIndex].isDropdownOpen ? false : true;
    //     }
    //     return {
    //       ...oldstate
    //     }
    //   })
    // }
  }

  

  const handleWeekDayWorkoutDisplayName = event => {
    setDayWorkoutStorage(oldstate => {
      oldstate.displayName = event.target.value;
      return {
        ...oldstate
      }
    })
  }


  const handleExerciseContentWindow = (opindex, content) => {
    let typeValue = isCurrentMemberFilterOption == "weekdays-exercise" ? "mainexercise" : isCurrentMemberFilterOption == "cool-down" ? "cooldown" : isCurrentMemberFilterOption == "warm-up" ? "warmup" : "";
    if (!typeValue) return "";
    setSelectedOptionalExerciseIndex(opindex)
    setSelectedContent({ ...content })
    sortByContentType = typeValue;
    setSortByContentType(typeValue);
    toggleCurrentWindow("add-exercise")
  }

  const handleAddOptionalWeekdayExercise = () => {
    const opindex=dayWorkoutStorage.exercises[selectedExerciseIndex].optionalExercises.length;
    setDayWorkoutStorage(oldstate => {
      oldstate.exercises[selectedExerciseIndex].optionalExercises.push({
        content: {},
        parameter: {}
      })
      return ({
        ...oldstate
      })
    })

    setTimeout(() => {
      handleExerciseContentWindow(opindex, {})
    }, 10);
  }

  const handleAddDayExercises = () => {
    setDayWorkoutStorage(oldstate => {
      let exerciseTemplateCopy = {
        ...exerciseTemplate
      }
      exerciseTemplateCopy.content = {}
      oldstate.exercises.push(exerciseTemplateCopy);
      return { ...oldstate }
    })
  } 

  // useEffect(() => {
  //   if (props.members.length > 0) {
  //     setWorkoutPlannerExecuteData({
  //       ...workoutPlannerExeccuteData,
  //       members: props.members
  //     })
  //   }
  //   // setTimeout(()=>{
  //   //   if(props.PlannerType) setPlannerType("Nutrition");
  //   // },700);
  // }, [props])


  useEffect(()=>{
     if (props.members.length > 0) {
      setWorkoutPlannerExecuteData({
        ...workoutPlannerExeccuteData,
        members: props.members
      })
    }
    if(props.PlannerType == 0) setPlannerType("Workout")
    else if(props.PlannerType == 1) setPlannerType("Nutrition")
  },[props])

  useEffect(() => {
    checkDataField()
  }, [workoutPlannerExeccuteData,workoutPlanner,isCurrentMemberFilterOption])

  useEffect(() => {
    if (isPlannerSelectWindow > -1) {
      // setSelectedGym("");
      // setSelectedBranchIds([]);
    }
  }, [isPlannerSelectWindow])


  useEffect(async () => {
    try {
      await startLoader();
      await GetGymCount();
      await GetAllGyms(true);
      await stopLoader();
    } catch (error) {
      //do something
      await stopLoader()
    }
  }, [gymSearchKey])

  useEffect(async () => {
    try {
      if (selectedGym) {
        setBranchSpinnerLoader(true);
        await GetBranchCount();
        await GetAllBranches(true);
        setBranchSpinnerLoader(false);
      }
    } catch (Error) {
      // do something
      setBranchSpinnerLoader(false);
    }
  }, [branchSearchKey, selectedGym])

  useEffect(async () => {
    try {
      setMemberLoaderView(true)
      await GetMemberCount()
      await GetMembers(true)
      setMemberLoaderView(false)
    } catch (Error) {
      // do something
      setMemberViewOpen(false)
    }
  }, [memberSearchKey, selectedGym, selectedBranchIds]);

  const GetAllParams = async (type = "exerciseName") => {
    try {
      let params = {
        noLimit: 'noLimit',
        type
      };
      let responses = await getAllParameters(user._id, token, params);
      if (responses.error) {
        // do something
        return []
      } else {
        return responses;
      }
    } catch (error) {
      // do something
      return []
    }
  }

  useEffect(async () => {
    window.addEventListener("click", () => {
      setCurrentElementId("");
    })
    setContents([])
    setSelectedContent("")
    try {
      await startLoader()
      let targetMuscleList = await GetAllParams("targetMuscle");
      setTargetMuscles(targetMuscleList)
      let exerciseTypeList = await GetAllParams('exerciseType')
      setExerciseTypes(exerciseTypeList);
      let exerciseLevelList = await GetAllParams('exerciseLevel');
      setExerciseLevels(exerciseLevelList)
      await stopLoader()
    } catch (error) {
      await stopLoader()
    }
  }, [])

  useEffect(async () => {
    startLoader()
    try {
      setPlannerLoaderView(true)
      setReload(true);
      // setPlanners([])
      if(PlannerType == "Nutrition"){
        await GetNutritionPlannersCount();
        await GetNutritionPlanners(true);
      }else{
        await GetWorkoutPlannersCount()
        await GetWorkoutPlanners(true)
      }
      setPlannerLoaderView(false)
      setReload(false)
    } catch (error) {
      setPlannerLoaderView(false)
      setReload(false)
    }
    stopLoader()
  }, [searchPlannerKey,ContentRole,PlannerType, sortByAccessRight, sortByPlannerFrequency, sortByPlannerRole, sortByLevelID, selectedGym, selectedBranchIds])

  useEffect(async () => {
    try {
      await startLoader()
      await GetParameters('exerciseLevel');
      await stopLoader()
    } catch (error) {
      await stopLoader()
    }
  }, []);


  return (
    <div className={`${window.innerWidth < 768 ? "w-full h-full" : "global-modal-container d-flex"}`}>
      <div className={`${window.innerWidth < 768 ? "w-full h-full" : "global-modal-type-2 planner-assign-modal flex-item"}`} style={{padding:window.innerWidth < 768 && "12px", width: window.innerWidth > 767 && "40%", height: window.innerWidth > 767 && "90%"}}>
        {
          window.innerWidth > 767 && (
            <div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="30" height="30" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.59375 5.90625C7.59375 5.68247 7.68264 5.46786 7.84088 5.30963C7.99911 5.15139 8.2137 5.0625 8.4375 5.0625H12.6562V6.75H8.4375C8.2137 6.75 7.99911 6.66111 7.84088 6.50287C7.68264 6.34464 7.59375 6.13003 7.59375 5.90625ZM0.84375 7.59375H4.21875C4.44253 7.59375 4.65714 7.68264 4.81537 7.84088C4.97361 7.99911 5.0625 8.2137 5.0625 8.4375C5.0625 8.6613 4.97361 8.8759 4.81537 9.0341C4.65714 9.1924 4.44253 9.2812 4.21875 9.2812H0.84375V7.59375Z" fill="#ffffff"/>
                  <path d="M2.95312 0C3.06501 0 3.17232 0.04445 3.25144 0.12356C3.33055 0.20268 3.375 0.30999 3.375 0.42188V0.84375H10.125V0.42188C10.125 0.30999 10.1694 0.20268 10.2486 0.12356C10.3277 0.04445 10.435 0 10.5469 0C10.6588 0 10.7661 0.04445 10.8452 0.12356C10.9243 0.20268 10.9688 0.30999 10.9688 0.42188V0.84375H11.8125C12.2601 0.84375 12.6893 1.02154 13.0057 1.33801C13.3222 1.65447 13.5 2.0837 13.5 2.53125V11.8125C13.5 12.2601 13.3222 12.6893 13.0057 13.0057C12.6893 13.3222 12.2601 13.5 11.8125 13.5H1.6875C1.23995 13.5 0.81072 13.3222 0.49426 13.0057C0.17779 12.6893 0 12.2601 0 11.8125V2.53125C0 2.0837 0.17779 1.65447 0.49426 1.33801C0.81072 1.02154 1.23995 0.84375 1.6875 0.84375H2.53125V0.42188C2.53125 0.30999 2.5757 0.20268 2.65481 0.12356C2.73393 0.04445 2.84124 0 2.95312 0ZM0.84375 3.375V11.8125C0.84375 12.0363 0.93264 12.2509 1.09088 12.4091C1.24911 12.5674 1.46372 12.6562 1.6875 12.6562H11.8125C12.0363 12.6562 12.2509 12.5674 12.4091 12.4091C12.5674 12.2509 12.6562 12.0363 12.6562 11.8125V3.375H0.84375Z" fill="#ffffff"/>
                </svg>
                <p className="flex-item fs-20 font-weight-700 color-white">{PlannerType == "Workout" ? "Workout Planner" : PlannerType == "Nutrition" ? "Nutrition Planner" : "Planner"}</p>
              </div>
              <div onClick={()=>props.toggleManageExecutePlanner()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div onClick={e => e.stopPropagation()} className="no-scroll-bar p-l-2 p-r-2" style={{ paddingBottom: window.innerWidth > 767 ? "20px" : "60px", overflowY: 'scroll', height: window.innerWidth > 767 ? "90%" : "100%", paddingTop:"4px" , paddingLeft: window.innerWidth > 767 && "12px", paddingRight: window.innerWidth > 767 && "12px", paddingTop: window.innerWidth > 767 && "12px"}}>
          {
            isCurrentMemberFilterOption == "home" ? [
              <div className='w-full handle-planner-assign-container cursor-pointer m-b-16'>
                <div className='w-full p-l-12 p-r-12 p-b-8 p-t-8' style={{borderBottom:"1px dashed #e0e0e0"}}>
                  <div onClick={() => toggleMemberFilterOption('member')} className='d-flex' >
                    <p className='flex-item fs-16 font-weight-600 m-r-8'>Members</p>
                    <svg className='flex-item' width="14" height="14" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.4438 0.556378C10.2674 0.379984 10.0579 0.240061 9.82748 0.144598C9.597 0.0491344 9.34999 0 9.10053 0C8.85107 0 8.60405 0.0491344 8.37358 0.144598C8.14311 0.240061 7.9337 0.379984 7.7573 0.556378L1.11048 7.20422C0.900953 7.41371 0.751625 7.6757 0.678138 7.96273L0.0106501 10.5713C-0.00407804 10.6291 -0.00352163 10.6897 0.0122647 10.7472C0.0280511 10.8047 0.0585245 10.8571 0.100692 10.8993C0.142859 10.9415 0.195269 10.9719 0.252775 10.9877C0.31028 11.0035 0.370903 11.0041 0.428689 10.9894L3.03786 10.3227C3.3251 10.2493 3.58729 10.1 3.79693 9.89036L10.4438 3.24252C10.7999 2.88629 11 2.40318 11 1.89945C11 1.39572 10.7999 0.912607 10.4438 0.556378ZM8.24355 1.04262C8.47083 0.815298 8.77911 0.687577 9.10057 0.687551C9.42202 0.687526 9.73032 0.815197 9.95764 1.04248C10.185 1.26976 10.3127 1.57804 10.3127 1.89949C10.3127 2.22094 10.1851 2.52924 9.95778 2.75656L9.3508 3.36353L7.63684 1.64932L8.24355 1.04262ZM7.15059 2.13556L8.86455 3.84977L3.31068 9.40412C3.18832 9.5265 3.03528 9.61371 2.86762 9.65659L0.820601 10.1797L1.34425 8.13324C1.38715 7.96548 1.47434 7.81257 1.59645 7.69046L7.15059 2.13556Z" fill="var(--darkBlue)"/>
                    </svg>
                  </div>
                  <p className='fs-18 font-weight-700 color-red'>{workoutPlannerExeccuteData.members.length > 0 ? `${workoutPlannerExeccuteData.members.length} Member${workoutPlannerExeccuteData.members.length > 1 ? "s" :""} selected` : "Select Member"}</p>
                </div>
                <div className='w-full handle-planner-assign-scroll-container'>
                  {
                    workoutPlannerExeccuteData.members.map(member => {
                      return (
                        <div className='d-flex handle-planner-member-chips space-between flex-item' style={{borderRadius:"8px"}}>
                          <div className='d-flex'>
                            {
                              member.user.length > 0 && (
                                member.user[0].profileID ? (
                                  <img style={{height: "40px", width: "40px"}} className='flex-item branch-gym-logo m-r-8' src={`${client.config.API_URL}/image/file/${member.user[0].profileID}/auto/auto/auto`} />
                                ) : (
                                  <div className='flex-item branch-gym-logo m-r-8 d-flex' style={{height: "40px", width: "40px", backgroundColor: "#5d883c"}}>
                                    <p className='flex-item fs-18' style={{ margin: '0 auto', color: '#ffffff' }}>{`${member.user[0].name}`.trim()[0]}</p>
                                  </div>
                                )
                              )
                            }
                            <div className='flex-item'>
                              <p className='name-txt fs-16' style={{ fontWeight: "600" }}>{member.user.length > 0 && member.user[0].name}</p>
                              <p className='email-txt'>{member.user[0].email}</p>
                            </div>
                          </div>
                          <div onClick={removeMemberFromList(member)} className="table-action-btn button-red flex-item d-flex" style={{boxShadow:"0px 0px 12px rgba(0,0,0,0.25)"}}>
                            <svg className='flex-item svg-stroke margin-auto' width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L11 11M1 11L11 1" stroke="#E33A34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>,
              !isEmpty(workoutPlannerExeccuteData.workoutPlanner) ? (
                <div className='w-full handle-planner-assign-container cursor-pointer p-b-6 m-b-16 d-flex space-between'>
                  <div className='flex-item' style={{width:"70%"}}>
                    <div onClick={() => toggleMemberFilterOption('planner')} className='d-flex p-t-12 p-l-12 p-r-12'>
                      <p className='flex-item font-weight-600 m-r-8'>Planner</p>
                      <svg className='flex-item' width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2371 3.20432L9.6829 2.55956C9.21298 2.06599 8.64755 1.6732 8.02101 1.40509C7.39447 1.13698 6.71993 0.999155 6.03843 1C3.2568 1 1 3.2568 1 6.03844C1 8.82007 3.2568 11.0769 6.03843 11.0769C7.0805 11.0768 8.09693 10.7538 8.94786 10.1523C9.79878 9.55073 10.4424 8.70027 10.79 7.71792" stroke="#E33A34" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M11.9183 1.87716V4.77898C11.9183 4.89034 11.8741 4.99714 11.7954 5.07588C11.7166 5.15462 11.6098 5.19885 11.4985 5.19885H8.59665C8.22245 5.19885 8.03508 4.74671 8.2996 4.48219L11.2017 1.5801C11.4662 1.31506 11.9183 1.50295 11.9183 1.87716Z" fill="#E33A34"/>
                      </svg>
                    </div>
                    <p className='description-txt m-t-4 m-b-8 p-l-12 p-r-12'>{workoutPlannerExeccuteData.workoutPlanner.name ? workoutPlannerExeccuteData.workoutPlanner.name:"No Planner Selected"}</p>
                  </div>
                  <div className='flex-item d-flex p-l-12 p-r-12'>
                    {
                      (!workoutPlanner.isNutritionPlanner && !workoutPlanner.isOneDayPlanner && !workoutPlanner.isDayPlanner) && (
                        <div onClick={()=>toggleMemberFilterOption('create-planner')} className="member-button-global button-red d-flex p-l-16 p-r-16" style={{ margin: "12px 0 0 0 0", background: "var(--darkBlue)" }}>
                          <p className="flex-item" style={{color: "#ffffff", fontSize:"14px", fontWeight:"600"}}>Update</p>
                        </div>
                      )
                    }
                  </div>
                </div>
              ) : (
                <div className='flex-item w-full'>
                  <div className='flex-item d-flex m-b-20'>
                    <div onClick={() => toggleMemberFilterOption('planner')} className={`member-button-global btn-center d-flex`} style={{background: "var(--darkBlue)"}}>
                      <p className="flex-item font-weight-600" style={{color:"#ffffff", fontSize:"16px", fontWeight:"600"}}>Select Planner</p>
                    </div>
                  </div>
                </div>
              ),
              !workoutPlanner.isNutritionPlanner && (
                <div className='d-flex space-between'>
                  <div id="start-date-wrapper" onClick={toggleInputFields('start-date')} className={`${(currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field flex-item m-b-20 d-flex"}`} style={{ border: (currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "1px solid var(--darkBlue)" : "", width: "48%", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-4" width={(currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "10" : "18"} height={(currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "10" : "18"} style={{ transition: "180ms" }} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.37735 2.24821C5.67548 2.24821 5.9614 2.12977 6.17221 1.91896C6.38302 1.70815 6.50145 1.42223 6.50145 1.1241C6.50145 0.825972 6.38302 0.540052 6.17221 0.329242C5.9614 0.118432 5.67548 0 5.37735 0C5.07922 0 4.7933 0.118432 4.58249 0.329242C4.37168 0.540052 4.25325 0.825972 4.25325 1.1241C4.25325 1.42223 4.37168 1.70815 4.58249 1.91896C4.7933 2.12977 5.07922 2.24821 5.37735 2.24821ZM3.11915 3.31785C2.80765 3.39529 2.59507 3.5117 2.42346 3.65608C2.16616 3.87291 1.95833 4.18566 1.67755 4.67727C1.6118 4.79231 1.50304 4.87653 1.37519 4.91138C1.24735 4.94623 1.11089 4.92887 0.995847 4.86312C0.880801 4.79736 0.796589 4.6886 0.761735 4.56076C0.726881 4.43291 0.74424 4.29646 0.809995 4.18141C1.08952 3.69255 1.37205 3.23517 1.77997 2.89194C2.20563 2.53323 2.72672 2.33039 3.4294 2.2522C3.72317 2.21973 4.04641 2.22622 4.34942 2.36137C4.66742 2.5035 4.89973 2.75805 5.0581 3.09828C5.27143 3.55616 5.43006 3.82869 5.55696 3.98657C5.61816 4.06251 5.66087 4.09773 5.6851 4.11347C5.70434 4.12596 5.71258 4.12696 5.71558 4.12746C5.73731 4.12995 5.80801 4.12746 6.01484 4.03578C6.10502 3.99581 6.20344 3.94785 6.32384 3.88915L6.35257 3.87516C6.49982 3.80249 6.6484 3.73254 6.79822 3.66533C6.91917 3.61222 7.05623 3.60919 7.17942 3.65688C7.30261 3.70458 7.40189 3.79911 7.45556 3.91982C7.50922 4.04053 7.5129 4.17757 7.46579 4.30098C7.41867 4.42439 7.3246 4.52412 7.20414 4.57835C7.06531 4.64066 6.92765 4.70553 6.79122 4.77294L6.7585 4.78893C6.64334 4.84513 6.52743 4.90184 6.41877 4.9498C6.19395 5.04922 5.90668 5.15713 5.59518 5.11941C5.26644 5.07945 5.01314 4.89384 4.80456 4.64479L4.12185 5.96199L5.0661 7.19051C5.1223 7.26395 5.15703 7.35138 5.16677 7.44331L5.3746 9.44072C5.38252 9.50652 5.37726 9.57325 5.35914 9.63701C5.34102 9.70077 5.31039 9.76028 5.26903 9.81208C5.22768 9.86388 5.17644 9.90694 5.11828 9.93874C5.06012 9.97054 4.99622 9.99046 4.93029 9.99732C4.86437 10.0042 4.79773 9.99785 4.73428 9.97871C4.67082 9.95956 4.6118 9.92798 4.56067 9.8858C4.50954 9.84362 4.46731 9.79169 4.43645 9.73304C4.40558 9.67438 4.3867 9.61016 4.3809 9.54413L4.18755 7.68736L3.61401 6.94096L3.60901 6.9502L3.58803 6.90724L2.52837 5.52834C2.47628 5.46056 2.44245 5.38056 2.43012 5.29597C2.41779 5.21139 2.42736 5.12505 2.45793 5.04522L3.11915 3.31785Z" fill={(currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate ? "var(--darkBlue)" : "#6d6d6d")} />
                        <path d="M2.36235 6.24658L1.99464 7.23579L0.545797 7.12088C0.479925 7.11477 0.413495 7.12179 0.35036 7.14156C0.287225 7.16132 0.228644 7.19342 0.178016 7.236C0.127387 7.27859 0.0857207 7.3308 0.0554334 7.38962C0.0251461 7.44843 0.00684141 7.51268 0.00158161 7.57862C-0.00367819 7.64457 0.00421159 7.7109 0.0247932 7.77378C0.0453747 7.83665 0.0782381 7.89481 0.121476 7.94488C0.164714 7.99495 0.217466 8.03593 0.27667 8.06545C0.335875 8.09497 0.400352 8.11244 0.466361 8.11684L2.2919 8.26172C2.40025 8.27035 2.50845 8.2434 2.60009 8.18498C2.69174 8.12655 2.76183 8.03984 2.79975 7.93798L3.08077 7.18159L2.36235 6.24658Z" fill={(currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate ? "var(--darkBlue)" : "#6d6d6d")} />
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "10px" : "14px", color: (currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>{workoutPlanner.isOneDayPlanner?"Assign Date":"Start Date"}</p>
                    </div>
                    <input value={formatDateTime(workoutPlannerExeccuteData.startDate)} className={`${(currentElementId == 'start-date' || workoutPlannerExeccuteData.startDate) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>
                  {!workoutPlanner.isOneDayPlanner&&<div onClick={toggleInputFields('duration')} className={`${(currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field flex-item m-b-20 d-flex"}`} style={{ border: (currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "1px solid var(--darkBlue)" : "", width: "48%", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-4" width={(currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "10" : "18"} height={(currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "10" : "18"} style={{ transition: "180ms" }} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.37735 2.24821C5.67548 2.24821 5.9614 2.12977 6.17221 1.91896C6.38302 1.70815 6.50145 1.42223 6.50145 1.1241C6.50145 0.825972 6.38302 0.540052 6.17221 0.329242C5.9614 0.118432 5.67548 0 5.37735 0C5.07922 0 4.7933 0.118432 4.58249 0.329242C4.37168 0.540052 4.25325 0.825972 4.25325 1.1241C4.25325 1.42223 4.37168 1.70815 4.58249 1.91896C4.7933 2.12977 5.07922 2.24821 5.37735 2.24821ZM3.11915 3.31785C2.80765 3.39529 2.59507 3.5117 2.42346 3.65608C2.16616 3.87291 1.95833 4.18566 1.67755 4.67727C1.6118 4.79231 1.50304 4.87653 1.37519 4.91138C1.24735 4.94623 1.11089 4.92887 0.995847 4.86312C0.880801 4.79736 0.796589 4.6886 0.761735 4.56076C0.726881 4.43291 0.74424 4.29646 0.809995 4.18141C1.08952 3.69255 1.37205 3.23517 1.77997 2.89194C2.20563 2.53323 2.72672 2.33039 3.4294 2.2522C3.72317 2.21973 4.04641 2.22622 4.34942 2.36137C4.66742 2.5035 4.89973 2.75805 5.0581 3.09828C5.27143 3.55616 5.43006 3.82869 5.55696 3.98657C5.61816 4.06251 5.66087 4.09773 5.6851 4.11347C5.70434 4.12596 5.71258 4.12696 5.71558 4.12746C5.73731 4.12995 5.80801 4.12746 6.01484 4.03578C6.10502 3.99581 6.20344 3.94785 6.32384 3.88915L6.35257 3.87516C6.49982 3.80249 6.6484 3.73254 6.79822 3.66533C6.91917 3.61222 7.05623 3.60919 7.17942 3.65688C7.30261 3.70458 7.40189 3.79911 7.45556 3.91982C7.50922 4.04053 7.5129 4.17757 7.46579 4.30098C7.41867 4.42439 7.3246 4.52412 7.20414 4.57835C7.06531 4.64066 6.92765 4.70553 6.79122 4.77294L6.7585 4.78893C6.64334 4.84513 6.52743 4.90184 6.41877 4.9498C6.19395 5.04922 5.90668 5.15713 5.59518 5.11941C5.26644 5.07945 5.01314 4.89384 4.80456 4.64479L4.12185 5.96199L5.0661 7.19051C5.1223 7.26395 5.15703 7.35138 5.16677 7.44331L5.3746 9.44072C5.38252 9.50652 5.37726 9.57325 5.35914 9.63701C5.34102 9.70077 5.31039 9.76028 5.26903 9.81208C5.22768 9.86388 5.17644 9.90694 5.11828 9.93874C5.06012 9.97054 4.99622 9.99046 4.93029 9.99732C4.86437 10.0042 4.79773 9.99785 4.73428 9.97871C4.67082 9.95956 4.6118 9.92798 4.56067 9.8858C4.50954 9.84362 4.46731 9.79169 4.43645 9.73304C4.40558 9.67438 4.3867 9.61016 4.3809 9.54413L4.18755 7.68736L3.61401 6.94096L3.60901 6.9502L3.58803 6.90724L2.52837 5.52834C2.47628 5.46056 2.44245 5.38056 2.43012 5.29597C2.41779 5.21139 2.42736 5.12505 2.45793 5.04522L3.11915 3.31785Z" fill={(currentElementId == 'duration' || workoutPlannerExeccuteData.duration ? "var(--darkBlue)" : "#6d6d6d")} />
                        <path d="M2.36235 6.24658L1.99464 7.23579L0.545797 7.12088C0.479925 7.11477 0.413495 7.12179 0.35036 7.14156C0.287225 7.16132 0.228644 7.19342 0.178016 7.236C0.127387 7.27859 0.0857207 7.3308 0.0554334 7.38962C0.0251461 7.44843 0.00684141 7.51268 0.00158161 7.57862C-0.00367819 7.64457 0.00421159 7.7109 0.0247932 7.77378C0.0453747 7.83665 0.0782381 7.89481 0.121476 7.94488C0.164714 7.99495 0.217466 8.03593 0.27667 8.06545C0.335875 8.09497 0.400352 8.11244 0.466361 8.11684L2.2919 8.26172C2.40025 8.27035 2.50845 8.2434 2.60009 8.18498C2.69174 8.12655 2.76183 8.03984 2.79975 7.93798L3.08077 7.18159L2.36235 6.24658Z" fill={(currentElementId == 'duration' || workoutPlannerExeccuteData.duration ? "var(--darkBlue)" : "#6d6d6d")} />
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "10px" : "14px", color: (currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "var(--darkBlue)" : "", transition: "180ms" }}>Duration (Day's)</p>
                    </div>
                    <input value={workoutPlannerExeccuteData.duration} className={`${(currentElementId == 'duration' || workoutPlannerExeccuteData.duration) ? "active-input-field" : "inactive-input-field"}`} type="text" onChange={handleChange("plannerExecution","duration")} />
                  </div>}
                </div>
              ),
              <div className='modal-bottom-action-container d-flex'>
                <div onClick={isButtonLock ? null : workoutPlanner.isNutritionPlanner?ExecuteNutritionPlanner:workoutPlanner.isOneDayPlanner?()=>alert("One day planner execute feature is under development"):AssignPlanner} className={`member-button-global ${isButtonLock ? "member-button-global-inactive" : ""} btn-center d-flex flex-item`} style={{ margin: "12px auto 12px auto", width: "94%" }}>
                  <p className="flex-item" style={{fontWeight:700, fontSize:"18px"}}>Assign</p>
                </div>
              </div>
            ] :
            isCurrentMemberFilterOption == "planner" ? [
              <div className="w-full h-full">
                <div className='w-full space-between d-flex m-b-20'>
                  <div id="search-container" className='global-search-box desktop-search-input' style={{ background: "#ffffff", boxShadow:"0px 0px 8px rgba(0, 0, 0, 0.10)", width: "90%", height: "40px", borderRadius: "20px" }}>
                    <svg id="search-icon" className='flex-item m-b-3' width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1637_1318)">
                        <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1637_1318">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <input id="search-planner-input" onChange={_.debounce(handleSearchPlannerKey, 1000)} className='flex-item' style={{ background: "#ffffff" }} type="text" placeholder="Search Planner"  />
                  </div>
                  
                  <div onClick={toggleFilterPlanner.bind(this)} className='global-round-btn d-flex' style={{ background: isFilterPlannerOpen && "#E33A34", boxShadow:"0px 0px 8px rgba(0, 0, 0, 0.10)", width: "40px", height: "40px", borderRadius: "20px" }}>
                    {
                      isFilterPlannerOpen ? (
                        <svg className='flex-item margin-auto' width="16" height="16" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.24911 6.66421L1.71358 10.1997C1.51323 10.4001 1.27753 10.5 1.00647 10.4996C0.735411 10.4991 0.499708 10.3992 0.299362 10.1997C0.0990146 10.0003 -0.000922958 9.76464 -0.000451556 9.49264C1.98463e-05 9.22064 0.0999575 8.98494 0.299362 8.78553L3.8349 5.25L0.299362 1.71447C0.0990146 1.51412 -0.000922958 1.27842 -0.000451556 1.00736C1.98463e-05 0.736302 0.0999575 0.5006 0.299362 0.300253C0.498766 0.0999058 0.734704 -0.000267811 1.00718 -0.000267811C1.27965 -0.000267811 1.51511 0.0999054 1.71358 0.300252L5.24911 3.83579L8.78464 0.300252C8.98499 0.0999054 9.22093 -0.000267558 9.49246 -0.000267558C9.76399 -0.000267558 9.99945 0.0999054 10.1989 0.300252C10.3983 0.500599 10.4984 0.736537 10.4994 1.00807C10.5003 1.2796 10.4001 1.51506 10.1989 1.71447L6.66332 5.25L10.1989 8.78553C10.3992 8.98588 10.4994 9.22182 10.4994 9.49335C10.4994 9.76488 10.3992 10.0003 10.1989 10.1997C9.99851 10.3992 9.76281 10.4991 9.49175 10.4996C9.22069 10.5 8.98499 10.4001 8.78464 10.1997L5.24911 6.66421Z" fill="#ffffff"/>
                        </svg>
                      ) : (
                        <svg className='flex-item fill-svg' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 4H12.95C12.7 2.85 11.7 2 10.5 2C9.3 2 8.3 2.85 8.05 4H1V5H8.05C8.3 6.15 9.3 7 10.5 7C11.7 7 12.7 6.15 12.95 5H15V4ZM10.5 6C9.65 6 9 5.35 9 4.5C9 3.65 9.65 3 10.5 3C11.35 3 12 3.65 12 4.5C12 5.35 11.35 6 10.5 6ZM1 12H3.05C3.3 13.15 4.3 14 5.5 14C6.7 14 7.7 13.15 7.95 12H15V11H7.95C7.7 9.85 6.7 9 5.5 9C4.3 9 3.3 9.85 3.05 11H1V12ZM5.5 10C6.35 10 7 10.65 7 11.5C7 12.35 6.35 13 5.5 13C4.65 13 4 12.35 4 11.5C4 10.65 4.65 10 5.5 10Z" fill="#000000" />
                        </svg>
                      )
                    }
                    {
                    isFilterPlannerOpen && (
                      <div class="gym-filter-popup" onClick={e => e.stopPropagation()} style={{ width: 300,height:'50vh',padding:8,overflowY:'auto' }}>
                        <p className='fs-16 font-weight-700 m-b-6'>Access Right</p>
                        <div className="w-full d-flex m-b-12">
                          <div onClick={handleAccessRight.bind(this, "all")} className='d-flex w-half p-r-12'>
                            <input type="radio" name="access-right" checked={sortByAccessRight == "all"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text' style={{color:'inherit'}}>All</p>
                          </div>
                          <div onClick={handleAccessRight.bind(this, "private")} className='d-flex w-half'>
                            <input type="radio" name="access-right" checked={sortByAccessRight == "private"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text' style={{color:'inherit'}}>Private</p>
                          </div>
                        </div>
                        <div onClick={handleAccessRight.bind(this, "public")} className='d-flex w-full m-b-20 gym-filter-type'>
                          <input type="radio" name="access-right" checked={sortByAccessRight == "public"} className='flex-item cursor-pointer m-r-6' />
                          <p className='filter-type-text' style={{color:'inherit'}}>Public</p>
                        </div>
                        {
                          (PlannerType == "day-workout" || PlannerType == "Workout") && [
                            // (props.PlannerType == 0 || PlannerType == "Workout") && [
                            <p className='fs-16 font-weight-700 m-b-8'>Exercise Level</p>,
                            Parameters.exerciseLevel.map(level => {
                              return (
                                <div onClick={handleSortByLevelID(level._id)} className='d-flex w-full m-b-8 gym-filter-type'>
                                  <input checked={level._id == sortByLevelID} type="radio" name="planner-level" class="flex-item cursor-pointer m-r-6" />
                                  <p className='filter-type-text' style={{color:'inherit'}}>{level.name}</p>
                                </div>
                              )
                            })
                          ]
                        }

                        <p className='fs-16 font-weight-700 m-b-12 m-t-20'>Content Role</p>
                        <div className="w-full d-flex m-b-8">
                          <div onClick={handleContentRole.bind(this, "All")} className='d-flex w-half p-r-12'>
                            <input type="radio" name="content-role" checked={ContentRole == "All"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text' style={{color:'inherit'}}>All</p>
                          </div>
                          <div onClick={handleContentRole.bind(this, "my")} className='d-flex w-half p-r-12'>
                            <input type="radio" name="content-role" checked={ContentRole == "my"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text' style={{color:'inherit'}}>My Content</p>
                          </div>
                        </div>
                        <div className="w-full d-flex m-b-8">
                          <div onClick={handleContentRole.bind(this, "branch")} className='d-flex w-half p-r-12'>
                            <input type="radio" name="content-role" checked={ContentRole == "branch"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text' style={{color:'inherit'}}>Branch Content</p>
                          </div>
                        </div>
                        <div onClick={handleContentRole.bind(this, "instafit")} className='d-flex'>
                          <input type="radio" name="content-role" checked={ContentRole == "instafit"} className='flex-item cursor-pointer m-r-6' />
                          <p className='filter-type-text' style={{color:'inherit'}}>Workout Plus Content</p>
                        </div>
                      </div>
                    )
                  }
                  </div>
                  
                </div>
                  
                {
                  PlannerType != "Nutrition" && (
                    <div className="w-full d-flex m-b-20">
                      <div onClick={()=> handlePlannerType("Workout")} className={`member-button-global btn-center d-flex m-r-12`} style={{background: PlannerType == "Workout" ? "var(--darkBlue)" : "#f5f5f5", width:"auto"}}>
                        <p className="flex-item" style={{color: PlannerType == "Workout" ? "#ffffff" : "#000000", fontWeight:"600"}}>Calendar</p>
                      </div>
                      <div onClick={()=> handlePlannerType("day-workout")} className={`member-button-global btn-center d-flex`} style={{background: PlannerType == "day-workout" ? "var(--darkBlue)" : "#f5f5f5", width:"auto"}}>
                        <p className="flex-item" style={{color: PlannerType == "day-workout" ? "#ffffff" : "#000000", fontWeight:"600"}}>Day</p>
                      </div>
                      {/* <div onClick={()=> handlePlannerType("Workout")} className='d-flex w-half p-r-12'>
                        <input type="radio" name="workout-right" checked={PlannerType == "Workout"} className='flex-item cursor-pointer m-r-6' />
                        <p className='filter-type-text' style={{color:'inherit'}}>Calendar</p>
                      </div>
                      <div onClick={()=> handlePlannerType("day-workout")} className='d-flex w-half'>
                        <input type="radio" name="workout-right" checked={PlannerType == "day-workout"} className='flex-item cursor-pointer m-r-6' />
                        <p className='filter-type-text' style={{color:'inherit'}}>Day</p>
                      </div> */}
                    </div>
                  )
                }

                <p className='m-b-16 fs-18 font-weight-700 color-red'>Select Planner</p>
                <div onScroll={handlePlannerScroll} className={window.innerWidth > 767 ? 'search-gym-modal-scroll' : ''} style={{padding: "0 0 100px 0", height:"60vh", overflowY:"auto"}}>
                  {
                    !isReload && Planners.map((planner, index) => {
                      return (
                        <div onClick={() => handleSelectPlanner(index)} className='d-flex w-full p-b-12 p-t-12 cursor-pointer' style={{borderBottom:"1px solid #e0e0e0"}}>
                          {
                            isSelectedPlannerIndex == index ? (
                              <svg className='flex-item cursor-pointer' style={{alignSelf: "flex-start"}} width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="white" stroke="var(--darkBlue)"/>
                                <rect x="3" y="3" width="10" height="10" rx="5" fill="var(--darkBlue)"/>
                              </svg>   
                            ) : (
                              <svg className='flex-item cursor-pointer' style={{alignSelf: "flex-start"}} width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="7.25" fill="white" stroke="#AEAEAE" stroke-width="1.5"/>
                              </svg>                              
                            )
                          }
                          <div className='m-l-12' style={{alignSelf:"flex-start"}}>
                            <p className='fs-18 font-weight-600' style={{lineHeight: "22px", color: isSelectedPlannerIndex == index ? "var(--darkBlue)" : "#000000"}}>{planner.name}</p>
                            <p className='fs-12' style={{ color: "#6D6D6D" }}>{PlannerType == 'Nutrition'?`${planner.nutritionSchedules && planner.nutritionSchedules.length} Schedule(s)`:`${getExerciseCount(planner)} Exercise(s)`}</p>
                          </div>
                        </div>
                      )
                    })
                  }
                  {plannerLoaderView && <div className="loader-5 center"><span></span></div>}
                </div>
                <div className='modal-bottom-action-container d-flex' style={{background:"#ffffff"}}>
                  <div className='d-flex flex-item h-full w-full'>
                    <div className='flex-item d-flex w-full p-l-12 p-r-12'>
                      <div onClick={() => toggleMemberFilterOption('planner')} className={`member-button-global btn-center d-flex`} style={{background: "#f5f5f5", width:"50%"}}>
                        <p className="flex-item" style={{color:"#000000", fontWeight:"600"}}>Close</p>
                      </div>
                      {
                        isSelectedPlannerIndex !== -1 && (
                          <div onClick={addSelectedPlanner} className={`member-button-global btn-center d-flex `} style={{ margin: "0 0 0 20px", width:"50%"}}>
                            <p className="flex-item" style={{fontWeight:"600"}}>Add Planner</p>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
                <div className='m-b-40' />
              </div>
            ] : isCurrentMemberFilterOption == "member" ? (
              <div className='w-full'>
                <div className='w-full space-between d-flex m-b-14'>
                  <div id="search-container" className='global-search-box desktop-search-input' style={{ background: "#ffffff", boxShadow:"0px 0px 8px rgba(0, 0, 0, 0.10)", width: "100%", height: "40px", borderRadius: "20px" }}>
                    <svg id="search-icon" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1637_1318)">
                        <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1637_1318">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <input id="search-member-input" onChange={_.debounce(handleMemberSearch, 1000)} className='flex-item' style={{ background: "#ffffff" }} type="text" placeholder="Search member" />
                  </div>
                </div>
                <div onScroll={handleMemberScroll} className={window.innerWidth > 767 && 'search-gym-modal-scroll'} style={{ padding: 0, height: window.innerWidth > 767 ? "66vh" : "100%" }}>
                  {
                    Members.map((member, index) => {
                      return (
                        <div onClick={handleTempObject(member)} className="d-flex w-full p-t-12 p-b-12 cursor-pointer" style={{borderBottom:"1px solid #e0e0e0"}} >
                          {
                            (tempObjects.findIndex(d => d._id == member._id) != -1 || isMultipleMember) ? (
                              <svg className="cursor-pointer flex-item m-r-12" style={{ transition: "180ms" }} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" rx="6" fill="#0088DA"/>
                                <path d="M5 13L9.5 18L19.5 6" stroke="white" stroke-width="2" stroke-linecap="round"/>
                              </svg>
                            ) : (
                              <svg className="cursor-pointer flex-item m-r-12" style={{ transition: "180ms" }} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="white" stroke="#808080"/>
                              </svg>
                            )
                          }
                          
                          {
                            member.user.length > 0 && (
                              member.user[0].profileID ? (
                                <img className='d-flex branch-gym-logo flex-item m-r-8' src={`${client.config.API_URL}/image/file/${member.user[0].profileID}/auto/auto/auto`} />
                                //   <div className="d-flex branch-gym-logo flex-item m-r-8" style={{ background: "#5d883c" }}>
                                //   <p className="flex-item" style={{ margin: "0 auto", color: '#ffffff' }}>A</p>
                                // </div>
                              ) : (
                                <div className="d-flex branch-gym-logo flex-item m-r-8" style={{ background: "#5d883c" }}>
                                  <p className="flex-item" style={{ margin: "0 auto", color: '#ffffff' }}>{`${member.user[0].name}`.trim()[0]}</p>
                                </div>
                              )
                            )
                          }
                          <div className="flex-item">
                            <p className="fs-18 font-weight-700">{member.userInfo.name}</p>
                            {/* <p className="branch-gym-email">{member.userInfo.email}</p> */}
                          </div>
                        </div>
                      )
                    })
                  }
                  {memberLoaderView && <div className="loader-5 center"><span></span></div>}
                </div>
                <div className='modal-bottom-action-container d-flex' style={{background:"#ffffff"}}>
                  <div className='flex-item d-flex w-full space-between' style={{padding:"0 12px"}}>
                    <div onClick={() => toggleMemberFilterOption('home')} className={`member-button-global btn-center d-flex`} style={{background: "#f5f5f5", width:"48%"}}>
                      <p className="flex-item" style={{color:"#000000"}}>Close</p>
                    </div>
                    <div onClick={confirmMembers} className={`member-button-global btn-center d-flex `} style={{ margin: "0 0 0 20px", width:"48%"}}>
                      <p className="flex-item" style={{color:'inherit'}}>Add Members</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          }

        {
          isCurrentMemberFilterOption == "create-planner" && [
            // global-modal-header-container
            <div onClick={()=>{toggleMemberFilterOption("home")}} className='d-flex' style={{width:"95%"}}>
              <div className="d-flex m-r-12 table-action-btn cursor-pointer" style={{width:"34px", height:"34px", background:"var(--red)"}}>
                <svg className='flex-item margin-auto svg-stroke' width="14" height="14" viewBox="0 0 15 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2L3 11.1935L13 21" stroke="#ffffff" stroke-width="3" stroke-linecap="round"/>
                </svg>
              </div>
              <p className="flex-item fs-16 font-weight-700 color-black" style={{width:"80%"}}>{workoutPlannerExeccuteData.workoutPlanner.name}</p>
            </div>,
            <div onClick={e => e.stopPropagation()} className="no-scroll-bar p-l-2 p-r-2 p-b-12" style={{ overflow: "auto"}}>    
            <div className='m-t-12'  style={{width:"100%", height:"auto", borderRadius:"12px", padding:"12px", background:"#ffffff"}}>  
              <div className='w-full m-b-16' style={{borderBottom:"1px dashed #cbcbcb"}}>
                <p className='fs-16 font-weight-700 flex-item m-b-12 m-r-12 color-red'>Manage Exercises</p>
              </div>
              <div className='d-flex m-b-16'>
                <div onClick={() => toggleCurrentWindow("warm-up")} className='warm-cool-container m-r-20 d-flex'>
                  <p className='flex-item m-r-12'>Warm Up</p>
                  <svg className='flex-item' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(workoutPlanner.warmup.length > 0 && workoutPlanner.warmup[0].content && workoutPlanner.warmup[0].content._id) ? "#5D883C" : "#E0E0E0"} />
                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                  </svg>
                </div>
                <div onClick={() => toggleCurrentWindow("cool-down")} className='warm-cool-container d-flex'>
                  <p className='flex-item m-r-12'>Cool Down</p>
                  <svg className='flex-item' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(workoutPlanner.cooldown.length > 0 && workoutPlanner.cooldown[0].content && workoutPlanner.cooldown[0].content._id) ? "#5D883C" : "#E0E0E0"} />
                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                  </svg>
                </div>
              </div>
              <div className='d-flex'>
                <div onClick={() =>{
                    toggleCurrentWindow("weekdays-exercise");
                    setEditActive(false);
                    setDayWorkoutStorage({
                      ...dayWorkoutStorage,
                      workoutDays: dayWorkoutStorage.workoutDays.map(d=>({...d,isSelected:false}))
                    })
                }}  className='day-workout-btn cursor-pointer d-flex'>
                  <div className='flex-item m-r-30'>
                    <p className='m-b-4'>Day Workout (s)</p>
                    <p>{workoutPlanner.weekdays.length?`Planner assigned for ${workoutPlanner.weekdays.map((data,index)=>(index+1==workoutPlanner.weekdays.length)?` and ${data.dayName}`:`${index==0?'':' , '}${data.dayName}`).join("")}`:"No days Planned"}</p>
                  </div>
                  <svg className='flex-item' width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.143 1.17658C16.516 0.803596 16.9587 0.507719 17.446 0.305841C17.9333 0.103963 18.4556 3.81562e-05 18.9831 1.05049e-08C19.5106 -3.81352e-05 20.0329 0.103811 20.5202 0.305618C21.0075 0.507426 21.4504 0.803239 21.8234 1.17617C22.1964 1.5491 22.4923 1.99184 22.6941 2.47912C22.896 2.96639 23 3.48866 23 4.0161C23 4.54354 22.8962 5.06583 22.6944 5.55313C22.4925 6.04044 22.1967 6.48322 21.8238 6.85621L21.0828 7.59635L15.4028 1.91672L16.143 1.17658ZM14.2412 3.0791L1.93662 15.3847C1.52233 15.7987 1.23648 16.3236 1.11346 16.8962L0.0183858 22.0057C-0.010493 22.1399 -0.00528421 22.2792 0.0335362 22.4108C0.0723567 22.5425 0.143551 22.6623 0.240615 22.7594C0.337679 22.8565 0.457518 22.9276 0.589184 22.9665C0.72085 23.0053 0.860144 23.0105 0.994342 22.9816L6.10414 21.8866C6.67679 21.7636 7.2017 21.4778 7.61573 21.0635L19.922 8.7579L14.2412 3.0791Z" fill="black"/>
                  </svg>
                </div>
              </div>
            </div>
            <div className='footer-absolute-container'  style={{background:"#ffffff"}}>
              <div onClick={isButtonLock ? null : ()=>{
                  setWorkoutPlannerExecuteData({
                  ...workoutPlannerExeccuteData,
                  workoutPlanner:{...workoutPlanner}
                });
                toggleMemberFilterOption("home")
              }} className={`member-button-global ${isButtonLock ? "member-button-global-inactive" : ""} btn-center d-flex`}>
                <p className="flex-item">{"Save Changes"}</p>
              </div>
            </div>
          </div>
          ]
        }
        {
          isCurrentMemberFilterOption == "warm-up" && [
            <div className="w-full m-b-12">
              <p className="flex-item fs-18 color-dark-blue font-weight-700">Warm Up</p>
            </div>,
            <div onClick={e => e.stopPropagation()} className="no-scroll-bar p-b-12" style={{ overflow: "auto", padding: window.innerWidth > 767 && "2px" }}>
              {
                workoutPlanner.warmup.map((exercise, index) => {
                  return (
                    <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: selectedExerciseIndex == index ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                      <div className='d-flex w-full space-between'>
                        <div className='d-flex' style={{ width: "80%" }}>
                          <p className='planner-exercise-name fs-18' style={{ maxWidth: "75%" }}>{(exercise.content && exercise.content._id) ? exercise.content.name : "Select Exercise"}</p>
                          <svg className='m-l-16 m-t-2' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                            <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                          </svg>
                        </div>

                        {
                          exercise.content._id && selectedExerciseIndex == index && (
                            <div className='d-flex'>
                              <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                </svg>
                              </div>
                              <div className='m-r-20 d-flex'>
                                <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content)} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                </svg>
                              </div>
                            </div>
                          )
                        }

                        {
                          exercise && !exercise.content._id  && (
                            <div onClick={toggleExerciseContentManageWindow(-1, {}, index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                            </div>
                          )
                        }

                        {
                          index == 0 && exercise && exercise.content._id && (
                            <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                              <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                            </svg>
                          )
                        }

                        {
                          index > 0 && (
                            <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                              <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                            </svg>
                          )
                        }
                        

                      </div>

                      {
                        (selectedExerciseIndex == index && exercise.content._id) && [
                          <div className='exercise-container-saperator' />,
                          exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{fontWeight: 'bold'}}>Optional</p>,
                          exercise.optionalExercises.map((optionalExercise, opindex) => {
                            return (
                              <div className='d-flex w-full space-between m-b-16'>
                                <div className='d-flex' style={{ width: "80%" }}>
                                  <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise._id) ? optionalExercise.name : "Select Exercise"}</p>
                                  <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise._id) ? "#5D883C" : "#E0E0E0"} />
                                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                  </svg>
                                </div>
                                <div className='d-flex'>
                                  {
                                    optionalExercise._id && [
                                      <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                        <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                        </svg>
                                      </div>,
                                      <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise)} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                      </svg>
                                    ]
                                  }


                                  {
                                    !optionalExercise._id && (
                                      <div onClick={toggleExerciseContentManageWindow(opindex, {})} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                      </div>
                                    )
                                  }

                                  <svg onClick={handleRemoveOptionalExercise(opindex)} className='flex-item' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                    <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                  </svg>
                                </div>
                              </div>
                            )
                          }),
                          (exercise.optionalExercises.length == 0) && (
                            <div onClick={()=>handleAddOptionalExerise(0)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                            </div>
                          ),
                          (exercise.optionalExercises.length == 1) && (
                            <div onClick={()=>handleAddOptionalExerise(1)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                            </div>
                          )
                        ]
                      }
                    </div>
                  )
                })
              }
              {
                workoutPlanner.warmup.length < 10 && (
                  <div onClick={handleAddExercise} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                    <p className="flex-item">Add More Exercise(s)</p>
                  </div>
                )
              }

            </div>,
            <div className='footer-absolute-container p-b-20'>
       
              <div className='d-flex'>
                <div className='d-flex flex-item p-r-16' style={{margin: "0 0 0 auto"}}>
                  <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`} style={{background:"#9a9a9a"}}>
                    <p className='flex-item fs-16' style={{ fontWeight: 500 }}>Close</p>
                  </div>
                  {
                    workoutPlanner.warmup.length > 0 && workoutPlanner.warmup[0].content && workoutPlanner.warmup[0].content._id && [
                      <div className='m-l-12'/>,
                      <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`}>
                        <p className='flex-item fs-16' style={{ fontWeight: 500, whiteSpace:"nowrap" }}>Save & Continue</p>
                      </div>
                    ]
                  }
                </div>
              </div>

            </div>
          ]
        }
        {
          isCurrentMemberFilterOption == "cool-down" && [
            <div className="d-flex w-full global-modal-header-container">
              <p className="flex-item modal-header-text m-t-6">Cool Down</p>
            </div>,
            <div onClick={e => e.stopPropagation()} className="no-scroll-bar p-l-2 p-r-2 p-b-12" style={{ overflow: "auto", padding: window.innerWidth > 767 && "12px"}}>
              {
                workoutPlanner.cooldown.map((exercise, index) => {
                  return (
                    <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: selectedExerciseIndex == index ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                      <div className='d-flex w-full space-between'>
                        <div className='d-flex' style={{ width: "80%" }}>
                          <p className='planner-exercise-name fs-18' style={{ maxWidth: "75%", fontWeight: 'bold' }}>{(exercise.content && exercise.content._id) ? exercise.content.name : "Select Exercise"}</p>
                          <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                            <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                          </svg>
                        </div>

                        {
                          exercise.content._id && selectedExerciseIndex == index && (
                            <div className='d-flex'>
                              <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                </svg>
                              </div>
                              {/* <div className='m-r-20 d-flex'>
                                <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content)} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                </svg>
                              </div>
*/}

                            </div>
                          )
                        }

                        {
                          exercise && !exercise.content._id && (
                            <div onClick={toggleExerciseContentManageWindow(-1, {}, index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                            </div>
                          )
                        }

                        {
                          index == 0 && exercise && exercise.content._id && (
                            <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                              <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                            </svg>
                          )
                        }

                        {
                          index > 0 && (
                            <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                              <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                            </svg>
                          )
                        }
                      </div>

                      {
                        (selectedExerciseIndex == index && exercise.content._id) && [
                          <div className='exercise-container-saperator' />,
                          exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{
                            fontWeight: 'bold'
                          }}>Optional</p>,
                          exercise.optionalExercises.map((optionalExercise, opindex) => {
                            return (
                              <div className='d-flex w-full space-between m-b-16'>
                                <div className='d-flex' style={{ width: "80%" }}>
                                  <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise._id) ? optionalExercise.name : "Select Exercise"}</p>
                                  <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise._id) ? "#5D883C" : "#E0E0E0"} />
                                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                  </svg>
                                </div>
                                <div className='d-flex'>
                                  {
                                    optionalExercise._id && [
                                      <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                        <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                        </svg>
                                      </div>,
                                      <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise)} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                      </svg>
                                    ]
                                  }


                                  {
                                    !optionalExercise._id && (
                                      <div onClick={toggleExerciseContentManageWindow(opindex, {})} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                      </div>
                                    )
                                  }

                                  <svg onClick={handleRemoveOptionalExercise(opindex)} className='flex-item' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                    <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                  </svg>
                                </div>
                              </div>
                            )
                          }),
                          (exercise.optionalExercises.length == 0) && (
                            <div onClick={()=>handleAddOptionalExerise(0)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                            </div>
                          ),
                          (exercise.optionalExercises.length == 1) && (
                            <div onClick={()=>handleAddOptionalExerise(1)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                            </div>
                          )
                        ]
                      }
                    </div>
                  )
                })
              }
              {
                workoutPlanner.cooldown.length < 10 && (
                  <div onClick={handleAddExercise} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                    <p className="flex-item">Add More Exercise(s)</p>
                  </div>
                )
              }
            </div>,
            <div className='footer-absolute-container p-l-20 p-b-20'>
              <div className='d-flex'>
                <div className='d-flex flex-item p-r-16' style={{margin: "0 0 0 auto"}}>
                  <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`} style={{background:"#9a9a9a"}}>
                    <p className='flex-item fs-16' style={{ fontWeight: 500 }}>Close</p>
                  </div>
                  {
                    workoutPlanner.cooldown.length > 0 && workoutPlanner.cooldown[0].content && workoutPlanner.cooldown[0].content._id && [
                      <div className='m-l-12'/>,
                      <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`}>
                        <p className='flex-item fs-16' style={{ fontWeight: 500, whiteSpace:"nowrap" }}>Save & Continue</p>
                      </div>
                    ]
                  }
                </div>
              </div>
            </div>
          ]
        }
        {
          isCurrentMemberFilterOption == "weekdays-exercise" && [
            // global-modal-header-container
            <div className="w-full">
              <div className='d-flex space-between'>
                <div className='flex-item' style={{textAlign:"left"}}>
                  <p className='day-workout-txt'>{(isEditActive && dayWorkoutStorage.workoutDays.filter(d=>d.isSelected).length)?"Edit "+ (dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name == "Mon" ? "Monday" : dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name == "Tue" ? "Tuesday" : dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name == "Wed" ? "Wednesday" : dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name == "Thu" ? "Thursday" : dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name == "Fri" ? "Friday" : dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name == "Sat" ? "Saturday" : dayWorkoutStorage.workoutDays.filter(d=>d.isSelected)[0].name) :`Day's of workout`}</p>
                  <p className='day-workout-sub-txt m-t-4'>{isEditActive?'Updating day exercises':'You can select multiple days & add workout'}</p>
                </div>
              </div>
              {!isEditActive && dayWorkoutStorage.workoutDays.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1).length>0 && <div className='d-flex-wrap m-t-20'>
                {
                  dayWorkoutStorage.workoutDays.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1).map((data, index) => {
                    return(
                        <div onClick={() => handleSelectWorkoutDay(data.name,false)} className={`${data.isSelected ? "day-chips day-chips-active" : "day-chips"} d-flex cursor-pointer m-r-10 m-b-16`} style={{width:"58px", height: "30px", padding: "0"}}>
                          <p className='flex-item' style={{margin:"0 auto"}}>{data.name}</p>
                        </div>
                      )
                    }
                  )
                }
              </div>}
              {
                dayWorkoutStorage.workoutDays.length < 6 && (
                  <p className='days-note-txt' style={{textAlign:"left"}}>*Note - You can add up to 6 days</p>
                )
              }
            </div>,

            // height:!isEditActive &&dayWorkoutStorage.workoutDays.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1).length>0?"75%":'95%' 
            // style={{marginTop: dayWorkoutStorage.workoutDays.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1 && !isEditActive).length>0?"20%":'5%'}}
            <div className="no-scroll-bar p-l-2 p-r-2 p-b-80 m-t-16" >
              {
                dayWorkoutStorage.workoutDays.filter(data => data.isSelected == true).length > 0 && (
                  <div className='w-full'>
                  <p className='fs-16 m-b-8' style={{color:"var(--darkBlue)", fontWeight:"600"}}>Plan workout for {" "} 
                    {dayWorkoutStorage.workoutDays[0].isSelected && dayWorkoutStorage.workoutDays.slice(1, 5).findIndex(item => item.isSelected == true) !== -1  ? "Mon, " 
                    : dayWorkoutStorage.workoutDays[0].isSelected ? "Mon" 
                    : null} 
                    
                    {dayWorkoutStorage.workoutDays[1].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(2, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(2, 6).filter(item => item.isSelected == true).length > 1 ? "Tue, " 
                    : dayWorkoutStorage.workoutDays[1].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(2, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(2, 6).filter(item => item.isSelected == true).length == 1 ? "Tue & " 
                    : dayWorkoutStorage.workoutDays[1].isSelected ? "Tue" :
                    null}

                    {dayWorkoutStorage.workoutDays[2].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(3, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(3, 6).filter(item => item.isSelected == true).length > 1 ? "Wed, " 
                    : dayWorkoutStorage.workoutDays[2].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(3, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(3, 6).filter(item => item.isSelected == true).length == 1 ? "Wed & " 
                    : dayWorkoutStorage.workoutDays[2].isSelected ? "Wed" :
                    null} 

                    {dayWorkoutStorage.workoutDays[3].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(4, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(4, 6).filter(item => item.isSelected == true).length > 1 ? "Thu, " 
                    : dayWorkoutStorage.workoutDays[3].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(4, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(4, 6).filter(item => item.isSelected == true).length == 1 ? "Thu & " 
                    : dayWorkoutStorage.workoutDays[3].isSelected ? "Thu" :
                    null} 

                    {dayWorkoutStorage.workoutDays[4].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(5, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(5, 6).filter(item => item.isSelected == true).length > 1 ? "Fri, " 
                    : dayWorkoutStorage.workoutDays[4].isSelected && 
                    dayWorkoutStorage.workoutDays.slice(5, 6).findIndex(item => item.isSelected == true) !== -1 && 
                    dayWorkoutStorage.workoutDays.slice(5, 6).filter(item => item.isSelected == true).length == 1 ? "Fri & " 
                    : dayWorkoutStorage.workoutDays[4].isSelected ? "Fri" :
                    null} 

                    {dayWorkoutStorage.workoutDays[5].isSelected && "Sat"}
                    </p>

                    <div onClick={toggleInputFields("exercise-display-name")} className={`${(currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "1px solid var(--darkBlue)" : "" }}>
                      <div className="flex-item d-flex">
                        <svg className='m-r-4 flex-item' width={(currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "12" : "18"} height={(currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.955 6.969L16.267 6.281L17.17 5.332L13.817 1.979L12.868 2.882L12.155 2.169L13.767 0.507L18.617 5.357L16.955 6.969ZM0.543 13.806L2.155 12.194L2.868 12.907L1.958 13.811L5.338 17.191L6.242 16.281L6.955 16.994L5.343 18.606L0.543 13.806ZM15.707 11.171L17.709 9.169L9.98 1.44L7.978 3.442L15.707 11.171ZM9.13 17.748L11.151 15.721L3.428 7.998L1.401 10.019L9.13 17.748ZM8.865 12.032L11.999 8.904L10.245 7.15L7.117 10.284L8.865 12.032ZM12.578 15.74L9.13 19.15L0 10.019L3.409 6.571L6.403 9.571L9.538 6.436L6.557 3.442L9.999 0L19.149 9.15L15.707 12.592L12.713 9.612L9.578 12.746L12.578 15.74Z" fill={(currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "var(--darkBlue)" : "#6d6d6d"}/>
                        </svg>
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "10px" : "14px", color: (currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Workout Display Name *</p>
                      </div>
                      <input id="exercise-display-name" value={dayWorkoutStorage.displayName} onInput={handleWeekDayWorkoutDisplayName} className={`${(currentElementId == "exercise-display-name" || dayWorkoutStorage.displayName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Enter Name" style={{ textTransform: 'capitalize' }} />
                    </div>

                    {
                      dayWorkoutStorage.exercises.map((exercise, index) => {
                        return (
                          <div className='planner-exercise-container m-b-12' onClick={handleSelectExercise(index)} style={{ position: 'relative', backgroundColor: selectedExerciseIndex == index ? "#ffffff" : "#f5f5f5" }}>
                            <div className='d-flex w-full space-between'>
                              <div className='d-flex' style={{ width: "80%" }}>
                                <svg style={{transform: (!exercise.isDropdownOpen) ? 'rotate(0deg)' : 'rotate(180deg)' }} className='flex-item m-r-12' width="16" height="11" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.00098 1L6.50098 6.5L12.501 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                                <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{exercise.content.name ? exercise.content.name : "Select Exercise"}</p>
                                <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={exercise.content._id ? "#5d883c" : "#E0E0E0"} />
                                  <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                </svg>
                              </div>

                              {
                                (exercise.content._id && selectedExerciseIndex == index) && (
                                  <div className='d-flex'>
                                    <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                      <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                      </svg>
                                    </div>
                                    <div className='m-r-20 d-flex'>
                                      <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content)} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                      </svg>
                                    </div>
                                  </div>
                                )
                              }

                              {
                                exercise && !exercise.content._id && (
                                  <div onClick={toggleExerciseContentManageWindow(-1, {}, index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                    <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                  </div>
                                )
                              }

                              {index>0 && <svg onClick={event=> {removeDayExercise(index); event.stopPropagation()}} className='flex-item' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                              </svg>}
                              
                            </div>
                            {
                              (selectedExerciseIndex == index && exercise.isDropdownOpen && exercise.parameter && exercise.parameter.isParameterAdded) && [
                                (exercise.parameter.unit == "weight") && [
                                  <div className='d-flex m-t-12 m-b-8'>
                                    <div className='d-flex' style={{ width: "120px" }}>
                                      <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_683_1507)">
                                          <path d="M10.5 10.5V2.25H7.5V10.5H6V5.25H3V10.5H1.5V0.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H11.25V10.5H10.5ZM8.25 3H9.75V6.75H8.25V3ZM3.75 6H5.25V8.25H3.75V6Z" fill="var(--darkBlue)" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_683_1507">
                                            <rect width="12" height="12" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      <p className='flex-item sub-txt-title'>Set</p>
                                    </div>
                                    <p className='flex-item sub-txt-value'>{exercise.parameter.set ? exercise.parameter.set.length : 0}</p>
                                  </div>],
                                  (exercise.parameter.unit == "distance") && <div className='d-flex m-t-12'>
                                    <div className='d-flex' style={{ width: "120px" }}>
                                      <svg className='flex-item m-r-8 svg-fill' width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke="var(--darkBlue)" />
                                      </svg>
                                      <p className='flex-item sub-txt-title'>Distance</p>
                                    </div>
                                    <p className='flex-item sub-txt-value'>{(exercise.parameter.distance && exercise.parameter.distance.value) ? exercise.parameter.distance.value : 0} {(exercise.parameter.distance && exercise.parameter.distance.unit) ? exercise.parameter.distance.unit : "Km"}</p>
                                  </div>,
                                  (exercise.parameter.unit == "number") && <div className='d-flex m-t-12'>
                                    <div className='d-flex' style={{ width: "120px" }}>
                                      <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.20041 2.6999C1.20041 2.62034 1.23202 2.54403 1.28828 2.48777C1.34454 2.43151 1.42084 2.3999 1.50041 2.3999H10.5004C10.58 2.3999 10.6563 2.43151 10.7125 2.48777C10.7688 2.54403 10.8004 2.62034 10.8004 2.6999C10.8004 2.77947 10.7688 2.85577 10.7125 2.91203C10.6563 2.9683 10.58 2.9999 10.5004 2.9999H1.50041C1.42084 2.9999 1.34454 2.9683 1.28828 2.91203C1.23202 2.85577 1.20041 2.77947 1.20041 2.6999ZM1.20041 5.6999C1.20041 5.62034 1.23202 5.54403 1.28828 5.48777C1.34454 5.43151 1.42084 5.3999 1.50041 5.3999H10.5004C10.58 5.3999 10.6563 5.43151 10.7125 5.48777C10.7688 5.54403 10.8004 5.62034 10.8004 5.6999C10.8004 5.77947 10.7688 5.85577 10.7125 5.91203C10.6563 5.9683 10.58 5.9999 10.5004 5.9999H1.50041C1.42084 5.9999 1.34454 5.9683 1.28828 5.91203C1.23202 5.85577 1.20041 5.77947 1.20041 5.6999ZM4.55321 7.7999C4.18541 7.7999 3.89741 8.1329 3.89741 8.4815C3.89741 8.56107 3.8658 8.63737 3.80954 8.69363C3.75328 8.7499 3.67697 8.7815 3.59741 8.7815C3.51784 8.7815 3.44154 8.7499 3.38528 8.69363C3.32902 8.63737 3.29741 8.56107 3.29741 8.4815C3.29741 7.8491 3.80861 7.1999 4.55321 7.1999C4.99121 7.1999 5.41061 7.4057 5.64341 7.7663C5.88581 8.1407 5.89661 8.6315 5.60921 9.1241C5.46281 9.3743 5.26121 9.5651 5.06081 9.7241C4.96121 9.8039 4.85741 9.8777 4.75901 9.9479L4.71701 9.9779C4.63241 10.0379 4.55261 10.0943 4.47521 10.1525C4.21181 10.3523 4.02101 10.5413 3.94061 10.7999H5.49641C5.57597 10.7999 5.65228 10.8315 5.70854 10.8878C5.7648 10.944 5.79641 11.0203 5.79641 11.0999C5.79641 11.1795 5.7648 11.2558 5.70854 11.312C5.65228 11.3683 5.57597 11.3999 5.49641 11.3999H3.59681C3.51724 11.3999 3.44094 11.3683 3.38468 11.312C3.32842 11.2558 3.29681 11.1795 3.29681 11.0999C3.29681 10.3829 3.71141 9.9779 4.11281 9.6743C4.19801 9.6101 4.28621 9.5471 4.37021 9.4883L4.41101 9.4583C4.50881 9.3893 4.60061 9.3227 4.68701 9.2543C4.86101 9.1163 4.99781 8.9801 5.09021 8.8211C5.28101 8.4959 5.24141 8.2499 5.13941 8.0927C5.02841 7.9211 4.81001 7.7999 4.55261 7.7999H4.55321ZM7.24301 7.9619C7.16101 8.03544 7.10116 8.1304 7.07021 8.2361C7.05962 8.27418 7.0416 8.3098 7.0172 8.34089C6.9928 8.37199 6.96249 8.39796 6.92802 8.41731C6.89356 8.43666 6.8556 8.449 6.81635 8.45363C6.77709 8.45827 6.73731 8.4551 6.69928 8.44431C6.66126 8.43352 6.62574 8.41532 6.59477 8.39075C6.5638 8.36619 6.53799 8.33575 6.51882 8.30118C6.49965 8.26661 6.4875 8.2286 6.48307 8.18932C6.47864 8.15004 6.48202 8.11027 6.49301 8.0723C6.53861 7.9109 6.64181 7.6925 6.84461 7.5125C7.05341 7.3277 7.34921 7.1999 7.74521 7.1999C8.55161 7.1999 9.00941 7.7903 9.00941 8.3183C9.00941 8.5295 8.96861 8.8541 8.75081 9.1301C8.70761 9.1841 8.65901 9.2351 8.60501 9.2813C8.68601 9.3413 8.76221 9.4157 8.82641 9.5063C8.94401 9.6725 9.00941 9.8777 9.00941 10.1183C9.00941 10.5563 8.86301 10.8923 8.60261 11.1143C8.35061 11.3273 8.03261 11.3999 7.74521 11.3999C7.47401 11.3999 7.20941 11.3543 6.98201 11.2097C6.74921 11.0615 6.59261 10.8329 6.49601 10.5389C6.48376 10.5014 6.479 10.4619 6.48202 10.4226C6.48504 10.3833 6.49577 10.345 6.5136 10.3098C6.53143 10.2747 6.55601 10.2434 6.58593 10.2177C6.61586 10.1921 6.65054 10.1726 6.68801 10.1603C6.72547 10.1481 6.76499 10.1433 6.80429 10.1463C6.84359 10.1493 6.88192 10.1601 6.91707 10.1779C6.95223 10.1957 6.98353 10.2203 7.00919 10.2502C7.03484 10.2801 7.05436 10.3148 7.06661 10.3523C7.13081 10.5485 7.21541 10.6475 7.30421 10.7039C7.39841 10.7639 7.53461 10.7999 7.74521 10.7999C7.94081 10.7999 8.10401 10.7495 8.21381 10.6559C8.31521 10.5707 8.40941 10.4159 8.40941 10.1183C8.41417 10.0244 8.38873 9.93147 8.33681 9.8531C8.28738 9.78786 8.22183 9.73658 8.14661 9.7043C7.96841 9.6203 7.74101 9.5999 7.58501 9.5999C7.50544 9.5999 7.42914 9.5683 7.37288 9.51203C7.31662 9.45577 7.28501 9.37947 7.28501 9.2999C7.28501 9.22034 7.31662 9.14403 7.37288 9.08777C7.42914 9.03151 7.50544 8.9999 7.58501 8.9999C8.00801 8.9999 8.19161 8.8697 8.27981 8.7581C8.37881 8.6333 8.40941 8.4665 8.40941 8.3183C8.40941 8.1257 8.22461 7.7999 7.74521 7.7999C7.48721 7.7999 7.33541 7.8797 7.24301 7.9619ZM1.80701 8.6189C1.65492 8.78467 1.48396 8.93207 1.29761 9.0581C1.26495 9.08143 1.22794 9.09797 1.18878 9.10673C1.14962 9.1155 1.10909 9.11632 1.06961 9.10915C1.03012 9.10197 0.992474 9.08695 0.958898 9.06496C0.925323 9.04297 0.8965 9.01447 0.874136 8.98115C0.851772 8.94783 0.836323 8.91035 0.828701 8.87095C0.82108 8.83155 0.821442 8.79102 0.829766 8.75175C0.83809 8.71249 0.854207 8.6753 0.877163 8.64238C0.900119 8.60946 0.929446 8.58148 0.963409 8.5601C1.40321 8.2655 1.73681 7.7921 1.81421 7.4363C1.81421 7.4363 1.88021 7.1999 2.09021 7.1999C2.39141 7.1999 2.40761 7.4999 2.40761 7.4999V11.0999C2.40761 11.1795 2.376 11.2558 2.31974 11.312C2.26348 11.3683 2.18717 11.3999 2.10761 11.3999C2.02804 11.3999 1.95174 11.3683 1.89548 11.312C1.83922 11.2558 1.80761 11.1795 1.80761 11.0999V8.6189H1.80701ZM9.60041 8.6999C9.60041 8.62034 9.63202 8.54403 9.68828 8.48777C9.74454 8.43151 9.82084 8.3999 9.90041 8.3999H10.5004C10.58 8.3999 10.6563 8.43151 10.7125 8.48777C10.7688 8.54403 10.8004 8.62034 10.8004 8.6999C10.8004 8.77947 10.7688 8.85577 10.7125 8.91203C10.6563 8.9683 10.58 8.9999 10.5004 8.9999H9.90041C9.82084 8.9999 9.74454 8.9683 9.68828 8.91203C9.63202 8.85577 9.60041 8.77947 9.60041 8.6999Z" fill="var(--darkBlue)" />
                                      </svg>
                                      <p className='flex-item sub-txt-title'>Count</p>
                                    </div>
                                    <p className='flex-item sub-txt-value'>{exercise.parameter.count ? exercise.parameter.count : 0}</p>
                                  </div>,
                                  (exercise.parameter.unit == "time") && <div className='d-flex m-t-12'>
                                  <div className='d-flex' style={{ width: "120px" }}>
                                    <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_683_1515)">
                                        <path d="M6 11.25C4.96165 11.25 3.94662 10.9421 3.08326 10.3652C2.2199 9.78834 1.54699 8.9684 1.14963 8.00909C0.752275 7.04978 0.648307 5.99418 0.85088 4.97578C1.05345 3.95738 1.55347 3.02192 2.28769 2.28769C3.02192 1.55347 3.95738 1.05345 4.97578 0.85088C5.99418 0.648307 7.04978 0.752275 8.00909 1.14963C8.9684 1.54699 9.78834 2.2199 10.3652 3.08326C10.9421 3.94662 11.25 4.96165 11.25 6C11.25 7.39239 10.6969 8.72775 9.71231 9.71231C8.72775 10.6969 7.39239 11.25 6 11.25ZM6 1.5C5.10999 1.5 4.23996 1.76392 3.49994 2.25839C2.75992 2.75286 2.18314 3.45566 1.84254 4.27793C1.50195 5.10019 1.41284 6.00499 1.58647 6.87791C1.7601 7.75082 2.18869 8.55265 2.81802 9.18198C3.44736 9.81132 4.24918 10.2399 5.1221 10.4135C5.99501 10.5872 6.89981 10.4981 7.72208 10.1575C8.54434 9.81686 9.24715 9.24009 9.74162 8.50007C10.2361 7.76005 10.5 6.89002 10.5 6C10.5 4.80653 10.0259 3.66194 9.18198 2.81802C8.33807 1.97411 7.19348 1.5 6 1.5Z" fill="var(--darkBlue)" />
                                        <path d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25Z" fill="var(--darkBlue)" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_683_1515">
                                          <rect width="12" height="12" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <p className='flex-item sub-txt-title'>Duration</p>
                                  </div>
                                  <p className='flex-item sub-txt-value'>{(exercise.parameter.duration && exercise.parameter.duration.hour) ? exercise.parameter.duration.hour : 0} hr {(exercise.parameter.duration && exercise.parameter.duration.min) ? exercise.parameter.duration.min : 0} min</p>
                                </div>
                              ]
                            }
                            {
                              (selectedExerciseIndex > -1 && selectedExerciseIndex == index && exercise.content && exercise.content._id) && [
                                <div className='exercise-container-saperator' />,
                                exercise.optionalExercises && exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{
                                  fontWeight: 'bold'
                                }}>Optional</p>,
                                exercise.optionalExercises && exercise.optionalExercises.map((optionalExercise, opindex) => {
                                  return [
                                    <div className='d-flex w-full space-between m-b-16' onClick={e => {
                                      toggleWeekDayDropdown(index, opindex)
                                      e.stopPropagation()
                                    }}>
                                      <div className='d-flex' style={{ width: "80%" }}>
                                        <svg style={{
                                          transform: optionalExercise.isDropdownOpen ? "rotate(0deg)" : "rotate(180deg)"
                                        }} className='flex-item m-r-12' width="16" height="11" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.00098 1L6.50098 6.5L12.501 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                        </svg>
                                        <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise.content && optionalExercise.content._id) ? optionalExercise.content.name : "Select Exercise"}</p>
                                        <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise.content && optionalExercise.content._id) ? "#5d883c" : "#E0E0E0"} />
                                          <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                        </svg>
                                      </div>
                                      <div className='d-flex'>
                                        {
                                          optionalExercise.content && optionalExercise.content._id && [
                                            <div onClick={toggleVideoPlayer.bind(this, optionalExercise.content)} className='d-flex planner-play-exercise m-r-20'>
                                              <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                              </svg>
                                            </div>,
                                            <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise.content)} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                            </svg>
                                          ]
                                        }


                                        {
                                          optionalExercise.content && !optionalExercise.content._id && (
                                            <div onClick={toggleExerciseContentManageWindow(opindex, {})} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                              <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                            </div>
                                          )
                                        }

                                        <svg onClick={handleRemoveOptionalWeekDayExercise(opindex)} className='flex-item' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                          <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                        </svg>
                                      </div>
                                    </div>,
                                    (optionalExercise.isDropdownOpen && optionalExercise.parameter && optionalExercise.parameter.isParameterAdded) && [
                                      optionalExercise.parameter && optionalExercise.parameter.unit == "weight" && [
                                        <div className='d-flex m-t-12 m-b-12'>
                                          <div className='d-flex' style={{ width: "120px" }}>
                                            <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <g clip-path="url(#clip0_683_1507)">
                                                <path d="M10.5 10.5V2.25H7.5V10.5H6V5.25H3V10.5H1.5V0.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H11.25V10.5H10.5ZM8.25 3H9.75V6.75H8.25V3ZM3.75 6H5.25V8.25H3.75V6Z" fill="var(--darkBlue)" />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_683_1507">
                                                  <rect width="12" height="12" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <p className='flex-item sub-txt-title'>Set</p>
                                          </div>
                                          <p className='flex-item sub-txt-value'>{optionalExercise.parameter.set ? optionalExercise.parameter.set.length : 0}</p>
                                        </div>],
                                      optionalExercise.parameter.unit == "distance" && <div className='d-flex m-t-12 m-b-14'>
                                        <div className='d-flex' style={{ width: "120px" }}>
                                          <svg className='flex-item m-r-8 svg-fill' width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke="var(--darkBlue)" />
                                          </svg>
                                          <p className='flex-item sub-txt-title'>Distance</p>
                                        </div>
                                        <p className='flex-item sub-txt-value'>{optionalExercise.parameter.distance.value ? optionalExercise.parameter.distance.value : 0} {optionalExercise.parameter.distance.unit ? optionalExercise.parameter.distance.unit : "KM"}</p>
                                      </div>,
                                      optionalExercise.parameter.unit == "number" && <div className='d-flex m-t-12 m-b-14'>
                                        <div className='d-flex' style={{ width: "120px" }}>
                                          <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.20041 2.6999C1.20041 2.62034 1.23202 2.54403 1.28828 2.48777C1.34454 2.43151 1.42084 2.3999 1.50041 2.3999H10.5004C10.58 2.3999 10.6563 2.43151 10.7125 2.48777C10.7688 2.54403 10.8004 2.62034 10.8004 2.6999C10.8004 2.77947 10.7688 2.85577 10.7125 2.91203C10.6563 2.9683 10.58 2.9999 10.5004 2.9999H1.50041C1.42084 2.9999 1.34454 2.9683 1.28828 2.91203C1.23202 2.85577 1.20041 2.77947 1.20041 2.6999ZM1.20041 5.6999C1.20041 5.62034 1.23202 5.54403 1.28828 5.48777C1.34454 5.43151 1.42084 5.3999 1.50041 5.3999H10.5004C10.58 5.3999 10.6563 5.43151 10.7125 5.48777C10.7688 5.54403 10.8004 5.62034 10.8004 5.6999C10.8004 5.77947 10.7688 5.85577 10.7125 5.91203C10.6563 5.9683 10.58 5.9999 10.5004 5.9999H1.50041C1.42084 5.9999 1.34454 5.9683 1.28828 5.91203C1.23202 5.85577 1.20041 5.77947 1.20041 5.6999ZM4.55321 7.7999C4.18541 7.7999 3.89741 8.1329 3.89741 8.4815C3.89741 8.56107 3.8658 8.63737 3.80954 8.69363C3.75328 8.7499 3.67697 8.7815 3.59741 8.7815C3.51784 8.7815 3.44154 8.7499 3.38528 8.69363C3.32902 8.63737 3.29741 8.56107 3.29741 8.4815C3.29741 7.8491 3.80861 7.1999 4.55321 7.1999C4.99121 7.1999 5.41061 7.4057 5.64341 7.7663C5.88581 8.1407 5.89661 8.6315 5.60921 9.1241C5.46281 9.3743 5.26121 9.5651 5.06081 9.7241C4.96121 9.8039 4.85741 9.8777 4.75901 9.9479L4.71701 9.9779C4.63241 10.0379 4.55261 10.0943 4.47521 10.1525C4.21181 10.3523 4.02101 10.5413 3.94061 10.7999H5.49641C5.57597 10.7999 5.65228 10.8315 5.70854 10.8878C5.7648 10.944 5.79641 11.0203 5.79641 11.0999C5.79641 11.1795 5.7648 11.2558 5.70854 11.312C5.65228 11.3683 5.57597 11.3999 5.49641 11.3999H3.59681C3.51724 11.3999 3.44094 11.3683 3.38468 11.312C3.32842 11.2558 3.29681 11.1795 3.29681 11.0999C3.29681 10.3829 3.71141 9.9779 4.11281 9.6743C4.19801 9.6101 4.28621 9.5471 4.37021 9.4883L4.41101 9.4583C4.50881 9.3893 4.60061 9.3227 4.68701 9.2543C4.86101 9.1163 4.99781 8.9801 5.09021 8.8211C5.28101 8.4959 5.24141 8.2499 5.13941 8.0927C5.02841 7.9211 4.81001 7.7999 4.55261 7.7999H4.55321ZM7.24301 7.9619C7.16101 8.03544 7.10116 8.1304 7.07021 8.2361C7.05962 8.27418 7.0416 8.3098 7.0172 8.34089C6.9928 8.37199 6.96249 8.39796 6.92802 8.41731C6.89356 8.43666 6.8556 8.449 6.81635 8.45363C6.77709 8.45827 6.73731 8.4551 6.69928 8.44431C6.66126 8.43352 6.62574 8.41532 6.59477 8.39075C6.5638 8.36619 6.53799 8.33575 6.51882 8.30118C6.49965 8.26661 6.4875 8.2286 6.48307 8.18932C6.47864 8.15004 6.48202 8.11027 6.49301 8.0723C6.53861 7.9109 6.64181 7.6925 6.84461 7.5125C7.05341 7.3277 7.34921 7.1999 7.74521 7.1999C8.55161 7.1999 9.00941 7.7903 9.00941 8.3183C9.00941 8.5295 8.96861 8.8541 8.75081 9.1301C8.70761 9.1841 8.65901 9.2351 8.60501 9.2813C8.68601 9.3413 8.76221 9.4157 8.82641 9.5063C8.94401 9.6725 9.00941 9.8777 9.00941 10.1183C9.00941 10.5563 8.86301 10.8923 8.60261 11.1143C8.35061 11.3273 8.03261 11.3999 7.74521 11.3999C7.47401 11.3999 7.20941 11.3543 6.98201 11.2097C6.74921 11.0615 6.59261 10.8329 6.49601 10.5389C6.48376 10.5014 6.479 10.4619 6.48202 10.4226C6.48504 10.3833 6.49577 10.345 6.5136 10.3098C6.53143 10.2747 6.55601 10.2434 6.58593 10.2177C6.61586 10.1921 6.65054 10.1726 6.68801 10.1603C6.72547 10.1481 6.76499 10.1433 6.80429 10.1463C6.84359 10.1493 6.88192 10.1601 6.91707 10.1779C6.95223 10.1957 6.98353 10.2203 7.00919 10.2502C7.03484 10.2801 7.05436 10.3148 7.06661 10.3523C7.13081 10.5485 7.21541 10.6475 7.30421 10.7039C7.39841 10.7639 7.53461 10.7999 7.74521 10.7999C7.94081 10.7999 8.10401 10.7495 8.21381 10.6559C8.31521 10.5707 8.40941 10.4159 8.40941 10.1183C8.41417 10.0244 8.38873 9.93147 8.33681 9.8531C8.28738 9.78786 8.22183 9.73658 8.14661 9.7043C7.96841 9.6203 7.74101 9.5999 7.58501 9.5999C7.50544 9.5999 7.42914 9.5683 7.37288 9.51203C7.31662 9.45577 7.28501 9.37947 7.28501 9.2999C7.28501 9.22034 7.31662 9.14403 7.37288 9.08777C7.42914 9.03151 7.50544 8.9999 7.58501 8.9999C8.00801 8.9999 8.19161 8.8697 8.27981 8.7581C8.37881 8.6333 8.40941 8.4665 8.40941 8.3183C8.40941 8.1257 8.22461 7.7999 7.74521 7.7999C7.48721 7.7999 7.33541 7.8797 7.24301 7.9619ZM1.80701 8.6189C1.65492 8.78467 1.48396 8.93207 1.29761 9.0581C1.26495 9.08143 1.22794 9.09797 1.18878 9.10673C1.14962 9.1155 1.10909 9.11632 1.06961 9.10915C1.03012 9.10197 0.992474 9.08695 0.958898 9.06496C0.925323 9.04297 0.8965 9.01447 0.874136 8.98115C0.851772 8.94783 0.836323 8.91035 0.828701 8.87095C0.82108 8.83155 0.821442 8.79102 0.829766 8.75175C0.83809 8.71249 0.854207 8.6753 0.877163 8.64238C0.900119 8.60946 0.929446 8.58148 0.963409 8.5601C1.40321 8.2655 1.73681 7.7921 1.81421 7.4363C1.81421 7.4363 1.88021 7.1999 2.09021 7.1999C2.39141 7.1999 2.40761 7.4999 2.40761 7.4999V11.0999C2.40761 11.1795 2.376 11.2558 2.31974 11.312C2.26348 11.3683 2.18717 11.3999 2.10761 11.3999C2.02804 11.3999 1.95174 11.3683 1.89548 11.312C1.83922 11.2558 1.80761 11.1795 1.80761 11.0999V8.6189H1.80701ZM9.60041 8.6999C9.60041 8.62034 9.63202 8.54403 9.68828 8.48777C9.74454 8.43151 9.82084 8.3999 9.90041 8.3999H10.5004C10.58 8.3999 10.6563 8.43151 10.7125 8.48777C10.7688 8.54403 10.8004 8.62034 10.8004 8.6999C10.8004 8.77947 10.7688 8.85577 10.7125 8.91203C10.6563 8.9683 10.58 8.9999 10.5004 8.9999H9.90041C9.82084 8.9999 9.74454 8.9683 9.68828 8.91203C9.63202 8.85577 9.60041 8.77947 9.60041 8.6999Z" fill="var(--darkBlue)" />
                                          </svg>
                                          <p className='flex-item sub-txt-title'>Count</p>
                                        </div>
                                        <p className='flex-item sub-txt-value'>{optionalExercise.parameter.count ? optionalExercise.parameter.count : 0}</p>
                                      </div>,
                                      optionalExercise.parameter.unit == "time" && <div className='d-flex m-t-12 m-b-14'>
                                        <div className='d-flex' style={{ width: "120px" }}>
                                          <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_683_1515)">
                                              <path d="M6 11.25C4.96165 11.25 3.94662 10.9421 3.08326 10.3652C2.2199 9.78834 1.54699 8.9684 1.14963 8.00909C0.752275 7.04978 0.648307 5.99418 0.85088 4.97578C1.05345 3.95738 1.55347 3.02192 2.28769 2.28769C3.02192 1.55347 3.95738 1.05345 4.97578 0.85088C5.99418 0.648307 7.04978 0.752275 8.00909 1.14963C8.9684 1.54699 9.78834 2.2199 10.3652 3.08326C10.9421 3.94662 11.25 4.96165 11.25 6C11.25 7.39239 10.6969 8.72775 9.71231 9.71231C8.72775 10.6969 7.39239 11.25 6 11.25ZM6 1.5C5.10999 1.5 4.23996 1.76392 3.49994 2.25839C2.75992 2.75286 2.18314 3.45566 1.84254 4.27793C1.50195 5.10019 1.41284 6.00499 1.58647 6.87791C1.7601 7.75082 2.18869 8.55265 2.81802 9.18198C3.44736 9.81132 4.24918 10.2399 5.1221 10.4135C5.99501 10.5872 6.89981 10.4981 7.72208 10.1575C8.54434 9.81686 9.24715 9.24009 9.74162 8.50007C10.2361 7.76005 10.5 6.89002 10.5 6C10.5 4.80653 10.0259 3.66194 9.18198 2.81802C8.33807 1.97411 7.19348 1.5 6 1.5Z" fill="var(--darkBlue)" />
                                              <path d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25Z" fill="var(--darkBlue)" />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_683_1515">
                                                <rect width="12" height="12" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <p className='flex-item sub-txt-title'>Duration</p>
                                        </div>
                                        <p className='flex-item sub-txt-value'>{optionalExercise.parameter.duration.hour ? optionalExercise.parameter.duration.hour : 0} hr {optionalExercise.parameter.duration.min ? optionalExercise.parameter.duration.min : 0} min</p>
                                      </div>
                                    ]
                                  ]
                                }),
                                (exercise.optionalExercises && exercise.optionalExercises.length < 2) && <div onClick={handleAddOptionalWeekdayExercise} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                  <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">{exercise.optionalExercises.length == 0 ? "Optional Exercise" : "Add More"}</p>
                                </div>
                              ]
                            }

                          </div>
                        )
                      })
                    }

                    {
                      dayWorkoutStorage.exercises.length < 30 && (
                        <div onClick={handleAddDayExercises} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                          <p className="flex-item">Add More Exercise(s)</p>
                        </div>
                      )
                    }
                  </div>
                )
              }

              {
                dayWorkoutStorage.workoutDays.filter(data => data.isSelected == true).length == 0 && workoutPlanner.weekdays.filter(data => data.dayName).length > 0 && (
                  <div className='w-full'>
                    <p className='fs-16 m-b-8' style={{color:"var(--darkBlue)", fontWeight:"600"}}>Workout Planned</p>
                    {
                      workoutPlanner.weekdays.map(data => {
                        return(
                          <div className='planned-workout-days-container d-flex space-between m-b-14'>
                            <div className='flex-item'>
                              <p className='day-txt m-b-6'>{data.dayName == "Mon" ? "Monday" : data.dayName == "Tue" ? "Tuesday" : data.dayName == "Wed" ? "Wednesday" : data.dayName == "Thu" ? "Thursday" : data.dayName == "Fri" ? "Friday" : data.dayName == "Sat" ? "Saturday" : data.dayName }</p>
                              <p className='day-name m-b-2'>{data.displayName}</p>
                              <p className='total-exercises-txt'>{data.exercises.length} Exercises</p>
                            </div>
                            <div className='d-flex m-t-6' style={{alignSelf:"flex-start"}}>
                              <svg onClick={handleDayRemove(data.dayName)} className='flex-item cursor-pointer m-r-12 global-fill-svg' width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.98857 18C2.48114 18 2.04686 17.8193 1.68571 17.4578C1.32381 17.0971 1.14286 16.6634 1.14286 16.1566V2.02029H0.571429C0.409143 2.02029 0.273524 1.9655 0.164571 1.85593C0.0556191 1.74635 0.000761905 1.61053 0 1.44845C0 1.28713 0.0548572 1.15168 0.164571 1.04211C0.274286 0.933291 0.409905 0.878884 0.571429 0.878884H4.57143C4.57143 0.642993 4.65905 0.43754 4.83429 0.262524C5.00952 0.0875079 5.21524 0 5.45143 0H10.5486C10.7848 0 10.9905 0.0875079 11.1657 0.262524C11.341 0.43754 11.4286 0.642993 11.4286 0.878884H15.4286C15.5909 0.878884 15.7265 0.933672 15.8354 1.04325C15.9451 1.15282 16 1.28865 16 1.45073C16 1.61205 15.9451 1.7475 15.8354 1.85707C15.7265 1.96588 15.5909 2.02029 15.4286 2.02029H14.8571V16.1566C14.8571 16.6634 14.6762 17.0971 14.3143 17.4578C13.9531 17.8193 13.5189 18 13.0114 18H2.98857ZM13.7143 2.02029H2.28571V16.1566C2.28571 16.3613 2.35162 16.5295 2.48343 16.6611C2.61524 16.7928 2.78362 16.8586 2.98857 16.8586H13.0114C13.2164 16.8586 13.3848 16.7928 13.5166 16.6611C13.6484 16.5295 13.7143 16.3613 13.7143 16.1566V2.02029ZM6.06629 14.5758C6.22857 14.5758 6.36419 14.521 6.47314 14.4114C6.58286 14.3018 6.63771 14.1664 6.63771 14.0051V4.87381C6.63771 4.71173 6.58286 4.57628 6.47314 4.46747C6.36343 4.35866 6.22743 4.30387 6.06514 4.30311C5.90286 4.30311 5.76724 4.35789 5.65829 4.46747C5.54933 4.57705 5.49486 4.71249 5.49486 4.87381V14.0051C5.49486 14.1672 5.54971 14.3026 5.65943 14.4114C5.76914 14.5202 5.90476 14.575 6.06629 14.5758ZM9.93486 14.5758C10.0971 14.5758 10.2328 14.521 10.3417 14.4114C10.4507 14.3018 10.5051 14.1664 10.5051 14.0051V4.87381C10.5051 4.71173 10.4503 4.57628 10.3406 4.46747C10.2309 4.35866 10.0952 4.30387 9.93372 4.30311C9.77143 4.30311 9.63581 4.35789 9.52686 4.46747C9.41714 4.57705 9.36229 4.71249 9.36229 4.87381V14.0051C9.36229 14.1672 9.41714 14.3026 9.52686 14.4114C9.63657 14.5202 9.77257 14.575 9.93486 14.5758Z" fill="#9a9a9a"/>
                              </svg>
                              <svg onClick={()=>handleSelectWorkoutDay(data.dayName,true)} className='flex-item cursor-pointer m-r-12 global-fill-svg' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.1845 0.815819C15.9259 0.557174 15.6189 0.352005 15.2809 0.212026C14.943 0.0720466 14.5808 0 14.2151 0C13.8493 0 13.4871 0.0720466 13.1492 0.212026C12.8113 0.352005 12.5042 0.557174 12.2456 0.815819L1.77261 11.2893C1.46096 11.601 1.2343 11.9877 1.1153 12.4127L0.0195523 16.326C-0.00576464 16.4167 -0.00650882 16.5125 0.0173963 16.6036C0.0413014 16.6947 0.0889962 16.7778 0.155594 16.8444C0.222191 16.911 0.305297 16.9587 0.396395 16.9826C0.487494 17.0065 0.583311 17.0058 0.674027 16.9804L4.58671 15.8847C5.01165 15.7658 5.39879 15.5394 5.71079 15.2274L16.1845 4.75392C16.7067 4.23165 17 3.52338 17 2.78487C17 2.04636 16.7067 1.33809 16.1845 0.815819ZM12.9971 1.56661C13.3202 1.2436 13.7584 1.06217 14.2153 1.06224C14.6722 1.0623 15.1103 1.24386 15.4334 1.56696C15.7564 1.89007 15.9378 2.32825 15.9377 2.78512C15.9377 3.24199 15.7561 3.68012 15.433 4.00313L14.3422 5.09319L11.9063 2.65667L12.9971 1.56661ZM11.1555 3.40817L13.5921 5.84469L4.95928 14.4766C4.77643 14.6595 4.54957 14.7922 4.30056 14.8619L1.29663 15.7027L2.13739 12.6995C2.20725 12.4506 2.33994 12.2237 2.52271 12.0408L11.1555 3.40817Z" fill="#9a9a9a"/>
                              </svg>
                              <svg onClick={() => handleDayWorkoutCopyTo(data.dayName)} className='flex-item cursor-pointer global-stroke-svg' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.25 4.375C12.25 3.3265 12.25 2.80225 12.079 2.38938C11.9659 2.1162 11.8001 1.868 11.5911 1.65894C11.382 1.44988 11.1338 1.28408 10.8606 1.171C10.4478 1 9.9235 1 8.875 1H5.5C3.37825 1 2.3185 1 1.65925 1.65925C1 2.3185 1 3.37825 1 5.5V8.875C1 9.9235 1 10.4478 1.171 10.8606C1.28408 11.1338 1.44988 11.382 1.65894 11.5911C1.868 11.8001 2.1162 11.9659 2.38938 12.079C2.80225 12.25 3.3265 12.25 4.375 12.25" stroke="#9a9a9a"/>
                                <path d="M16.75 7.75H10C8.75736 7.75 7.75 8.75736 7.75 10V16.75C7.75 17.9926 8.75736 19 10 19H16.75C17.9926 19 19 17.9926 19 16.75V10C19 8.75736 17.9926 7.75 16.75 7.75Z" stroke="#9a9a9a"/>
                              </svg>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
              
            </div>,

            <div className='footer-absolute-container p-l-20 p-b-20' style={{background:"#f4f4f4"}}>
              <div className='d-flex'>
                <div className='d-flex flex-item p-r-16' style={{margin: "0 0 0 auto"}}>
                  <div onClick={toggleBackToPrevWindow} className={`member-button-global btn-center d-flex`} style={{background:"var(--darkBlue)"}}>
                    <p className='flex-item fs-16' style={{ fontWeight: 500, whiteSpace:"nowrap", color:"#ffffff" }}>Go Back</p>
                  </div>
                  {
                    dayWorkoutStorage.displayName && dayWorkoutStorage.exercises.length > 0 && dayWorkoutStorage.exercises[0].content && dayWorkoutStorage.exercises[0].content._id && [
                      <div className='m-l-12'/>,
                      <div onClick={handleAddWorkouts} className={`member-button-global btn-center d-flex`}>
                        <p className='flex-item fs-16' style={{ fontWeight: 500, whiteSpace:"nowrap" }}>{isEditActive?"Update":"Add Workout to"} {dayWorkoutStorage.workoutDays[0].isSelected && dayWorkoutStorage.workoutDays.slice(1, 5).findIndex(item => item.isSelected == true) !== -1  ? "Mon, " 
                          : dayWorkoutStorage.workoutDays[0].isSelected ? "Mon" 
                          : null} 
                          
                          {dayWorkoutStorage.workoutDays[1].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(2, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(2, 6).filter(item => item.isSelected == true).length > 1 ? "Tue, " 
                          : dayWorkoutStorage.workoutDays[1].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(2, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(2, 6).filter(item => item.isSelected == true).length == 1 ? "Tue & " 
                          : dayWorkoutStorage.workoutDays[1].isSelected ? "Tue" :
                          null}

                          {dayWorkoutStorage.workoutDays[2].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(3, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(3, 6).filter(item => item.isSelected == true).length > 1 ? "Wed, " 
                          : dayWorkoutStorage.workoutDays[2].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(3, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(3, 6).filter(item => item.isSelected == true).length == 1 ? "Wed & " 
                          : dayWorkoutStorage.workoutDays[2].isSelected ? "Wed" :
                          null} 

                          {dayWorkoutStorage.workoutDays[3].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(4, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(4, 6).filter(item => item.isSelected == true).length > 1 ? "Thu, " 
                          : dayWorkoutStorage.workoutDays[3].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(4, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(4, 6).filter(item => item.isSelected == true).length == 1 ? "Thu & " 
                          : dayWorkoutStorage.workoutDays[3].isSelected ? "Thu" :
                          null} 

                          {dayWorkoutStorage.workoutDays[4].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(5, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(5, 6).filter(item => item.isSelected == true).length > 1 ? "Fri, " 
                          : dayWorkoutStorage.workoutDays[4].isSelected && 
                          dayWorkoutStorage.workoutDays.slice(5, 6).findIndex(item => item.isSelected == true) !== -1 && 
                          dayWorkoutStorage.workoutDays.slice(5, 6).filter(item => item.isSelected == true).length == 1 ? "Fri & " 
                          : dayWorkoutStorage.workoutDays[4].isSelected ? "Fri" :
                          null} 

                          {dayWorkoutStorage.workoutDays[5].isSelected && "Sat"}
                          {isEditActive&&' Workout'}
                        </p>
                      </div>
                    ]
                  }
                </div>
              </div>
          </div>
          ]
        }
        {
          isCurrentMemberFilterOption == "weekdays-exercise" && copyFrom.length > 0 && (
            <div  onClick={() => handleDayWorkoutCopyTo("")} className='day-copy-to-modal d-flex'>
              <div onClick={e => e.stopPropagation()} className='day-copy-to-container flex-item'>
                <div className='d-flex'>
                  <svg className='flex-item m-r-12' width="26" height="33" viewBox="0 0 26 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.631 9.73077L16.3548 0.372308C16.1191 0.134213 15.7994 0.000296242 15.4658 0H11.3226C10.0992 0 8.92585 0.490315 8.06076 1.36308C7.19568 2.23585 6.70968 3.41957 6.70968 4.65385V6.76923H4.6129C3.38949 6.76923 2.21617 7.25955 1.35109 8.13231C0.486001 9.00508 0 10.1888 0 11.4231V28.3462C0 29.5804 0.486001 30.7642 1.35109 31.6369C2.21617 32.5097 3.38949 33 4.6129 33H16.3548C17.5783 33 18.7516 32.5097 19.6167 31.6369C20.4817 30.7642 20.9677 29.5804 20.9677 28.3462V26.2308H21.3871C22.6105 26.2308 23.7838 25.7405 24.6489 24.8677C25.514 23.9949 26 22.8112 26 21.5769V10.5769C25.9868 10.2581 25.855 9.95599 25.631 9.73077ZM16.7742 4.33231L21.7058 9.30769H16.7742V4.33231ZM18.4516 28.3462C18.4516 28.9072 18.2307 29.4452 17.8375 29.842C17.4443 30.2387 16.9109 30.4615 16.3548 30.4615H4.6129C4.0568 30.4615 3.52348 30.2387 3.13026 29.842C2.73704 29.4452 2.51613 28.9072 2.51613 28.3462V11.4231C2.51613 10.862 2.73704 10.324 3.13026 9.92727C3.52348 9.53056 4.0568 9.30769 4.6129 9.30769H6.70968V21.5769C6.70968 22.8112 7.19568 23.9949 8.06076 24.8677C8.92585 25.7405 10.0992 26.2308 11.3226 26.2308H18.4516V28.3462ZM21.3871 23.6923H11.3226C10.7665 23.6923 10.2332 23.4694 9.83994 23.0727C9.44672 22.676 9.22581 22.138 9.22581 21.5769V4.65385C9.22581 4.09281 9.44672 3.55475 9.83994 3.15804C10.2332 2.76133 10.7665 2.53846 11.3226 2.53846H14.2581V10.5769C14.2624 10.9122 14.3963 11.2325 14.6313 11.4696C14.8663 11.7066 15.1838 11.8418 15.5161 11.8462H23.4839V21.5769C23.4839 22.138 23.263 22.676 22.8697 23.0727C22.4765 23.4694 21.9432 23.6923 21.3871 23.6923Z" fill="#A9A9A9"/>
                  </svg>
                  <p className='copy-from-txt flex-item'>Copy <span style={{color:"var(--darkBlue)"}}>{copyFrom}</span> workout to</p>
                </div>
                <div className='d-flex-wrap m-t-40' style={{justifyContent:"center"}}>
                  {
                    copyTo.map((data, index) => {
                      if(data.day !== copyFrom){
                        return(
                          <div onClick={() => handleCopyTo(index)} className={`${data.isSelected == true ? "day-chips day-chips-active" : "day-chips"} d-flex cursor-pointer m-r-10 m-b-16`} style={{width:"auto", height: "30px", padding: "0 20px"}}>
                            <p className='flex-item'>{data.day}</p>
                          </div>
                        )
                      }
                    })
                  }
                </div>

                {
                  copyTo.filter(data => data.isSelected == true).length > 0 && (
                    <div className='d-flex m-t-40'>
                      <div onClick={()=>handlePasteTo()} className={`member-button-global btn-center d-flex p-l-60 p-r-60`} style={{margin:"0 auto"}}>
                        <p className='flex-item fs-16' style={{ fontWeight: 500 }}>Continue</p>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          )
        }

        {
          isCurrentMemberFilterOption == "add-exercise" && [
            <div className="d-flex w-full space-between">
              <div className='flex-item d-flex'>
                <div onClick={toggleBackToPrevWindow.bind(this)} className="d-flex desktop-modal-close-button m-r-12">
                  <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                  </svg>
                </div>
                <p className="flex-item modal-header-text">Content</p>
              </div>
              <div className='d-flex space-between flex-item'>
                <div id="search-container" className='global-search-box flex-item' style={{ background: "#f5f5f5", width: "80%" }}>
                  <svg id="search-icon" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1637_1318)">
                      <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1637_1318">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <input id="search-content" onChange={_.debounce(handleContentSearchKey, 1000)} className='flex-item' style={{ background: "#f5f5f5" }} type="text" placeholder="Search Content" />
                </div>
                <div onClick={() => toggleContentFilter("main-filter")} className='global-round-btn d-flex flex-item' style={{ background: "#f5f5f5" }}>
                  <svg className='flex-item fill-svg' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 4H12.95C12.7 2.85 11.7 2 10.5 2C9.3 2 8.3 2.85 8.05 4H1V5H8.05C8.3 6.15 9.3 7 10.5 7C11.7 7 12.7 6.15 12.95 5H15V4ZM10.5 6C9.65 6 9 5.35 9 4.5C9 3.65 9.65 3 10.5 3C11.35 3 12 3.65 12 4.5C12 5.35 11.35 6 10.5 6ZM1 12H3.05C3.3 13.15 4.3 14 5.5 14C6.7 14 7.7 13.15 7.95 12H15V11H7.95C7.7 9.85 6.7 9 5.5 9C4.3 9 3.3 9.85 3.05 11H1V12ZM5.5 10C6.35 10 7 10.65 7 11.5C7 12.35 6.35 13 5.5 13C4.65 13 4 12.35 4 11.5C4 10.65 4.65 10 5.5 10Z" fill="#6D6D6D" />
                  </svg>
                </div>
              </div>
            </div>,
            <div onClick={e => e.stopPropagation()} className="no-scroll-bar p-l-2 p-r-2 p-b-12 m-t-20" onScroll={handleScroll} style={{ overflow: "auto"}}>
              {
                Contents.map((content) => {
                  if (selectedContent && selectedContent._id == content._id) {
                    return (
                      <div className='planner-exercise-container m-b-20'>
                        <div className={`d-flex w-full space-between ${selectedContent.contentType === 'mainexercise'&&'m-b-12'}`}>
                          <div className='d-flex' style={{ width: "80%" }}>
                            <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.75 3.64583C1.75 3.14303 1.94974 2.66081 2.30528 2.30528C2.66081 1.94974 3.14303 1.75 3.64583 1.75H10.3542C10.857 1.75 11.3392 1.94974 11.6947 2.30528C12.0503 2.66081 12.25 3.14303 12.25 3.64583V10.3542C12.25 10.857 12.0503 11.3392 11.6947 11.6947C11.3392 12.0503 10.857 12.25 10.3542 12.25H3.64583C3.14303 12.25 2.66081 12.0503 2.30528 11.6947C1.94974 11.3392 1.75 10.857 1.75 10.3542V3.64583ZM3.64583 2.625C3.37509 2.625 3.11544 2.73255 2.924 2.924C2.73255 3.11544 2.625 3.37509 2.625 3.64583V10.3542C2.625 10.9177 3.08233 11.375 3.64583 11.375H7.875V2.625H3.64583ZM10.3542 11.375C10.6249 11.375 10.8846 11.2674 11.076 11.076C11.2674 10.8846 11.375 10.6249 11.375 10.3542V9.33333H8.75V11.375H10.3542ZM11.375 8.45833V5.54167H8.75V8.45833H11.375ZM11.375 4.66667V3.64583C11.375 3.37509 11.2674 3.11544 11.076 2.924C10.8846 2.73255 10.6249 2.625 10.3542 2.625H8.75V4.66667H11.375ZM3.5 8.02083C3.5 7.9048 3.54609 7.79352 3.62814 7.71147C3.71019 7.62943 3.82147 7.58333 3.9375 7.58333H6.5625C6.67853 7.58333 6.78981 7.62943 6.87186 7.71147C6.95391 7.79352 7 7.9048 7 8.02083C7 8.13687 6.95391 8.24814 6.87186 8.33019C6.78981 8.41224 6.67853 8.45833 6.5625 8.45833H3.9375C3.82147 8.45833 3.71019 8.41224 3.62814 8.33019C3.54609 8.24814 3.5 8.13687 3.5 8.02083ZM4.22917 3.79167C3.82667 3.79167 3.5 4.11833 3.5 4.52083V5.97917C3.5 6.38167 3.82667 6.70833 4.22917 6.70833H6.27083C6.67333 6.70833 7 6.38167 7 5.97917V4.52083C7 4.11833 6.67333 3.79167 6.27083 3.79167H4.22917ZM4.375 5.83333V4.66667H6.125V5.83333H4.375ZM3.5 9.77083C3.5 9.6548 3.54609 9.54352 3.62814 9.46147C3.71019 9.37943 3.82147 9.33333 3.9375 9.33333H6.5625C6.67853 9.33333 6.78981 9.37943 6.87186 9.46147C6.95391 9.54352 7 9.6548 7 9.77083C7 9.88687 6.95391 9.99815 6.87186 10.0802C6.78981 10.1622 6.67853 10.2083 6.5625 10.2083H3.9375C3.82147 10.2083 3.71019 10.1622 3.62814 10.0802C3.54609 9.99815 3.5 9.88687 3.5 9.77083Z" fill="var(--darkBlue)" />
                            </svg>
                            <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{content.name}</p>
                          </div>
                          <div className='d-flex'>
                            <div onClick={toggleVideoPlayer.bind(this, content)} className='d-flex planner-play-exercise m-r-20'>
                              <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                              </svg>
                            </div>
                            <svg className='flex-item' width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="6" cy="6" r="6" transform="matrix(1 0 0 -1 0 12)" fill="#5D883C" />
                              <path d="M3.12646 7.3249L4.9814 8.92561L9.12875 3.54259" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                            </svg>
                          </div>
                        </div>
                  
                        {
                          (selectedContent && selectedContent._id && selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "weight") && [
                            <div className='d-flex-wrap m-b-16 p-t-16'>
                              {
                                exerciseDetails.set.map((data, index) => {
                                  return(
                                    <div onMouseOver={()=> handleDeleteSet(index)} onMouseLeave={() => handleDeleteSet(-1)} onClick={() => handleSelectedSet(index)} className={`member-button-global btn-center d-flex m-r-12`} style={{background: selectedSet == index ? "var(--darkBlue)" : "#ffffff", position:"relative"}}>
                                      <p className="flex-item" style={{color: selectedSet == index ? "#ffffff" : "#000000", fontSize:"12px"}}>Set {index +1}</p>
                                      {
                                        isSetIndexDeleteEnabled == index && index>0 && (
                                          <svg onClick={() => handleSetAction("delete", index)} className='flex-item m-l-16' style={{position:"absolute", top: 0, right: 0, margin: "-8px -8px 0 0"}} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="10.5" cy="10.5" r="10.5" fill="#939393"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5092 11.5469L14.7343 15.772C14.8751 15.908 15.0638 15.9833 15.2596 15.9816C15.4554 15.9799 15.6428 15.9014 15.7812 15.7629C15.9197 15.6244 15.9983 15.4371 16 15.2413C16.0017 15.0454 15.9264 14.8568 15.7903 14.7159L11.5653 10.4908L15.7903 6.26574C15.9264 6.12488 16.0017 5.93622 16 5.74039C15.9983 5.54456 15.9197 5.35723 15.7812 5.21876C15.6428 5.08028 15.4554 5.00173 15.2596 5.00003C15.0638 4.99833 14.8751 5.07361 14.7343 5.20966L10.5092 9.43474L6.2841 5.20966C6.1426 5.07697 5.95503 5.00454 5.76108 5.00769C5.56713 5.01084 5.38201 5.08932 5.2449 5.22653C5.10779 5.36374 5.02943 5.54892 5.02642 5.74287C5.02341 5.93682 5.09597 6.12434 5.22876 6.26574L9.45309 10.4908L5.22801 14.7159C5.15668 14.7848 5.09978 14.8672 5.06064 14.9583C5.02149 15.0495 5.00089 15.1475 5.00003 15.2466C4.99917 15.3458 5.01806 15.4442 5.05562 15.5359C5.09317 15.6277 5.14863 15.7111 5.21875 15.7812C5.28888 15.8514 5.37227 15.9068 5.46406 15.9444C5.55585 15.9819 5.6542 16.0008 5.75337 16C5.85254 15.9991 5.95054 15.9785 6.04166 15.9394C6.13279 15.9002 6.2152 15.8433 6.2841 15.772L10.5092 11.5469Z" fill="white"/>
                                          </svg>
                                        )
                                      }
                                    </div>
                                  )
                                })
                              }
                              {
                                exerciseDetails.set.length < 5 && (
                                  <div onClick={() => handleSetAction("add")} className='d-flex desktop-modal-close-button m-r-12'>
                                    <svg className='flex-item' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.52494 8.51015L14.5001 8.51015C14.6959 8.50675 14.8825 8.42657 15.0198 8.2869C15.1571 8.14722 15.234 7.95922 15.234 7.76339C15.234 7.56755 15.1571 7.37955 15.0198 7.23987C14.8825 7.1002 14.6959 7.02003 14.5001 7.01662L8.52494 7.01662L8.52494 1.04146C8.52154 0.84565 8.44136 0.659013 8.30169 0.521745C8.16201 0.384476 7.97401 0.307558 7.77818 0.307558C7.58234 0.307558 7.39434 0.384476 7.25466 0.521744C7.11499 0.659013 7.03481 0.845649 7.03141 1.04146L7.03141 7.01662L1.05624 7.01662C0.862367 7.02285 0.678519 7.10427 0.543602 7.24364C0.408685 7.38301 0.333284 7.5694 0.333352 7.76338C0.333421 7.95736 0.408954 8.1437 0.543969 8.28297C0.678985 8.42225 0.86289 8.50353 1.05677 8.50962L7.03141 8.51015L7.03141 14.4853C7.02969 14.5845 7.04773 14.683 7.08448 14.7751C7.12124 14.8672 7.17597 14.9511 7.24548 15.0218C7.315 15.0925 7.3979 15.1487 7.48936 15.1871C7.58082 15.2254 7.679 15.2452 7.77817 15.2452C7.87735 15.2452 7.97553 15.2254 8.06699 15.1871C8.15845 15.1487 8.24135 15.0925 8.31087 15.0218C8.38038 14.9511 8.43511 14.8672 8.47186 14.7751C8.50862 14.683 8.52666 14.5845 8.52494 14.4853L8.52494 8.51015Z" fill="#4D4D4D"/>
                                    </svg>
                                  </div>
                                )
                              }
                            </div>,
                            exerciseDetails.set && exerciseDetails.set[selectedSet] && (
                              <>
                              <div onClick={toggleInputFields('exercise-reps')} className={`${(currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "member-global-input-field w-full m-b-20 flex-item" : "member-global-input-field w-full m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "1px solid var(--darkBlue)" : "" }}>
                                <div className="flex-item d-flex">
                                  <svg className="flex-item m-r-8" width={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "12" : "18"} height={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.65032 5.25014H11.5993C11.6349 5.25015 11.6698 5.26032 11.6999 5.27944C11.73 5.29857 11.7539 5.32586 11.7691 5.35812C11.7842 5.39039 11.7898 5.42629 11.7852 5.46162C11.7807 5.49696 11.7661 5.53026 11.7433 5.55764L10.2688 7.32764C10.2512 7.34874 10.2292 7.36572 10.2043 7.37737C10.1794 7.38902 10.1523 7.39506 10.1248 7.39506C10.0973 7.39506 10.0702 7.38902 10.0453 7.37737C10.0204 7.36572 9.99842 7.34874 9.98082 7.32764L8.50632 5.55764C8.48352 5.53026 8.46899 5.49696 8.46443 5.46162C8.45987 5.42629 8.46548 5.39039 8.48059 5.35812C8.4957 5.32586 8.51969 5.29857 8.54975 5.27944C8.57981 5.26032 8.61469 5.25015 8.65032 5.25014ZM0.40032 6.75014H3.34932C3.38495 6.75013 3.41983 6.73996 3.44989 6.72084C3.47995 6.70172 3.50394 6.67442 3.51905 6.64216C3.53416 6.60989 3.53977 6.57399 3.53521 6.53866C3.53065 6.50332 3.51612 6.47002 3.49332 6.44264L2.01882 4.67264C2.00122 4.65154 1.9792 4.63456 1.95432 4.62291C1.92944 4.61126 1.9023 4.60522 1.87482 4.60522C1.84734 4.60522 1.8202 4.61126 1.79532 4.62291C1.77044 4.63456 1.74842 4.65154 1.73082 4.67264L0.25632 6.44264C0.233519 6.47002 0.218988 6.50332 0.214431 6.53866C0.209874 6.57399 0.215478 6.60989 0.230587 6.64216C0.245697 6.67442 0.269686 6.70172 0.299746 6.72084C0.329806 6.73996 0.364693 6.75013 0.40032 6.75014Z" fill={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "var(--darkBlue)" : "#6d6d6d"} />
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00025 2.25005C4.83625 2.25005 3.79525 2.7803 3.1075 3.61355C3.07679 3.65336 3.03839 3.68658 2.99458 3.71125C2.95077 3.73591 2.90245 3.75152 2.85249 3.75714C2.80253 3.76275 2.75195 3.75827 2.70376 3.74394C2.65557 3.72962 2.61075 3.70575 2.57197 3.67376C2.53319 3.64177 2.50123 3.60231 2.47801 3.55772C2.45478 3.51313 2.44076 3.46433 2.43677 3.41421C2.43279 3.36409 2.43892 3.31369 2.45481 3.26599C2.4707 3.21829 2.49601 3.17427 2.52925 3.13655C3.07839 2.4717 3.80694 1.97856 4.62825 1.71579C5.44955 1.45303 6.32905 1.43169 7.16213 1.65432C7.99521 1.87695 8.74682 2.33418 9.32756 2.97162C9.9083 3.60906 10.2937 4.39989 10.438 5.25005H9.67525C9.50209 4.40316 9.04178 3.64205 8.37215 3.09541C7.70252 2.54878 6.86466 2.25016 6.00025 2.25005ZM2.32525 6.75005C2.46723 7.44352 2.80251 8.08267 3.29236 8.59366C3.7822 9.10465 4.40662 9.46662 5.09347 9.63777C5.78032 9.80891 6.50158 9.78224 7.17392 9.56083C7.84626 9.33943 8.44223 8.93232 8.893 8.38655C8.92371 8.34675 8.96211 8.31352 9.00592 8.28886C9.04973 8.26419 9.09805 8.24859 9.14801 8.24297C9.19797 8.23735 9.24855 8.24184 9.29674 8.25616C9.34493 8.27048 9.38975 8.29435 9.42853 8.32634C9.46731 8.35833 9.49927 8.3978 9.52249 8.44239C9.54572 8.48698 9.55974 8.53578 9.56372 8.5859C9.56771 8.63601 9.56158 8.68642 9.54569 8.73412C9.5298 8.78182 9.50449 8.82583 9.47125 8.86355C8.92211 9.52841 8.19356 10.0215 7.37225 10.2843C6.55095 10.5471 5.67145 10.5684 4.83837 10.3458C4.00529 10.1232 3.25368 9.66593 2.67294 9.02849C2.0922 8.39105 1.70678 7.60021 1.5625 6.75005H2.32525Z" fill={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "var(--darkBlue)" : "#6d6d6d"} />
                                  </svg>
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "10px" : "14px", color: (currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "var(--darkBlue)" : "", transition: "180ms" }}>Repetation</p>
                                </div>
                                <input id="exercise-reps" value={exerciseDetails.set[selectedSet].reps} onChange={handleSetReps} className={`${(currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                              <div className='d-flex space-between'>
                                <div onClick={toggleInputFields('exercise-weight')} className={`${(currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                  <div className="flex-item d-flex">
                                    <svg className='flex-item m-r-8' width={(currentElementId == 'exercise-weight' || exerciseDetails.set[selectedSet].weight.value) ? "12" : "18"} height={(currentElementId == 'exercise-weight' || exerciseDetails.set[selectedSet].weight.value) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6 0C5.10273 0 4.36364 0.739091 4.36364 1.63636C4.36364 1.82836 4.404 2.00945 4.46618 2.18182H1.73891L1.65327 2.62527L0.0169092 10.8071L0 10.8578V12H12V10.8578L11.9831 10.8071L10.3467 2.62527L10.2611 2.18182H7.53382C7.59934 2.00731 7.63403 1.82275 7.63636 1.63636C7.63636 0.739091 6.89727 0 6 0ZM6 1.09091C6.30709 1.09091 6.54545 1.32982 6.54545 1.63636C6.54545 1.94345 6.30655 2.18182 6 2.18182C5.69291 2.18182 5.45455 1.94291 5.45455 1.63636C5.45455 1.32927 5.69345 1.09091 6 1.09091ZM2.62473 3.27273H9.37527L10.9091 10.9091H1.09091L2.62473 3.27273Z" fill={(currentElementId == 'exercise-weight' || exerciseDetails.set[selectedSet].weight.value) ? "var(--darkBlue)" : "#6d6d6d"} />
                                    </svg>
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "10px" : "14px", color: (currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Weight</p>
                                  </div>
                                  <input id="exercise-weight" value={exerciseDetails.set[selectedSet].weight.value} className={`${(currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "active-input-field" : "inactive-input-field"}`} type="number" onChange={handleChangeExerciseDetails("weight.value")} />
                                </div>
                                <div onClick={toggleInputFields('weight-unit')} className={`${(currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "10px" : "14px", color: (currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "var(--darkBlue)" : "", transition: "180ms" }}>Unit</p>
                                  </div>
                                  <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                    <svg className="flex-item" style={{ transform: exerciseWeightUnitTypeDropdownOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                    </svg>
                                  </div>
                                  <input id="weight-unit" className={`${(currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Unit" value={exerciseDetails.set[selectedSet].weight.unit} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                                  {
                                    exerciseWeightUnitTypeDropdownOpen && (
                                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                        <div onClick={getSelectedWeightUnit.bind(this, "Kg")} className="global-input-field-arrow-dropdown-item">
                                          <p className="flex-item">Kg</p>
                                        </div>
                                        <div onClick={getSelectedWeightUnit.bind(this, "Lbs")} className="global-input-field-arrow-dropdown-item">
                                          <p className="flex-item">Lbs</p>
                                        </div>
                                      </div>
                                    )
                                  }
                                </div>
                              </div>
                              </>
                            )
                            
                          ]
                        }
                        {
                          (selectedContent && selectedContent._id && selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "distance") && (
                            <div className='d-flex space-between'>
                              <div onClick={toggleInputFields('exercise-distance')} className={`${(currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                <div className="flex-item d-flex">
                                  <svg className='flex-item m-r-8' width={(currentElementId == 'exercise-distance' || exerciseDetails.distance.value) ? "12" : "18"} height={(currentElementId == 'exercise-distance' || exerciseDetails.distance.value) ? "16" : "18"} style={{ transition: "180ms" }} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke={(currentElementId == 'exercise-distance' || exerciseDetails.distance.value) ? "var(--darkBlue)" : "#6d6d6d"} />
                                  </svg>
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "10px" : "14px", color: (currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Distance</p>
                                </div>
                                <input onChange={handleChangeExerciseDetails("distance.value")} id="exercise-distance" value={exerciseDetails.distance.value} className={`${(currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                              <div onClick={toggleInputFields('distance-unit')} className={`${(currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "10px" : "14px", color: (currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "var(--darkBlue)" : "", transition: "180ms" }}>Unit</p>
                                </div>
                                <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                  <svg className="flex-item" style={{ transform: exerciseDistanceUnitTypeDropdownOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                  </svg>
                                </div>
                                <input id="distance-unit" className={`${(currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Unit" value={exerciseDetails.distance.unit} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                                {
                                  exerciseDistanceUnitTypeDropdownOpen && (
                                    <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                      <div onClick={getSelectedDistanceUnit.bind(this, "Kg")} className="global-input-field-arrow-dropdown-item">
                                        <p className="flex-item">Kg</p>
                                      </div>
                                      <div onClick={getSelectedDistanceUnit.bind(this, "Lbs")} className="global-input-field-arrow-dropdown-item">
                                        <p className="flex-item">Lbs</p>
                                      </div>
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                          )
                        }
                        {
                          (selectedContent && selectedContent._id && selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "number") && (
                            <div onClick={toggleInputFields('exercise-count')} className={`${(currentElementId == "exercise-count" || exerciseDetails.count) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-count" || exerciseDetails.count) ? "1px solid var(--darkBlue)" : "" }}>
                              <div className="flex-item d-flex">
                                <svg className="flex-item m-r-8" width={(currentElementId == 'exercise-count' || exerciseDetails.count) ? "12" : "18"} height={(currentElementId == 'exercise-count' || exerciseDetails.count) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.20041 0.700024C1.20041 0.620459 1.23202 0.544153 1.28828 0.487892C1.34454 0.431632 1.42084 0.400024 1.50041 0.400024H10.5004C10.58 0.400024 10.6563 0.431632 10.7125 0.487892C10.7688 0.544153 10.8004 0.620459 10.8004 0.700024C10.8004 0.779589 10.7688 0.855895 10.7125 0.912156C10.6563 0.968417 10.58 1.00002 10.5004 1.00002H1.50041C1.42084 1.00002 1.34454 0.968417 1.28828 0.912156C1.23202 0.855895 1.20041 0.779589 1.20041 0.700024ZM1.20041 3.70002C1.20041 3.62046 1.23202 3.54415 1.28828 3.48789C1.34454 3.43163 1.42084 3.40002 1.50041 3.40002H10.5004C10.58 3.40002 10.6563 3.43163 10.7125 3.48789C10.7688 3.54415 10.8004 3.62046 10.8004 3.70002C10.8004 3.77959 10.7688 3.8559 10.7125 3.91216C10.6563 3.96842 10.58 4.00002 10.5004 4.00002H1.50041C1.42084 4.00002 1.34454 3.96842 1.28828 3.91216C1.23202 3.8559 1.20041 3.77959 1.20041 3.70002ZM4.55321 5.80002C4.18541 5.80002 3.89741 6.13302 3.89741 6.48162C3.89741 6.56119 3.8658 6.6375 3.80954 6.69376C3.75328 6.75002 3.67697 6.78162 3.59741 6.78162C3.51784 6.78162 3.44154 6.75002 3.38528 6.69376C3.32902 6.6375 3.29741 6.56119 3.29741 6.48162C3.29741 5.84922 3.80861 5.20002 4.55321 5.20002C4.99121 5.20002 5.41061 5.40582 5.64341 5.76642C5.88581 6.14082 5.89661 6.63162 5.60921 7.12422C5.46281 7.37442 5.26121 7.56523 5.06081 7.72423C4.96121 7.80403 4.85741 7.87782 4.75901 7.94802L4.71701 7.97802C4.63241 8.03802 4.55261 8.09442 4.47521 8.15262C4.21181 8.35242 4.02101 8.54142 3.94061 8.80002H5.49641C5.57597 8.80002 5.65228 8.83163 5.70854 8.88789C5.7648 8.94415 5.79641 9.02046 5.79641 9.10003C5.79641 9.17959 5.7648 9.2559 5.70854 9.31216C5.65228 9.36842 5.57597 9.40002 5.49641 9.40002H3.59681C3.51724 9.40002 3.44094 9.36842 3.38468 9.31216C3.32842 9.2559 3.29681 9.17959 3.29681 9.10003C3.29681 8.38302 3.71141 7.97802 4.11281 7.67443C4.19801 7.61023 4.28621 7.54722 4.37021 7.48842L4.41101 7.45842C4.50881 7.38942 4.60061 7.32282 4.68701 7.25442C4.86101 7.11642 4.99781 6.98022 5.09021 6.82122C5.28101 6.49602 5.24141 6.25002 5.13941 6.09282C5.02841 5.92122 4.81001 5.80002 4.55261 5.80002H4.55321ZM7.24301 5.96202C7.16101 6.03556 7.10116 6.13052 7.07021 6.23622C7.05962 6.27431 7.0416 6.30992 7.0172 6.34102C6.9928 6.37211 6.96249 6.39808 6.92802 6.41743C6.89356 6.43678 6.8556 6.44912 6.81635 6.45376C6.77709 6.45839 6.73731 6.45522 6.69928 6.44443C6.66126 6.43364 6.62574 6.41544 6.59477 6.39087C6.5638 6.36631 6.53799 6.33587 6.51882 6.3013C6.49965 6.26674 6.4875 6.22872 6.48307 6.18944C6.47864 6.15016 6.48202 6.11039 6.49301 6.07242C6.53861 5.91103 6.64181 5.69262 6.84461 5.51262C7.05341 5.32782 7.34921 5.20002 7.74521 5.20002C8.55161 5.20002 9.00941 5.79042 9.00941 6.31842C9.00941 6.52962 8.96861 6.85422 8.75081 7.13022C8.70761 7.18422 8.65901 7.23522 8.60501 7.28142C8.68601 7.34142 8.76221 7.41582 8.82641 7.50642C8.94401 7.67262 9.00941 7.87782 9.00941 8.11842C9.00941 8.55643 8.86301 8.89242 8.60261 9.11442C8.35061 9.32743 8.03261 9.40002 7.74521 9.40002C7.47401 9.40002 7.20941 9.35443 6.98201 9.20983C6.74921 9.06163 6.59261 8.83302 6.49601 8.53903C6.48376 8.50156 6.479 8.46205 6.48202 8.42274C6.48504 8.38344 6.49577 8.34512 6.5136 8.30996C6.53143 8.2748 6.55601 8.2435 6.58593 8.21785C6.61586 8.19219 6.65054 8.17268 6.68801 8.16042C6.72547 8.14817 6.76499 8.14342 6.80429 8.14644C6.84359 8.14946 6.88192 8.16019 6.91707 8.17801C6.95223 8.19584 6.98353 8.22042 7.00919 8.25035C7.03484 8.28027 7.05436 8.31496 7.06661 8.35242C7.13081 8.54862 7.21541 8.64762 7.30421 8.70403C7.39841 8.76402 7.53461 8.80002 7.74521 8.80002C7.94081 8.80002 8.10401 8.74963 8.21381 8.65602C8.31521 8.57082 8.40941 8.41603 8.40941 8.11842C8.41417 8.02454 8.38873 7.93159 8.33681 7.85323C8.28738 7.78798 8.22183 7.7367 8.14661 7.70442C7.96841 7.62042 7.74101 7.60002 7.58501 7.60002C7.50544 7.60002 7.42914 7.56842 7.37288 7.51216C7.31662 7.4559 7.28501 7.37959 7.28501 7.30002C7.28501 7.22046 7.31662 7.14415 7.37288 7.08789C7.42914 7.03163 7.50544 7.00002 7.58501 7.00002C8.00801 7.00002 8.19161 6.86982 8.27981 6.75822C8.37881 6.63342 8.40941 6.46662 8.40941 6.31842C8.40941 6.12582 8.22461 5.80002 7.74521 5.80002C7.48721 5.80002 7.33541 5.87983 7.24301 5.96202ZM1.80701 6.61902C1.65492 6.78479 1.48396 6.93219 1.29761 7.05822C1.26495 7.08155 1.22794 7.09809 1.18878 7.10686C1.14962 7.11562 1.10909 7.11644 1.06961 7.10927C1.03012 7.10209 0.992474 7.08707 0.958898 7.06508C0.925323 7.0431 0.8965 7.0146 0.874136 6.98127C0.851772 6.94795 0.836323 6.91047 0.828701 6.87107C0.82108 6.83167 0.821442 6.79114 0.829766 6.75188C0.83809 6.71262 0.854207 6.67543 0.877163 6.64251C0.900119 6.60959 0.929446 6.58161 0.963409 6.56023C1.40321 6.26562 1.73681 5.79222 1.81421 5.43642C1.81421 5.43642 1.88021 5.20002 2.09021 5.20002C2.39141 5.20002 2.40761 5.50002 2.40761 5.50002V9.10003C2.40761 9.17959 2.376 9.2559 2.31974 9.31216C2.26348 9.36842 2.18717 9.40002 2.10761 9.40002C2.02804 9.40002 1.95174 9.36842 1.89548 9.31216C1.83922 9.2559 1.80761 9.17959 1.80761 9.10003V6.61902H1.80701ZM9.60041 6.70002C9.60041 6.62046 9.63202 6.54415 9.68828 6.48789C9.74454 6.43163 9.82084 6.40002 9.90041 6.40002H10.5004C10.58 6.40002 10.6563 6.43163 10.7125 6.48789C10.7688 6.54415 10.8004 6.62046 10.8004 6.70002C10.8004 6.77959 10.7688 6.8559 10.7125 6.91216C10.6563 6.96842 10.58 7.00002 10.5004 7.00002H9.90041C9.82084 7.00002 9.74454 6.96842 9.68828 6.91216C9.63202 6.8559 9.60041 6.77959 9.60041 6.70002Z" fill={(currentElementId == 'exercise-count' || exerciseDetails.count) ? "var(--darkBlue)" : "#6d6d6d"} />
                                </svg>
                                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-count" || exerciseDetails.count) ? "10px" : "14px", color: (currentElementId == "exercise-count" || exerciseDetails.count) ? "var(--darkBlue)" : "", transition: "180ms" }}>Count</p>
                              </div>
                              <input id="exercise-count" value={exerciseDetails.count} onChange={handleChangeExerciseDetails("count")} className={`${(currentElementId == "exercise-count" || exerciseDetails.count) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                            </div>
                          )
                        }
                        {
                          (selectedContent && selectedContent._id&& selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "time") && [
                            <div className='d-flex m-b-12'>
                              <svg className='flex-item m-r-6' width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.09625 7.625L5 5.52875V2H5.75V5.2175L7.625 7.09625L7.09625 7.625Z" fill="#2B2B2B" />
                                <path d="M5.25 10.5C4.21165 10.5 3.19662 10.1921 2.33326 9.61522C1.4699 9.03834 0.796995 8.2184 0.399635 7.25909C0.00227474 6.29978 -0.101693 5.24418 0.10088 4.22578C0.303452 3.20738 0.803466 2.27192 1.53769 1.53769C2.27192 0.803466 3.20738 0.303452 4.22578 0.10088C5.24418 -0.101693 6.29978 0.00227474 7.25909 0.399635C8.2184 0.796995 9.03834 1.4699 9.61522 2.33326C10.1921 3.19662 10.5 4.21165 10.5 5.25C10.5 6.64239 9.94688 7.97775 8.96231 8.96231C7.97775 9.94688 6.64239 10.5 5.25 10.5ZM5.25 0.750002C4.35999 0.750002 3.48996 1.01392 2.74994 1.50839C2.00992 2.00286 1.43314 2.70566 1.09254 3.52793C0.75195 4.35019 0.662835 5.25499 0.836469 6.12791C1.0101 7.00082 1.43869 7.80265 2.06802 8.43198C2.69736 9.06132 3.49918 9.4899 4.3721 9.66354C5.24501 9.83717 6.14981 9.74805 6.97208 9.40746C7.79434 9.06686 8.49715 8.49009 8.99162 7.75007C9.48608 7.01005 9.75 6.14002 9.75 5.25C9.75 4.05653 9.2759 2.91194 8.43198 2.06802C7.58807 1.22411 6.44348 0.750002 5.25 0.750002Z" fill="#2B2B2B" />
                              </svg>
                              <p className='flex-item'>Duration</p>
                            </div>,
                            <div className='d-flex space-between'>
                              <div onClick={toggleInputFields('duration-hour')} className={`${(currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "1px solid var(--darkBlue)" : "", width: "45%" }}>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "10px" : "14px", color: (currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "var(--darkBlue)" : "", transition: "180ms" }}>Hour</p>
                                </div>
                                <input id="duration-hour" value={exerciseDetails.duration.hour} onChange={handleChangeExerciseDetails("duration.hour")} className={`${(currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                              <svg className='flex-item' width="6" height="20" viewBox="0 0 6 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="3" cy="3" r="3" fill="#9A9A9A" />
                                <circle cx="3" cy="17" r="3" fill="#9A9A9A" />
                              </svg>
                              <div onClick={toggleInputFields('duration-min')} className={`${(currentElementId == "duration-min" || exerciseDetails.duration.min) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "duration-min" || exerciseDetails.duration.min) ? "1px solid var(--darkBlue)" : "", width: "45%" }}>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "duration-min" || exerciseDetails.duration.min) ? "10px" : "14px", color: (currentElementId == "duration-min" || exerciseDetails.duration.min) ? "var(--darkBlue)" : "", transition: "180ms" }}>Min</p>
                                </div>
                                <input onChange={handleChangeExerciseDetails("duration.min")} id="duration-min" value={exerciseDetails.duration.min} className={`${(currentElementId == "duration-min" || exerciseDetails.duration.min) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                            </div>
                          ]
                        }
                      </div>
                    )
                  } else {
                    return (
                      <div onClick={handleSelectContent(content)} className='planner-exercise-container m-b-12' style={{ padding: "2px 6px", boxShadow: "none" }}>
                        <div className='d-flex w-full space-between m-b-12'>
                          <div className='d-flex' style={{ width: "80%" }}>
                            <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.75 3.64583C1.75 3.14303 1.94974 2.66081 2.30528 2.30528C2.66081 1.94974 3.14303 1.75 3.64583 1.75H10.3542C10.857 1.75 11.3392 1.94974 11.6947 2.30528C12.0503 2.66081 12.25 3.14303 12.25 3.64583V10.3542C12.25 10.857 12.0503 11.3392 11.6947 11.6947C11.3392 12.0503 10.857 12.25 10.3542 12.25H3.64583C3.14303 12.25 2.66081 12.0503 2.30528 11.6947C1.94974 11.3392 1.75 10.857 1.75 10.3542V3.64583ZM3.64583 2.625C3.37509 2.625 3.11544 2.73255 2.924 2.924C2.73255 3.11544 2.625 3.37509 2.625 3.64583V10.3542C2.625 10.9177 3.08233 11.375 3.64583 11.375H7.875V2.625H3.64583ZM10.3542 11.375C10.6249 11.375 10.8846 11.2674 11.076 11.076C11.2674 10.8846 11.375 10.6249 11.375 10.3542V9.33333H8.75V11.375H10.3542ZM11.375 8.45833V5.54167H8.75V8.45833H11.375ZM11.375 4.66667V3.64583C11.375 3.37509 11.2674 3.11544 11.076 2.924C10.8846 2.73255 10.6249 2.625 10.3542 2.625H8.75V4.66667H11.375ZM3.5 8.02083C3.5 7.9048 3.54609 7.79352 3.62814 7.71147C3.71019 7.62943 3.82147 7.58333 3.9375 7.58333H6.5625C6.67853 7.58333 6.78981 7.62943 6.87186 7.71147C6.95391 7.79352 7 7.9048 7 8.02083C7 8.13687 6.95391 8.24814 6.87186 8.33019C6.78981 8.41224 6.67853 8.45833 6.5625 8.45833H3.9375C3.82147 8.45833 3.71019 8.41224 3.62814 8.33019C3.54609 8.24814 3.5 8.13687 3.5 8.02083ZM4.22917 3.79167C3.82667 3.79167 3.5 4.11833 3.5 4.52083V5.97917C3.5 6.38167 3.82667 6.70833 4.22917 6.70833H6.27083C6.67333 6.70833 7 6.38167 7 5.97917V4.52083C7 4.11833 6.67333 3.79167 6.27083 3.79167H4.22917ZM4.375 5.83333V4.66667H6.125V5.83333H4.375ZM3.5 9.77083C3.5 9.6548 3.54609 9.54352 3.62814 9.46147C3.71019 9.37943 3.82147 9.33333 3.9375 9.33333H6.5625C6.67853 9.33333 6.78981 9.37943 6.87186 9.46147C6.95391 9.54352 7 9.6548 7 9.77083C7 9.88687 6.95391 9.99815 6.87186 10.0802C6.78981 10.1622 6.67853 10.2083 6.5625 10.2083H3.9375C3.82147 10.2083 3.71019 10.1622 3.62814 10.0802C3.54609 9.99815 3.5 9.88687 3.5 9.77083Z" fill="var(--darkBlue)" />
                            </svg>
                            <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{content.name}</p>
                          </div>
                          <div className='d-flex'>
                            <div onClick={toggleVideoPlayer.bind(this, content)} className='d-flex planner-play-exercise m-r-20'>
                              <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                              </svg>
                            </div>
                            <svg className='flex-item' width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="6" cy="6" r="5.5" fill="white" stroke="#E0E0E0" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )
                  }

                })
              }
              {isContentLoader && <div className="loader-5 center"><span></span></div>}
              {
                selectedContent && selectedContent._id && (
                  <div className='footer-absolute-container'>
                    {
                      sortByContentType == "mainexercise" ? (
                        <div onClick={addDayExerciseContent} className={`member-button-global ${!selectedContent ? "member-button-global-inactive" : ""} btn-center  d-flex`}>
                          <p className="flex-item">Add Content</p>
                        </div>
                      ) : (
                        <div onClick={addExerciseContent} className={`member-button-global ${!selectedContent ? "member-button-global-inactive" : ""} btn-center  d-flex`}>
                          <p className="flex-item">Add Content</p>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>,
            <div className='w-full'>
              {
                isContentFilter == "main-filter" && (
                  <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                    <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                      <div className='flex-item d-flex m-b-20'>
                        <div onClick={() => toggleContentFilter("main-filter")} className="d-flex desktop-modal-close-button m-r-12">
                          <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p className="flex-item modal-header-text">Filter Content</p>
                      </div>
                      <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                        <div className='w-full'>
                        <p className='filter-heading-text m-b-12'>Access Right</p>
                        <div className="w-full d-flex m-b-8">
                            <div onClick={handleAccessRight.bind(this, "")} className='d-flex w-half p-r-12'>
                                <input type="radio" name="access-right" checked={!sortByAccessRight} className='flex-item cursor-pointer m-r-6' />
                                <p className='filter-type-text'>All</p>
                            </div>
                            <div onClick={handleAccessRight.bind(this, "private")} className='d-flex w-half'>
                                <input type="radio" name="access-right" checked={sortByAccessRight == "private"} className='flex-item cursor-pointer m-r-6' />
                                <p className='filter-type-text'>Private</p>
                            </div>
                        </div>
                        <div onClick={handleAccessRight.bind(this, "public")} className='d-flex w-full m-b-20 gym-filter-type'>
                            <input type="radio" name="access-right" checked={sortByAccessRight == "public"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text'>Public</p>
                        </div>


                          <p className='filter-heading-text m-b-12 m-t-20'>Content Role</p>
                          <div className="w-full d-flex m-b-8">
                            <div onClick={handleContentRole.bind(this, "All")} className='d-flex w-half p-r-12'>
                              <input type="radio" name="content-role" checked={ContentRole == "All"} className='flex-item cursor-pointer m-r-6' />
                              <p className='filter-type-text'>All</p>
                            </div>
                            <div onClick={handleContentRole.bind(this, "gym")} className='d-flex w-half gym-filter-type'>
                              <input type="radio" name="content-role" checked={ContentRole == "gym"} className='flex-item cursor-pointer m-r-6' />
                              <p className='filter-type-text'>Gym Content</p>
                            </div>
                          </div>

                          <div className="w-full d-flex m-b-8">
                            <div onClick={handleContentRole.bind(this, "my")} className='d-flex w-half p-r-12'>
                              <input type="radio" name="content-role" checked={ContentRole == "my"} className='flex-item cursor-pointer m-r-6' />
                              <p className='filter-type-text'>My Content</p>
                            </div>
                            <div onClick={handleContentRole.bind(this, "branch")} className='d-flex w-half p-r-12'>
                              <input type="radio" name="content-role" checked={ContentRole == "branch"} className='flex-item cursor-pointer m-r-6' />
                              <p className='filter-type-text'>Branch Content</p>
                            </div>
                          </div>
                          <div onClick={handleContentRole.bind(this, "instafit")} className='d-flex w-half'>
                            <input type="radio" name="content-role" checked={ContentRole == "instafit"} className='flex-item cursor-pointer m-r-6' />
                            <p className='filter-type-text'>Workout Plus Content</p>
                          </div>

                          {
                            selectedGym && [
                              <div className='d-flex'>
                                <div className='d-flex m-t-20'>
                                  <p className='filter-heading-text m-r-12 flex-item'>Selected Gym</p>
                                  <svg onClick={toggleContentFilter.bind(this, "gym")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                  </svg>
                                  <span className="m-l-4 m-r-4 flex-item"></span>
                                  <svg role={`button`} onClick={handleClearGym} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
                              </div>,
                              <div className="d-flex w-full m-t-8">
                                {
                                  selectedGym.logoFileID ? (
                                    <img className="flex-item m-r-8 branch-gym-logo" style={{ width: 40, height: 40 }} src={`${client.config.API_URL}${client.config.prefixStream}/media/file/${selectedGym.logoFileID}`} />
                                  ) : (
                                    <div className="d-flex flex-item m-r-8 branch-gym-logo" style={{ background: selectedGym.logoPlaceholderColor ? selectedGym.logoPlaceholderColor : "#5d883c" }}>
                                      <p className="flex-item" style={{ margin: '0 auto', color: '#ffffff' }}>{`${selectedGym.name}`.trim()[0]}</p>
                                    </div>
                                  )
                                }
                                <div className="flex-item">
                                  <p className="branch-gym-name">{selectedGym.name}</p>
                                  <p className="branch-gym-email">{selectedGym.email}</p>
                                </div>
                              </div>
                            ]
                          }

                          {
                            (selectedGym && branchIDs.length == 0) && [
                              <div onClick={toggleContentFilter.bind(this, "branch")} className='member-button-global btn-center d-flex m-t-16' style={{ width: "46%" }}>
                                <p className='flex-item'>Select Branch</p>
                              </div>
                            ]
                          }

                          {
                            branchIDs.length > 0 && [
                              <div className='d-flex'>
                                <div className='d-flex m-t-20'>
                                  <p className='filter-heading-text m-r-12 flex-item'>Selected Branch</p>
                                  <svg onClick={toggleContentFilter.bind(this, "branch")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                  </svg>
                                  <span className="m-l-4 m-r-4 flex-item"></span>
                                  <svg role={`button`} onClick={handleClearBranch} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
                              </div>,
                              <div className="w-full m-t-8">
                                <p className="branch-gym-name">{`${branchIDs.length} Branch(s) Selected`}</p>
                              </div>
                            ]
                          }

                          {
                            (sortExerciseTypeIDs.length > 0) && [
                              <div className='d-flex'>
                                <div className='d-flex m-t-20 m-b-8'>
                                  <p className='filter-heading-text m-r-12 flex-item'>Exercise Type</p>
                                  <svg onClick={toggleContentFilter.bind(this, "exercise-type")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                  </svg>
                                  <span className="m-l-4 m-r-4 flex-item"></span>
                                  <svg onClick={clearExerciseTypes} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
                              </div>,
                              <p className="flex-item">{`${sortExerciseTypeIDs.length} Exercise Type(s) Selected`}</p>
                            ]
                          }


                          {
                            (sortTargetMuscleIDs.length > 0) && [
                              <div className='d-flex'>
                                <div className='d-flex m-t-20 m-b-8'>
                                  <p className='filter-heading-text m-r-12 flex-item'>Muscle Type</p>
                                  <svg onClick={toggleContentFilter.bind(this, "muscle-type")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                  </svg>
                                  <span className="m-l-4 m-r-4 flex-item"></span>
                                  <svg onClick={clearTargetMuscles} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
                              </div>,
                              <p className="flex-item">{`${sortTargetMuscleIDs.length} Muscle Type(s) Selected`}</p>
                            ]
                          }

                          {
                            sortExerciseLevelIDs.length > 0 && [
                              <div className='d-flex'>
                                <div className='d-flex m-t-20 m-b-8'>
                                  <p className='filter-heading-text m-r-12 flex-item'>Exercise Level</p>
                                  <svg onClick={toggleContentFilter.bind(this, "exercise-level")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                  </svg>
                                  <span className="m-l-4 m-r-4 flex-item"></span>
                                  <svg onClick={clearExerciseLevels} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
                              </div>,
                              <p className="flex-item">{`${sortExerciseLevelIDs.length} Exercise Level Selected`}</p>
                            ]
                          }

                          <div className="w-full m-t-20 d-flex-wrap">
                            {
                              ((ContentRole == "gym" || ContentRole == "branch") && !selectedGym) && <div onClick={toggleContentFilter.bind(this, "gym")} className='member-button-global btn-center d-flex' style={{ width: "46%", margin: "2%" }}>
                                <p className='flex-item'>Add Gym</p>
                              </div>
                            }

                            {!sortExerciseTypeIDs.length && <div onClick={toggleContentFilter.bind(this, "exercise-type")} className='member-button-global btn-center d-flex' style={{ width: "46%", margin: "2%" }}>
                              <p className='flex-item'>Exercise Type</p>
                            </div>}

                            {!sortTargetMuscleIDs.length && <div onClick={toggleContentFilter.bind(this, "muscle-type")} className='member-button-global btn-center w-half d-flex' style={{ width: "46%", margin: "2%" }}>
                              <p className='flex-item'>Muscle Type</p>
                            </div>}

                            {!sortExerciseLevelIDs.length && <div onClick={toggleContentFilter.bind(this, "exercise-level")} className='member-button-global btn-center d-flex' style={{ width: "46%", margin: "2%" }}>
                              <p className='flex-item'>Exercise Level</p>
                            </div>}

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                )
              }

              {
                isContentFilter == "exercise-type" && (
                  <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                    <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                      <div className='flex-item d-flex m-b-20'>
                        <div onClick={() => toggleContentFilter("exercise-type")} className="d-flex desktop-modal-close-button m-r-12">
                          <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p className="flex-item modal-header-text">Filter Content</p>
                      </div>
                      <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                        <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                          <p className="flex-item modal-header-text">Exercise Type</p>

                        </div>
                        <div className='search-gym-modal-scroll'>
                          <div className="d-flex-wrap w-full m-t-12">
                            {
                              exerciseTypes.map(data => {
                                return (
                                  <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                    <p className='flex-item'>{data.name}</p>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                        <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                          <div className="flex-item d-flex">
                            <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                              <p className='flex-item'>Cancel</p>
                            </div>
                            {
                              tempIDs.length > 0 && <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                <p className='flex-item'>Add</p>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

              {
                isContentFilter == "muscle-type" && (
                  <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                    <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                      <div className='flex-item d-flex m-b-20'>
                        <div onClick={() => toggleContentFilter("muscle-type")} className="d-flex desktop-modal-close-button m-r-12">
                          <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p className="flex-item modal-header-text">Filter Content</p>
                      </div>
                      <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                        <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                          <p className="flex-item modal-header-text">Muscle Type</p>

                        </div>
                        <div className='search-gym-modal-scroll'>
                          <div className="d-flex-wrap w-full m-t-12">
                            {
                              targetMuscles.map(data => {
                                return (
                                  <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                    <p className='flex-item'>{data.name}</p>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                        <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                          <div className="flex-item d-flex">
                            <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                              <p className='flex-item'>Cancel</p>
                            </div>
                            {
                              tempIDs.length > 0 &&
                              <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                <p className='flex-item'>Add</p>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

              {
                isContentFilter == "exercise-level" && (
                  <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                    <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                      <div className='flex-item d-flex m-b-20'>
                        <div onClick={() => toggleContentFilter("exercise-level")} className="d-flex desktop-modal-close-button m-r-12">
                          <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p className="flex-item modal-header-text">Filter Content</p>
                      </div>
                      <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                        <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                          <p className="flex-item modal-header-text">Exercise Level</p>
                        </div>
                        <div className='search-gym-modal-scroll'>
                          <div className="d-flex-wrap w-full m-t-12">
                            {
                              exerciseLevels.map(data => {
                                return (
                                  <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                    <p className='flex-item'>{data.name}</p>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                        <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                          <div className="flex-item d-flex">
                            <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                              <p className='flex-item'>Cancel</p>
                            </div>
                            {
                              tempIDs.length > 0 &&
                              <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                <p className='flex-item'>Add</p>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

              {
                isContentFilter == "branch" && (
                  <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                    <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                      <div className='flex-item d-flex m-b-20'>
                        <div onClick={() => toggleContentFilter("branch")} className="d-flex desktop-modal-close-button m-r-12">
                          <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p className="flex-item modal-header-text">Filter Content</p>
                      </div>
                      <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                        <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                          <p className="flex-item modal-header-text">Select Branch</p>
                          <div id="search-container-gym" className='global-search-box flex-item' style={{ background: "#f5f5f5", width: "50%" }}>
                            <svg id="search-icon-gym" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_1637_1318)">
                                <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                              </g>
                              <defs>
                                <clipPath id="clip0_1637_1318">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <input id="search-branch-input" onChange={_.debounce(handleBranchSearch, 1000)} className='flex-item' type="text" placeholder="Search" style={{ background: "#f5f5f5" }} />
                          </div>
                        </div>
                        <div className='search-gym-modal-scroll' onScroll={handleBranchScroll}>
                          <div className="d-flex-wrap w-full m-t-12">
                            {
                              Branches.map(data => {
                                return (
                                  <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                    <p className='flex-item'>{data.name}</p>
                                  </div>
                                )
                              })
                            }
                          </div>
                          {isBrachSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                        </div>
                        <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                          <div className="flex-item d-flex">
                            <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                              <p className='flex-item'>Cancel</p>
                            </div>
                            {
                              tempIDs.length > 0 &&
                              <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                <p className='flex-item'>Add</p>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
          ]
        }

        {
          isVideoPlayerOpen && (
            <div onClick={toggleVideoPlayer.bind(this, "")} className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
              <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "60%", borderBottomRightRadius: "8px" }}>
                {
                  (displayContent && displayContent.videoList && displayContent.videoList.length > 0) && displayContent.videoList.map(video => (
                    <iframe className="exercise-video-container" src={video.link} />
                  ))
                }

                {
                  (displayContent && displayContent.videoList && displayContent.videoList.length > 1) && (
                    <div className='d-flex space-between m-t-12 m-b-6'>
                      <div className='more-table-item-container p-t-8 p-b-8 p-l-12 p-r-12 d-flex'>
                        <p className='flex-item more-table-item-txt'>1/2</p>
                      </div>
                      <div className='d-flex flex-item'>
                        <div className='global-round-btn d-flex flex-item m-r-12' style={{ boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)" }}>
                          <svg className='flex-item stroke-svg' width="11" height="16" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 1L1 5.33333L5 10" stroke="#6D6D6D" stroke-linecap="round" />
                          </svg>
                        </div>
                        <div className='global-round-btn d-flex flex-item' style={{ boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)" }}>
                          <svg className='flex-item stroke-svg' width="11" height="16" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 10L6 5.66667L1 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  (displayContent && displayContent.videoList && displayContent.videoList.length > 0) && displayContent.videoList.map(video => (
                    <div className='w-full m-t-12' style={{ textAlign: "left", justifyContent: "left" }}>
                      <p className='fs-16'>{video.title}</p>
                    </div>
                  ))
                }
              </div>
            </div>
          )
        }
        </div>
      </div>
    </div>
  )
}

export default ExecutePlanner;